// Static UI string dictionary. Domain entities (tabs, sections, metrics,
// branches) carry their own name_ar / name_en from the backend and are
// rendered via the `tn()` helper in I18nContext.
import { STK_COUNT } from "./components/stock-count/i18n.count";
import { STK_ADMIN } from "./components/stock-count/i18n.admin";
import { DK_STRINGS } from "./components/daily-count/i18n.dk";
import { AI_STRINGS } from "./components/ai-analysis/i18n.ai";
import { MAINT_STRINGS } from "./components/maintenance/i18n.maint";

export const translations = {
    ar: {
        app_name: "منصة العمليات",
        app_short: "العمليات",
        company: "مطاعم الشلال",

        login_title: "تسجيل الدخول",
        login_subtitle: "ادخل بيانات حسابك للوصول إلى منصة العمليات",
        login_identifier: "البريد الإلكتروني أو رقم الهوية",
        login_identifier_ph: "name@shallal.sa / 10أرقام",
        login_password: "كلمة المرور",
        login_submit: "دخول",
        login_submitting: "جارٍ الدخول...",
        login_error: "بيانات الدخول غير صحيحة",

        nav_administration: "الإدارة",
        nav_users: "المستخدمون",
        nav_branches: "الفروع",
        coming_soon: "قريباً",
        coming_soon_tip: "هذا التبويب قيد التطوير وسيتوفر لاحقاً",

        logout: "تسجيل الخروج",
        role_super_admin: "مدير النظام",
        role_user: "مستخدم",
        role_inspector: "مفتش جودة",
        role_branch_manager: "مدير فرع",
        role_quality_manager: "مدير الجودة",
        role_qc_supervisor: "مشرف الجودة",
        role_ops_manager: "مدير العمليات",
        role_warehouse_manager: "مدير المستودع",
        role_kitchen_manager: "مدير المطبخ",
        role_maintenance_manager: "مدير الصيانة",
        role_call_center_manager: "مدير مركز الاتصال",
        role_complaints_manager: "مدير الشكاوى",
        role_it_admin: "مسؤول تقنية المعلومات",
        perm_ops_manager_note: "مدير العمليات لديه صلاحية قراءة وكتابة على جميع الوحدات (المبيعات، المالية، الجودة، وكل الوحدات القادمة). لا يدير المستخدمين ولا البنية التحتية (الفروع/النسخ الاحتياطي/الاستيراد).",
        perm_warehouse_manager_note: "مدير المستودع مقيّد بوحدة المستودعات فقط. لا وصول للمبيعات أو المالية أو الجودة.",
        perm_kitchen_manager_note: "مدير المطبخ مقيّد بوحدة المطبخ والإنتاج فقط. لا وصول للمبيعات أو المالية أو الجودة.",
        perm_maintenance_manager_note: "مدير الصيانة مقيّد بوحدة الصيانة فقط. لا وصول للمبيعات أو المالية أو الجودة.",
        perm_call_center_manager_note: "مدير مركز الاتصال مقيّد بوحدة مركز الاتصال فقط. لا وصول للمبيعات أو المالية أو الجودة.",
        perm_complaints_manager_note: "مدير الشكاوى مقيّد بوحدة الشكاوى فقط — وهي منفصلة تماماً عن جودة التفتيش. لا وصول لبيانات الجودة أو المبيعات أو المالية.",
        perm_it_admin_note: "مسؤول تقنية المعلومات دور بنية تحتية: يرى حالة الاستيراد والنسخ الاحتياطي وسجلات المزامنة فقط. لا يرى أي أرقام مبيعات أو بيانات مالية إطلاقاً، ولا يدير المستخدمين.",
        role_cctv_monitor: "مراقب كاميرات",
        role_cctv_manager: "مدير المراقبة",
        perm_cctv_monitor_note: "مراقب الكاميرات ينشئ ويحرّر بلاغاته فقط ويعيد إرسال المرفوض. يرى بلاغاته فقط، ولا يمكنه الإحالة لمدير العمليات.",
        perm_cctv_manager_note: "مدير المراقبة يرى جميع بلاغات المراقبين، وهو الوحيد الذي يُحيل البلاغ لمدير العمليات، ويمكنه إعادته للمراقب مع ذكر السبب. لا يعتمد البلاغات.",
        cctv_title: "مراقبة الكاميرات",
        cctv_subtitle: "إدارة ملاحظات مراقبة الكاميرات وسلسلة الاعتماد الداخلية",
        cctv_new_finding: "بلاغ جديد",
        cctv_no_findings: "لا توجد بلاغات",
        cctv_no_findings_hint: "لم يتم إنشاء أي بلاغ بعد بالمعايير المحددة.",
        cctv_filter_branch: "الفرع",
        cctv_filter_category: "التصنيف",
        cctv_filter_status: "الحالة",
        cctv_filter_date: "التاريخ",
        cctv_all: "الكل",
        cctv_col_branch: "الفرع",
        cctv_col_incident: "وقت الحادثة",
        cctv_col_category: "التصنيف",
        cctv_col_employee: "الموظف",
        cctv_col_status: "الحالة",
        cctv_col_evidence: "الأدلة",
        cctv_col_updated: "آخر تحديث",
        cctv_status_draft: "مسودة",
        cctv_status_submitted: "مُرسل",
        cctv_status_with_ops: "لدى العمليات",
        cctv_status_ops_approved: "معتمد",
        cctv_status_returned_to_monitor: "مُعاد للمراقب",
        cctv_cat_behavior: "سلوك",
        cctv_cat_quality: "جودة",
        cctv_cat_safety: "سلامة",
        cctv_cat_cleanliness: "نظافة",
        cctv_cat_theft: "سرقة",
        cctv_cat_other: "أخرى",
        cctv_f_branch: "الفرع",
        cctv_f_date: "تاريخ الحادثة",
        cctv_f_day: "اليوم",
        cctv_f_time: "الوقت",
        cctv_f_category: "التصنيف",
        cctv_f_category_other: "وصف التصنيف",
        cctv_f_description: "الوصف",
        cctv_f_employee: "الموظف (اختياري)",
        cctv_f_category_other_ph: "اكتب التصنيف",
        cctv_f_description_ph: "اشرح ما لوحظ على الكاميرا",
        cctv_emp_loading: "جارٍ تحميل الموظفين…",
        cctv_emp_none: "بدون موظف",
        cctv_emp_unmapped: "الفرع غير مربوط بالموارد البشرية",
        cctv_emp_unconfigured: "تكامل الموارد البشرية غير مُهيأ",
        cctv_emp_unreachable: "تعذّر الوصول للموارد البشرية",
        cctv_emp_pick: "اختر موظفاً",
        cctv_employee_id_note: "يجب اختيار الموظف من القائمة",
        cctv_evidence: "الأدلة",
        cctv_evidence_hint: "صورة و/أو فيديو",
        cctv_add_evidence: "إضافة دليل",
        cctv_uploading: "جارٍ الرفع…",
        cctv_upload_failed: "فشل الرفع",
        cctv_no_evidence: "لا توجد أدلة",
        cctv_photo: "صورة",
        cctv_video: "فيديو",
        cctv_delete_evidence: "حذف",
        cctv_evidence_required_dispatch: "لا يمكن الإحالة للعمليات بدون دليل واحد على الأقل",
        cctv_max_note: "الفيديو حتى 200 ميجابايت، الصورة حتى 15 ميجابايت",
        cctv_hr_clip_too_big: "هذا المقطع أكبر من {mb} ميجابايت، ومنصّة الموارد البشرية لا تستطيع تشغيله — ستظهر المخالفة عندهم دون إمكانية المشاهدة. الأفضل رفع مقتطف أقصر حول الحادثة (المقطع الكامل يبقى محفوظاً هنا).",
        cctv_hr_not_playable: "لا يُشغَّل في الموارد البشرية",
        cctv_upload_note_timeout: "يتم رفع الملفات على دفعات (8 ميجابايت) لتفادي انقطاع المتصفح",
        cctv_save_first: "احفظ البلاغ أولاً لإضافة الأدلة",
        cctv_save_draft: "حفظ كمسودة",
        cctv_saved: "تم الحفظ",
        cctv_submit: "إرسال",
        cctv_action_done: "تم",
        cctv_edit_btn: "تعديل",
        cctv_delete_btn: "حذف البلاغ",
        cctv_delete_confirm_title: "حذف البلاغ؟",
        cctv_delete_confirm_desc: "سيتم حذف البلاغ وجميع الأدلة المرفقة نهائياً. لا يمكن التراجع عن هذا الإجراء.",
        cctv_delete_ok: "حذف نهائي",
        cctv_deleted: "تم حذف البلاغ",
        cctv_dispatch: "إحالة للعمليات",
        cctv_approve: "اعتماد",
        cctv_reject: "إرجاع للمراقب",
        cctv_reject_reason: "سبب الإرجاع",
        cctv_reject_reason_ph: "اذكر سبب الإرجاع (مطلوب)",
        cctv_history: "سجل الإجراءات",
        cctv_by: "بواسطة",
        cctv_reason: "السبب",
        cctv_ev_create: "إنشاء",
        cctv_ev_submit: "إرسال",
        cctv_ev_dispatch_to_ops: "إحالة للعمليات",
        cctv_ev_approve: "اعتماد",
        cctv_ev_reject: "إرجاع",
        cctv_ev_escalate_to_hr: "تصعيد للموارد البشرية",
        cctv_ev_severity_change: "تغيير مستوى الخطورة",
        cctv_ev_branch_change: "نقل إلى فرع آخر",
        cctv_f_severity: "مستوى الخطورة",
        cctv_filter_severity: "الخطورة",
        cctv_approve_severity: "خطورة الاعتماد",
        cctv_severity_hint: "يقترح المراقب الخطورة عند الإنشاء؛ يمكن لمدير العمليات تعديلها عند الاعتماد",
        cctv_sev_low: "منخفضة",
        cctv_sev_medium: "متوسطة",
        cctv_sev_high: "عالية",
        cctv_sev_critical: "حرجة",
        cctv_hr_push_title: "الموارد البشرية",
        cctv_hr_push_queued: "قيد الإرسال للموارد البشرية",
        cctv_hr_push_sent: "أُرسل للموارد البشرية",
        cctv_hr_push_failed: "فشل الإرسال للموارد البشرية",
        cctv_hr_push_none: "لا يوجد موظف — لم يُصعّد للموارد البشرية",
        cctv_view: "عرض",
        cctv_edit: "تعديل",
        cctv_last_reason: "سبب الإرجاع",
        cctv_detail: "تفاصيل البلاغ",
        cctv_description_required: "الوصف مطلوب",
        cctv_reason_required: "سبب الإرجاع مطلوب",
        ops_tile_cctv: "المراقبة",
        nav_infrastructure: "البنية التحتية",
        nav_ingest_status: "حالة الاستيراد",
        sys_ingest_title: "حالة الاستيراد وصحة النظام",
        sys_ingest_subtitle: "مصادر الاستيراد الخارجية وسجل الأحداث الداخلي وكتالوج المؤشرات",
        sys_sources_title: "مصادر الاستيراد",
        sys_sources_desc: "آخر حالة استيراد لكل مصدر خارجي (نقاط البيع / الأرباح والخسائر / بِتفِل)",
        sys_col_source: "المصدر",
        sys_col_configured: "الإعداد",
        sys_col_status: "الحالة",
        sys_col_last_run: "آخر تشغيل",
        sys_col_runs: "ناجح / فاشل",
        sys_col_error: "آخر خطأ",
        sys_configured: "مُهيّأ",
        sys_not_configured: "غير مُهيّأ",
        sys_status_ok: "ناجح",
        sys_status_failed: "فشل",
        sys_status_never: "لم يُشغّل",
        sys_events_title: "سجل الأحداث (ناقل التنبيهات)",
        sys_events_desc: "الأحداث المُصدَرة من الوحدات عبر ناقل الأحداث الداخلي",
        sys_events_empty: "لا توجد أحداث بعد",
        sys_event_voided: "ملغى",
        sys_rc_title: "إعادة احتساب الإغلاق المتأخر (تصحيح منتصف الليل)",
        sys_rc_desc: "يعيد احتساب أوقات الإغلاق المخزّنة بالقاعدة المصحّحة. المعاينة لا تكتب شيئاً.",
        sys_rc_preview: "معاينة",
        sys_rc_apply: "تطبيق",
        sys_rc_scanned: "سجلات الإغلاق",
        sys_rc_changed: "ستتغيّر",
        sys_rc_late_on_time: "متأخر ← في الموعد",
        sys_rc_late_early: "متأخر ← إغلاق مبكر",
        sys_rc_events: "تنبيهات ستُعلَّم ملغاة",
        sys_rc_over_6h: "أكثر من 6 ساعات عن الموعد (راجِعها مع الفرع)",
        sys_rc_report: "التقرير",
        sys_rc_last: "آخر تطبيق",
        sys_rc_last_counts: "أُعيد احتساب {n} سجل، وعُلِّم {m} تنبيه كملغى",
        sys_rc_last_none: "لم يُطبَّق أي احتساب بعد.",
        sys_rc_nothing: "لا يوجد ما يُطبَّق — السجلات محدّثة.",
        sys_rc_confirm_title: "تطبيق إعادة الاحتساب؟",
        sys_rc_confirm_desc: "سيُعاد احتساب {n} سجل إغلاق وتُعلَّم {m} تنبيهات كملغاة. تُحفظ القيم القديمة في كل سجل، ولا يُحذف أي تنبيه.",
        sys_rc_applied: "تم التطبيق: أُعيد احتساب {n} سجل، وعُلِّم {m} تنبيه كملغى.",
        sys_col_event: "الحدث",
        sys_col_payload: "البيانات",
        sys_col_time: "الوقت",
        sys_test_emit: "إصدار حدث تجريبي",
        sys_emit_success: "تم إصدار الحدث التجريبي",
        sys_test_emit_confirm: "سيُضاف حدث تجريبي باسم system.test_emit إلى سجل الأحداث ويُسجَّل في سجل التدقيق. لا يُرسل أي تنبيه أو إشعار.",
        sys_metrics_title: "كتالوج المؤشرات",
        sys_metrics_desc: "المؤشرات التشغيلية التي تحسبها خدمة المؤشرات الموحّدة",
        budget_tab: "الميزانية مقابل الفعلي",
        budget_title: "الميزانية مقابل الفعلي",
        budget_subtitle: "مقارنة أهداف المبيعات الشهرية لكل فرع بالإيرادات الفعلية",
        budget_import_targets: "استيراد الأهداف",
        budget_import_title: "استيراد أهداف المبيعات",
        budget_import_desc: "حمّل ملف CSV بالأعمدة: الفرع، الشهر، الهدف",
        budget_csv_format: "تنسيق الملف (CSV):",
        budget_csv_hint: "الفرع = اسم الفرع بالعربية · الشهر = YYYY-MM · الهدف = رقم بالريال (> 0). يُطابق كل فرع بالمعرّف عبر الاسم، ولا يُخزَّن بالاسم.",
        budget_choose_csv: "اختر ملف CSV",
        budget_compared_against: "المقارنة تتم مقابل:",
        budget_revenue_gross: "الإيرادات (شامل الضريبة)",
        budget_month_open: "الشهر لم يُغلق بعد",
        budget_col_branch: "الفرع",
        budget_col_target: "الهدف",
        budget_col_actual: "الفعلي (الإيرادات)",
        budget_col_variance: "الفرق (ر.س)",
        budget_col_variance_pct: "الفرق %",
        budget_col_status: "الحالة",
        budget_col_month: "الشهر",
        budget_no_target: "لا يوجد هدف",
        budget_no_data: "لا توجد بيانات",
        budget_rag_green: "ضمن الهدف",
        budget_rag_amber: "قريب",
        budget_rag_red: "دون الهدف",
        budget_company_total: "إجمالي الشركة",
        budget_coverage_fmt: "قابل للمقارنة: {comparable} · لديها هدف: {with_target} · إجمالي الفروع: {total}",
        budget_set_target: "تعيين هدف",
        budget_edit_target: "تعديل الهدف",
        budget_target_amount: "قيمة الهدف",
        budget_clear_target: "حذف الهدف",
        budget_target_invalid: "يجب أن يكون الهدف رقماً أكبر من صفر",
        budget_target_saved: "تم حفظ الهدف",
        budget_target_cleared: "تم حذف الهدف",
        budget_imported: "مستورد",
        budget_updated: "محدَّث",
        budget_failed: "فشل",
        budget_failed_rows_title: "صفوف مرفوضة",
        budget_all_rows_ok: "تمت معالجة جميع الصفوف بنجاح",
        budget_reason: "السبب",
        nav_dashboard: "لوحة العمليات",
        ops_dashboard_title: "لوحة مدير العمليات",
        ops_dashboard_subtitle: "نظرة حية على جميع الفروع في شاشة واحدة",
        ops_as_of: "حتى تاريخ",
        ops_last_updated: "آخر تحديث",
        ops_hr_offline: "بيانات الموظفين غير متصلة (HR غير مُهيّأ)",
        ops_tile_sales_today: "مبيعات اليوم",
        ops_tile_sales_mtd: "مبيعات الشهر حتى تاريخه",
        ops_tile_qc_open: "مخالفات الجودة المفتوحة",
        ops_tile_workforce: "القوى العاملة",
        ops_drill_subtitle: "ملخص الفرع",
        nav_checkin: "فتح/إغلاق الفرع",
        ops_tile_checkin: "الفتح/الإغلاق",
        // ops dashboard module columns (2026-10-31)
        ops_tile_error: "تعذر تحميل هذا العمود الآن",
        ops_tile_hidden: "لهذا الفرع مدير عمليات خاص — بياناته في الجودة والمراقبة لديه",
        ops_cctv_with_ops: "لدى العمليات",
        ops_cctv_high: "عالية/حرجة",
        ops_cctv_at_manager: "بانتظار مدير الكاميرات",
        ops_cctv_returned: "معادة للمراقب",
        ops_cc_orders: "طلب",
        ops_cc_mtd: "الشهر",
        ops_cc_paid_note: "طلبات مركز الاتصال المدفوعة: الإيراد وعدد الطلبات",
        ops_cc_no_pos: "الفرع غير مربوط بنقاط البيع",
        ops_cc_no_data: "لم يغطِّ سحب مركز الاتصال هذا اليوم بعد",
        ops_cc_mtd_partial: "سحب مركز الاتصال لا يغطي الشهر كاملاً بعد",
        ops_stock_month: "الجرد الشهري",
        ops_stock_not_started: "لم يبدأ",
        ops_stock_draft: "قيد الجرد",
        ops_stock_submitted: "أُرسل",
        ops_stock_approved: "معتمد",
        ops_stock_late: "متأخر",
        ops_stock_value_title: "قيمة الجرد المرسل أو المعتمد",
        ops_stock_missing_cost: "أصناف بلا تكلفة",
        ops_stock_missing_cost_title: "أصناف في الجرد ليس لها تكلفة بعد، فالقيمة أقل من الحقيقية",
        ops_stock_daily_title: "الجرد اليومي للأصناف الرئيسية: الأصناف المجرودة أمس",
        ops_stock_daily_yesterday: "اليومي أمس",
        ops_stock_flags_mtd: "أصناف تجاوزت حد الفرق من بداية الشهر حتى أمس",
        ops_stock_flags_unevaluated: "لم تُقيَّم الفروقات (لا مبيعات مسحوبة أو لا وصفات)",
        ops_stock_daily_value: "فروقات الشهر",
        ops_stock_daily_value_title: "صافي قيمة فروقات الجرد اليومي من بداية الشهر حتى أمس (موجب = نقص)",
        ops_stock_not_counted: "لا يُجرد",
        ops_stock_not_counted_reason: "لا يوجد موقع جرد لهذا الفرع",
        ops_maint_open_wo: "أوامر العمل المفتوحة الآن",
        ops_maint_overdue: "متأخر",
        ops_maint_awaiting_branch: "بانتظار تأكيد الفرع",
        ops_maint_suggested: "مقترح",
        ops_maint_suggested_reason: "ربط موقع الصيانة بهذا الفرع مقترح ولم يؤكده المشرف بعد",
        ops_maint_unmapped: "لا يوجد موقع صيانة مربوط بهذا الفرع",
        ops_maint_unlinked: "غير مربوطة بفرع",
        ops_maint_stale: "آخر مزامنة ناجحة مع نظام الصيانة أقدم من ساعة، أو المزامنة غير مُهيّأة",
        ops_maint_stale_short: "بيانات قديمة",
        ops_maint_not_configured: "مزامنة الصيانة غير مُهيّأة",
        ops_maint_never: "لم تتم أي مزامنة ناجحة مع نظام الصيانة بعد",
        ops_wf_unmapped: "غير مربوط",
        ops_wf_unmapped_reason: "لم يُحدَّد معرّف الفرع في نظام الموارد البشرية (hr_branch_id)",
        ops_wf_unreachable: "تعذر الوصول إلى نظام الموارد البشرية لهذا الفرع",
        ops_wf_no_data: "لا توجد بيانات موظفين",
        ops_wf_partial_reason: "بعض الفروع غير مربوطة بالموارد البشرية أو لم يرد نظامها، فالمجموع ناقص",
        checkin_title: "تسجيل فتح وإغلاق الفرع",
        checkin_subtitle: "سجّل وقت فتح وإغلاق الفرع وتابع الالتزام بمواعيد التشغيل",
        checkin_schedule_settings: "مواعيد التشغيل",
        checkin_schedule_desc: "حدّد مواعيد الفتح والإغلاق لكل يوم من أيام الأسبوع. يمكن تعليم اليوم كإجازة (مغلق).",
        checkin_today: "اليوم",
        checkin_open: "الفتح",
        checkin_close: "الإغلاق",
        checkin_scheduled: "المجدول",
        checkin_schedule_today: "مواعيد اليوم",
        checkin_default_hours: "افتراضي",
        checkin_closed_today: "مغلق اليوم",
        checkin_closed_short: "مغلق",
        checkin_closed_col: "مغلق",
        checkin_late: "متأخر",
        checkin_min: "دقيقة",
        checkin_on_time: "في الموعد",
        checkin_early_close: "إغلاق مبكر",
        checkin_early_close_note: "إغلاق مبكر إذا سبق الموعد بأكثر من",
        checkin_not_applicable: "لا ينطبق",
        checkin_partial: "جزئي",
        checkin_manually_adjusted: "معدّل يدوياً",
        checkin_live_stamp: "تسجيل مباشر",
        checkin_adjusted_by: "عُدّل بواسطة",
        checkin_recorded_by: "سُجّل بواسطة",
        checkin_edit: "تعديل",
        checkin_enter_time: "إدخال الوقت",
        checkin_not_recorded: "لم يُسجّل",
        checkin_yesterday: "أمس",
        checkin_prev_close_label: "إغلاق أمس",
        checkin_mtd_label: "منذ بداية الشهر",
        checkin_open_now: "تسجيل الفتح الآن",
        checkin_close_now: "تسجيل الإغلاق الآن",
        checkin_time_invalid: "الوقت يجب أن يكون بصيغة HH:MM",
        checkin_grace_note: "مهلة السماح:",
        checkin_saved: "تم التسجيل",
        checkin_already_recorded: "تم التسجيل مسبقاً — استخدم التعديل لتغيير الوقت",
        checkin_summary_title: "التزام هذا الشهر",
        checkin_summary_desc: "نسبة الالتزام بمواعيد الفتح والإغلاق",
        checkin_open_compliance: "التزام الفتح",
        checkin_close_compliance: "التزام الإغلاق",
        checkin_scheduled_days: "أيام التشغيل",
        checkin_closed_days: "يوم إجازة",
        checkin_not_recorded_count: "غير مُسجّل",
        checkin_open_word: "فتح",
        checkin_summary_note: "الأيام غير المسجّلة وأيام الإجازة مستثناة من نسبة الالتزام.",
        checkin_summary_early_note: "الإغلاق المبكر لا يُحتسب تأخيراً، لكنه لا يُحتسب في الموعد أيضاً.",
        checkin_no_branch: "لا يوجد فرع",
        checkin_no_branch_hint: "لا يوجد فرع متاح لتسجيل الحضور بحسابك.",
        checkin_schedule_saved: "تم حفظ المواعيد",
        checkin_day_mon: "الاثنين",
        checkin_day_tue: "الثلاثاء",
        checkin_day_wed: "الأربعاء",
        checkin_day_thu: "الخميس",
        checkin_day_fri: "الجمعة",
        checkin_day_sat: "السبت",
        checkin_day_sun: "الأحد",
        nav_branch_kpi: "مؤشرات الفروع",
        bkpi_title: "مؤشرات أداء الفرع",
        bkpi_subtitle: "عرض تشغيلي موحّد لكل فرع — كل الأرقام من خدمة المؤشرات، بدون أي إعادة احتساب",
        bkpi_view_single: "فرع واحد",
        bkpi_view_compare: "مقارنة الفروع",
        bkpi_branch: "الفرع",
        bkpi_month: "الشهر",
        bkpi_day: "يوم الإيراد اليومي",
        bkpi_no_data: "لا توجد بيانات",
        bkpi_source: "المصدر",
        bkpi_kpi_monthly_revenue: "الإيراد الشهري (شامل الضريبة)",
        bkpi_kpi_daily_revenue: "الإيراد اليومي",
        bkpi_kpi_net_sales: "صافي المبيعات (بدون ضريبة)",
        bkpi_kpi_vat: "ضريبة القيمة المضافة",
        bkpi_kpi_invoices: "عدد الفواتير",
        bkpi_kpi_orders: "عدد الطلبات",
        bkpi_kpi_aov: "متوسط قيمة الطلب",
        bkpi_kpi_discounts: "الخصومات",
        bkpi_kpi_cancelled: "الفواتير الملغاة",
        bkpi_kpi_modified: "الفواتير المعدّلة",
        bkpi_kpi_returns: "المرتجعات",
        bkpi_note_no_month_data: "لم تُسحب إجماليات هذا الشهر من نقاط البيع بعد",
        bkpi_note_no_daily_data: "لم تُسحب مبيعات هذا اليوم لهذا الفرع بعد",
        bkpi_note_not_in_payload: "غير متوفر في بيانات نقاط البيع",
        bkpi_note_pos_not_carrying_discounts: "القيمة 0 لأن بيانات نقاط البيع لا تُرسِل الخصومات — ليست دلالة على عدم وجود خصومات",
        bkpi_legend_title: "عن هذه الأرقام",
        bkpi_legend_body: "كل الأرقام تأتي من خدمة المؤشرات ومطابقة لتقرير المبيعات (نفس المصدر). لا يتم تلفيق أي رقم؛ الفترة التي لم تصل بياناتها تظهر «—» وليس صفراً. الفواتير الملغاة والمعدّلة والمرتجعات المنفصلة غير متوفرة في بيانات نقاط البيع حالياً.",
        bkpi_no_branch: "لا يوجد فرع",
        bkpi_no_branch_hint: "لا يوجد فرع متاح لعرض المؤشرات بحسابك.",
        bkpi_branch_col: "الفرع",
        branch_manager_branch_label: "الفرع المُعيّن",
        branch_manager_branch_placeholder: "اختر فرعاً…",
        branch_manager_branch_hint: "مدير الفرع يرى ويدير فقط بيانات هذا الفرع في تبويب الجودة. يمكن للمدير تغيير هذا التعيين لاحقاً بأثر فوري.",
        branch_manager_needs_branch: "يجب اختيار فرع لدور مدير الفرع",
        perm_branch_manager_note: "مدير الفرع يصل فقط إلى تبويب الجودة، مقيّد بفرع واحد يحدَّده مدير النظام أعلاه. لا يمكنه بدء جولات جديدة أو حذف الصور، لكنه يستطيع متابعة المخالفات وإغلاقها برفع صورة الحل.",
        language: "English",

        notifications: "الإشعارات",
        notif_qc_submissions_label: "إشعارات البريد الإلكتروني",
        notif_qc_submissions_desc: "تلقّي بريد إلكتروني عند إرسال جولة تفتيش جودة أو عند وجود إجراء مطلوب منك (اعتماد حل مخالفة، طلب صنف…). الإيقاف يمنع كل رسائل البريد ولا يؤثر على إشعارات الجرس داخل النظام.",
        notif_dialog_title: "إعدادات الإشعارات",
        notif_dialog_desc: "اختر ما تريد استلامه عبر البريد الإلكتروني.",
        notif_saved: "تم حفظ الإعدادات",
        notif_settings: "إعدادات الإشعارات",
        notif_inbox_title: "الإشعارات",
        notif_mark_all_read: "تعليم الكل كمقروء",
        notif_empty: "لا توجد إشعارات",
        qc_v_timeline_title: "سجل المعالجة",
        qc_tl_created: "أُنشئت المخالفة",
        qc_tl_started: "بدأت المعالجة",
        qc_tl_submitted: "أُرسل الحل للاعتماد",
        qc_tl_sent_back: "أُعيدت للتعديل",
        qc_tl_approved: "تم الاعتماد والإغلاق",
        qc_tl_closed: "أُغلقت",
        qc_tl_reopened: "أُعيد فتحها",

        sales_title: "المبيعات والأداء",
        sales_subtitle: "لوحة متابعة أداء المبيعات",
        branch_filter: "الفرع",
        all_branches: "جميع الفروع المسموحة",
        no_data: "لا توجد بيانات مستوردة بعد",
        no_data_hint: "ستظهر الأرقام هنا بعد ربط بيانات نقاط البيع",
        metric: "المؤشر",
        value: "القيمة",
        date: "التاريخ",
        month: "الشهر",
        branch: "الفرع",
        item: "الصنف",
        channel: "القناة",
        share: "النسبة",

        users_title: "إدارة المستخدمين",
        users_subtitle: "إضافة وتعديل الحسابات والصلاحيات",
        add_user: "إضافة مستخدم",
        edit_user: "تعديل المستخدم",
        new_user: "مستخدم جديد",
        name: "الاسم",
        email: "البريد الإلكتروني",
        national_id: "رقم الهوية",
        password: "كلمة المرور",
        role: "الدور",
        status: "الحالة",
        last_login: "آخر دخول",
        actions: "إجراءات",
        active: "نشط",
        inactive: "معطل",
        never: "لم يدخل بعد",
        save: "حفظ",
        saving: "جارٍ الحفظ...",
        cancel: "إلغاء",
        edit: "تعديل",
        reset_password: "إعادة تعيين كلمة المرور",
        deactivate: "تعطيل",
        activate: "تفعيل",
        delete: "حذف",
        new_password: "كلمة المرور الجديدة",
        confirm: "تأكيد",
        confirm_delete_user: "حذف هذا المستخدم نهائياً؟ لا يمكن التراجع.",
        password_hint: "6 أحرف على الأقل",
        identifier_hint: "يجب إدخال البريد أو رقم الهوية (أحدهما على الأقل)",

        permissions: "الصلاحيات",
        perm_tabs: "التبويبات",
        perm_branches: "الفروع",
        perm_sections: "أقسام المبيعات",
        perm_metrics: "المؤشرات",
        select_all: "تحديد الكل",
        clear_all: "إلغاء الكل",
        all_branches_grant: "جميع الفروع (بما فيها الجديدة)",
        perm_super_note: "مدير النظام يرى ويدير كل شيء تلقائياً.",
        perm_inspector_note: "مفتش الجودة يصل فقط إلى تبويب الجودة — التفتيش، ولا يرى المبيعات أو المالية أو أي تبويب آخر. لا تحتاج لضبط أي صلاحيات هنا.",
        perm_quality_manager_note: "مدير الجودة يصل إلى كل بيانات الجودة (التفتيش والهدر) في جميع الفروع، ويحرّر الأقسام، ويدير المستخدمين من نوع «مفتش/مدير فرع/مشرف جودة» فقط. لا يملك صلاحية على المبيعات أو المالية.",
        perm_qc_supervisor_note: "مشرف الجودة يرى كل بيانات الجودة في جميع الفروع، يقوم بجولات ويغلق المخالفات، لكنه لا يدير مستخدمين ولا يعدّل الأقسام. لا وصول للمبيعات أو المالية.",
        sales_access: "صلاحيات المبيعات",

        branches_title: "إدارة الفروع",
        branches_subtitle: "إضافة وتعديل الفروع",
        add_branch: "إضافة فرع",
        branch_name_ar: "اسم الفرع (عربي)",
        branch_name_en: "اسم الفرع (إنجليزي)",
        branch_code: "الرمز",
        branch_pos_id: "رقم نقاط البيع",
        branch_pos_id_hint: "(اختياري)",
        branch_pos_id_invalid: "رقم نقاط البيع يجب أن يكون رقمًا موجبًا",
        branch_hr_id: "معرّف فرع الموارد البشرية",
        branch_hr_id_hint: "(لربط قائمة الموظفين)",
        branch_hr_unmapped: "غير مربوط",
        branch_hr_test: "اختبار الموارد البشرية",
        branch_hr_test_employees: "موظف",
        branch_hr_test_zero: "٠ موظف — تحقق من معرّف فرع الموارد البشرية",
        branch_hr_test_unmapped: "لا يوجد معرّف فرع للموارد البشرية",
        branch_hr_test_unconfigured: "الموارد البشرية غير مُهيّأة",
        branch_hr_test_unreachable: "تعذّر الوصول إلى الموارد البشرية",
        branch_hr_test_using: "باستخدام",
        branch_flags: "خصائص",
        branch_finance_only: "مالي فقط",
        branch_finance_only_desc: "فرع مالي فقط لا يظهر في المبيعات وجودة الطعام (فقط في القوائم المالية).",
        branch_finance_only_no_pos: "الفرع المالي فقط لا يجب أن يحمل رقم نقاط بيع",
        branch_hr_id_invalid: "معرّف فرع الموارد البشرية يجب أن يكون بصيغة UUID (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)",
        branch_finance_only_unlinks: "سيُفصل الفرع عن نقاط البيع #{n} عند الحفظ: يتوقف سحبه الليلي وتختفي مبيعاته من عروض الفروع. أوقف «مالي فقط» لاستعادة الرقم.",
        // the branch's own operations manager «مدير العمليات للفرع» (2026-11-01)
        branch_ops_manager: "مدير العمليات للفرع",
        branch_ops_manager_hint: "(اختياري)",
        branch_ops_manager_none: "— مدير العمليات العام —",
        branch_ops_manager_desc: "يتولى مخالفات الجودة واعتماد ملاحظات المراقبة لهذا الفرع وحده، ولا يرى مدير العمليات العام بيانات الفرع في الجودة والمراقبة.",
        branch_ops_manager_saved_failed: "حُفظ الفرع، لكن تعذّر حفظ مدير العمليات للفرع",
        branch_clear_title: "إزالة ربط من الفرع؟",
        branch_clear_save: "احفظ وأزل الربط",
        branch_clear_pos_effect: "يتوقف سحب نقاط البيع الليلي لهذا الفرع وتختفي مبيعاته من عروض الفروع حتى يُعاد إدخال الرقم.",
        branch_clear_hr_effect: "تفرغ قائمة الموظفين في الجودة والكاميرات لهذا الفرع حتى يُعاد إدخال المعرّف.",
        branch_deactivate_effect: "تعطيل الفرع يُخفيه من المبيعات ولوحة العمليات والجودة والهدر والوجبات وتسجيل الحضور، ويوقف سحب نقاط البيع الليلي له. تختفي أرقامه السابقة من العروض حسب الفرع بينما تبقى ضمن إجمالي الشبكة. لا تُحذف أي بيانات، ويمكن إعادة تفعيله في أي وقت.",
        branch_deactivate_type: "اكتب اسم الفرع «{name}» للتأكيد",
        rename: "تعديل",

        no_access_title: "لا توجد صلاحيات",
        no_access_desc: "لم يتم منحك أي تبويب. تواصل مع مدير النظام.",
        forbidden_title: "لا تملك صلاحية الوصول",
        loading: "جارٍ التحميل...",
        search_users: "بحث بالاسم أو البريد...",
        no_users: "لا يوجد مستخدمون",
        of: "من",
        save_success: "تم الحفظ بنجاح",
        action_success: "تم تنفيذ الإجراء",
        error_generic: "حدث خطأ، حاول مجدداً",
        app_error_title: "تعذّر عرض هذه الصفحة",
        app_error_body: "حدث خطأ غير متوقع أثناء العرض. لم تُفقد أي بيانات محفوظة — أعد تحميل الصفحة أو ارجع إلى الصفحة الرئيسية.",
        app_error_reload: "إعادة التحميل",
        app_error_home: "الصفحة الرئيسية",

        import_sales: "استيراد بيانات المبيعات",
        import_desc: "ارفع ملف JSON المعتمد من نظام نقاط البيع. يتم التحديث بشكل تراكمي دون تكرار.",
        choose_file: "اختر ملف JSON",
        selected_file: "الملف المختار",
        upload: "رفع واستيراد",
        uploading: "جارٍ الرفع والمعالجة...",
        import_done: "اكتمل الاستيراد",
        rows_inserted: "صفوف مُضافة",
        rows_updated: "صفوف محدّثة",
        rejected_rows: "صفوف مرفوضة",
        no_rejected: "لا توجد صفوف مرفوضة",
        service_token: "رمز الخدمة (للرفع التلقائي لاحقاً)",
        token_hint: "احفظ هذا الرمز لإرساله في ترويسة X-Ingest-Token عند الرفع الآلي. الرفع اليدوي يستخدمه تلقائياً.",
        copy: "نسخ",
        copied: "تم النسخ",
        invalid_json: "ملف JSON غير صالح",

        reconciliation: "التسوية والمطابقة",
        recon_desc: "مقارنة الإجماليات المخزّنة مع القيم المستهدفة في الملف",
        recon_no_data: "لم يتم استيراد بيانات بعد",
        recon_no_data_hint: "ارفع ملف المبيعات لعرض لوحة المطابقة",
        recon_metric: "البند",
        recon_stored: "المخزّن",
        recon_target: "المستهدف",
        recon_diff: "الفرق",
        recon_status: "الحالة",
        all_matched: "جميع البنود مطابقة",
        mismatch_found: "يوجد عدم تطابق",
        last_import: "آخر استيراد",
        coverage: "التغطية",
        source: "المصدر",

        period: "الفترة",
        period_all_time: "كل الفترة",
        period_custom: "نطاق مخصص",
        period_reset: "إعادة الضبط",
        period_apply: "تطبيق",
        updated_through: "محدّث حتى",
        item_name: "الصنف",
        item_category: "التصنيف",
        qty: "الكمية",
        revenue_col: "الإيراد",
        share_col: "النسبة",
        orders_col: "الطلبات",
        rank_col: "#",
        top_n_items: "أعلى الأصناف مبيعاً",
        reference_total: "الإجمالي المرجعي",
        channel_breakdown: "توزيع قنوات البيع",
        net_only_note: "ملاحظة",
        no_rows_range: "لا توجد بيانات ضمن الفترة المحددة",

        exp_title: "مستكشف المبيعات",
        exp_subtitle: "عرض موحّد — جمّع البيانات حسب اليوم أو الشهر أو الصنف أو الفرع أو القناة",
        exp_group_by: "التجميع حسب",
        exp_gb_day: "اليوم",
        exp_gb_month: "الشهر",
        exp_gb_item: "الصنف",
        exp_gb_branch: "الفرع",
        exp_gb_channel: "القناة",
        exp_channel_breakdown: "تفصيل القنوات",
        exp_chart: "الرسم البياني",
        exp_chart_show: "إظهار الرسم البياني",
        exp_chart_hide: "إخفاء الرسم البياني",
        exp_sum_net: "الإيرادات",
        exp_sum_cash: "النقد",
        exp_sum_card: "الشبكة",
        exp_sum_delivery: "تطبيقات التوصيل",
        exp_sum_invoices: "الفواتير",
        exp_sum_aov: "متوسط قيمة الطلب",
        exp_period_30: "آخر 30 يوم",
        exp_compare_yoy: "مقارنة سنوية",
        exp_compare_metric: "مؤشر المقارنة",
        exp_compare_change: "التغير",
        exp_compare_total: "الإجمالي",
        exp_vs: "مقابل",

        dsr_tab: "التقرير اليومي للفرع",
        dsr_title: "التقرير اليومي للفرع",
        dsr_subtitle: "توزيع المبيعات اليومية للفرع حسب القناة (مباشر بالفرع / كول سنتر / تطبيقات التوصيل) — بديل ملف الإكسل اليومي.",
        dsr_all_branches: "كل الفروع",
        dsr_all_subtitle: "مقارنة أداء جميع الفروع في جدول واحد للشهر المحدد — الإجمالي وتوزيع القنوات والنسب.",
        dsr_col_branch: "الفرع",
        dsr_network_total: "إجمالي الشبكة",
        sc_title: "أداء الفروع",
        sc_subtitle: "قارن إيرادات الفروع لاكتشاف الأداء المنخفض بسرعة — شهري وسنوي.",
        sc_month: "الشهر",
        sc_tab_compare: "مقارنة الفروع",
        sc_tab_trend: "الاتجاه الشهري",
        sc_tab_yoy: "مقارنة سنوية",
        sc_col_revenue: "الإيرادات",
        sc_col_target: "المستهدف",
        sc_attainment: "نسبة التحقيق",
        sc_mom: "مقارنة بالشهر السابق",
        sc_yoy: "مقارنة بالعام السابق",
        sc_vs_prev: "مقابل الشهر السابق",
        sc_vs_last_year: "مقابل العام السابق",
        sc_network_total: "إجمالي الشبكة",
        sc_no_target: "لا يوجد مستهدف",
        sc_no_data: "لا توجد بيانات لهذا الشهر",
        sc_yoy_unavailable_title: "لا تتوفر بيانات العام السابق بعد",
        sc_yoy_unavailable_desc: "استورد بيانات العام السابق لعرض المقارنة السنوية لكل فرع.",
        sc_current_year: "السنة الحالية",
        sc_prior_year: "العام السابق",
        exp_item_gap_title: "تفصيل الأصناف غير متوفر لهذه الفترة",
        exp_channel_gap_title: "توزيع القنوات غير متوفر لهذه الفترة",
        exp_breakdown_gap_hint: "التفصيل متاح من {from} إلى {to}. إجماليات الفترة المختارة مُزامنة، لكن سحب التفاصيل من نقاط البيع لم يصل إلى هذه الفترة بعد — وسّع نطاق سحب تاريخ المبيعات ليشملها.",
        ops_charts_attainment_title: "تحقيق المستهدف حسب الفرع",
        ops_charts_attainment_desc: "الأدنى أداءً أولاً (الشهر حتى تاريخه)",
        ops_charts_movers_title: "أبرز التغيّرات (مقارنة بالشهر السابق)",
        ops_charts_movers_desc: "أكبر ارتفاع وانخفاض في الإيرادات",
        ops_charts_no_data: "لا تتوفر بيانات كافية للرسوم البيانية",
        dsr_branch: "الفرع",
        dsr_month: "الشهر",
        dsr_pick_branch: "اختر فرعاً لعرض التقرير",
        dsr_no_data: "لا توجد بيانات لهذا الفرع في هذا الشهر",
        dsr_no_data_hint: "لن تظهر أرقام إلا بعد مزامنة اليوميات لهذا الفرع.",
        dsr_col_date: "التاريخ",
        dsr_col_total: "الإجمالي",
        dsr_col_walk_in: "مباشر بالفرع",
        dsr_col_cc: "الكول سنتر",
        dsr_col_apps: "تطبيقات التوصيل",
        dsr_col_total_tc: "عدد الطلبات",
        dsr_col_cc_tc: "طلبات الكول سنتر",
        dsr_col_apps_tc: "طلبات التطبيقات",
        dsr_col_avg_ticket: "متوسط قيمة الطلب",
        dsr_row_totals: "الإجمالي الشهري",
        dsr_row_prev: "الشهر السابق",
        dsr_row_delta: "المقارنة (% )",
        dsr_apps_tc_note: "غير متوفر — نظام نقاط البيع لم يرسل بعد بيانات التطبيقات لهذا اليوم.",
        dsr_cc_window_from: "بيانات الكول سنتر متاحة من",
        dsr_cc_window_to: "إلى",
        dsr_cc_no_coverage: "لا توجد بيانات كول سنتر لهذا الفرع بعد.",
        dsr_apps_breakdown: "تفصيل طلبات التطبيقات لهذا اليوم",
        dsr_apps_col_name: "التطبيق",
        dsr_apps_col_net: "الصافي",
        dsr_apps_col_orders: "عدد الطلبات",
        dsr_wk: ["أحد", "اثن", "ثلا", "أرب", "خمي", "جمع", "سبت"],

        qc_ins_title: "الجودة — التفتيش",
        qc_ins_subtitle: "قائمة تدقيق مفتش الجودة — إدارة أقسام التفتيش وبنودها",
        qc_ins_admin_title: "أقسام التفتيش وبنودها",
        qc_ins_admin_desc: "يمكنك إضافة وتعديل وإعادة ترتيب الأقسام، وتحرير بنود التفتيش (بنود المخالفات المحتملة) داخل كل قسم.",
        qc_ins_inspector_placeholder_title: "نموذج التفتيش قيد التطوير",
        qc_ins_inspector_placeholder_hint: "سيتوفر لك هنا نموذج جولة التفتيش خلال المرحلة القادمة. الحساب الحالي يمكنه الوصول إلى هذا التبويب فقط.",
        qc_ins_add_section: "إضافة قسم",
        qc_ins_new_section: "قسم تفتيش جديد",
        qc_ins_edit_section: "تعديل قسم التفتيش",
        qc_ins_section_key: "المفتاح البرمجي",
        qc_ins_section_key_hint: "مفتاح إنجليزي مختصر (a-z0-9_-) — يُستخدم داخلياً ولا يظهر للمفتش.",
        qc_ins_title_ar: "العنوان (عربي)",
        qc_ins_title_en: "العنوان (English)",
        qc_ins_subtitle_ar: "الوصف (عربي)",
        qc_ins_subtitle_en: "الوصف (English)",
        qc_ins_items: "بنود التفتيش",
        qc_ins_items_desc: "كل بند هو نقطة يمكن للمفتش تحديدها كمخالفة. سطر لكل بند.",
        qc_ins_items_count: (n) => `${n} بند`,
        qc_ins_items_placeholder: "اكتب بنداً في كل سطر…",
        qc_ins_active: "نشط",
        qc_ins_inactive: "غير نشط",
        qc_ins_no_sections: "لا توجد أقسام بعد",
        qc_ins_no_sections_hint: "اضغط «إضافة قسم» لإنشاء أول قسم تفتيش.",
        qc_ins_move_up: "نقل لأعلى",
        qc_ins_move_down: "نقل لأسفل",
        qc_ins_toggle: "تفعيل / إلغاء",
        qc_ins_edit: "تعديل",
        qc_ins_delete: "حذف",
        qc_ins_delete_confirm: "حذف قسم التفتيش؟",
        qc_ins_delete_confirm_desc: "لا يمكن التراجع عن هذا الإجراء. سيتم حذف القسم وبنوده نهائياً.",
        qc_ins_saved: "تم الحفظ",
        qc_ins_deleted: "تم الحذف",

        qc_ins_sections_tab: "الأقسام",
        qc_ins_rounds_tab: "جولات التفتيش",

        // ---- Unified Quality Management hub (2026-07-23) ----
        quality_hub_title: "نظام إدارة الجودة",
        quality_hub_subtitle: "لوحة موحّدة لإدارة جودة العمليات — التفتيش، المخالفات، والهدر.",
        quality_hub_nav: "إدارة الجودة",
        quality_hub_tab_dashboard: "لوحة الجودة",
        quality_hub_tab_rounds: "الجولات",
        quality_hub_tab_violations: "المخالفات",
        quality_hub_tab_waste: "الهدر",

        // ---------------- Waste & Staff Meals (الهدر وأكل العمال) ----------------
        wm_title: "الهدر وأكل العمال",
        wm_subtitle: "تسجيل يومي للهدر وأكل العمال لكل فرع",
        wm_tab_waste: "تسجيل الهدر",
        wm_tab_waste_report: "تقرير الهدر",
        wm_tab_meals: "أكل العمال",
        wm_tab_meals_report: "تقرير أكل العمال",
        wm_tab_coverage: "متابعة اليوم",
        wm_tab_admin: "إدارة الأصناف",
        wm_admin_items: "الأصناف",
        wm_admin_units: "الوحدات",
        wm_admin_reasons: "أسباب الهدر",
        wm_admin_requests: "طلبات الأصناف",
        wm_admin_policy: "السياسة",
        wm_admin_search: "بحث بالاسم أو الرقم",
        wm_admin_usage_all: "الكل",
        wm_admin_usage_waste: "هدر",
        wm_admin_usage_meals: "أكل عمال",
        wm_admin_usage_both: "كلاهما",
        wm_admin_only_active: "الفعّالة فقط",
        wm_admin_count: "فعّال",
        wm_admin_item_add: "إضافة صنف",
        wm_admin_item_edit: "تعديل الصنف",
        wm_admin_items_empty: "لا توجد أصناف مطابقة",
        wm_admin_code: "الرقم",
        wm_admin_name_ar: "الاسم بالعربي",
        wm_admin_name_en: "الاسم بالإنجليزي",
        wm_admin_usage: "نوع الاستخدام",
        wm_admin_unit: "الوحدة",
        wm_admin_state: "الحالة",
        wm_admin_active: "فعال",
        wm_admin_inactive: "غير فعال",
        wm_admin_category: "التصنيف",
        wm_admin_name_required: "اسم الصنف بالعربي إجباري",
        wm_admin_unit_locked: "لا يمكن تغيير الوحدة بعد تسجيل عمليات على الصنف. أوقف الصنف وأنشئ بديلاً بالوحدة الصحيحة.",
        wm_admin_inactive_hint: "إيقاف الصنف يخفيه من شاشات التسجيل الجديدة فقط، ويبقى ظاهراً في تقارير الأشهر السابقة.",
        wm_admin_unit_key: "المفتاح",
        wm_admin_allows_decimal: "يسمح بالكسور",
        wm_admin_unit_add: "إضافة وحدة",
        wm_admin_unit_required: "المفتاح والاسم بالعربي إجباريان",
        wm_admin_reason_key: "المفتاح",
        wm_admin_reason_add: "إضافة سبب",
        wm_admin_reason_required: "سبب الهدر إجباري",
        wm_admin_reason_required_hint: "عند التشغيل لن يُقبل تسجيل هدر بدون سبب",
        wm_admin_backdate_days: "أيام التسجيل للخلف",
        wm_admin_edit_days: "أيام التعديل",
        wm_admin_cutoff_hour: "ساعة إغلاق اليوم",
        wm_admin_warn_quantity: "حد التنبيه للكمية",
        wm_admin_max_quantity: "الحد الأقصى للكمية",
        wm_admin_request_open: "قيد الانتظار",
        wm_admin_request_resolved: "معتمد",
        wm_admin_request_rejected: "مرفوض",
        wm_admin_request_all: "الكل",
        wm_admin_requests_empty: "لا توجد طلبات",
        wm_admin_link_to_item: "اربط بصنف موجود",
        wm_admin_request_link: "اعتماد",
        wm_admin_request_decline: "رفض",
        wm_admin_pick_item_first: "اختر الصنف أولاً",
        wm_admin_request_done: "تم اعتماد الطلب وإشعار الموظف",
        wm_admin_request_declined: "تم رفض الطلب وإشعار الموظف",
        wm_admin_yes: "نعم",
        wm_admin_no: "لا",
        wm_branch: "الفرع",
        wm_date: "التاريخ",
        wm_month: "الشهر",
        wm_more: "المزيد",
        wm_less: "إخفاء",
        wm_item: "الصنف",
        wm_quantity: "الكمية",
        wm_reason: "السبب",
        wm_notes: "ملاحظات",
        wm_save: "حفظ",
        wm_saving: "جارٍ الحفظ...",
        wm_cancel: "إلغاء",
        wm_close: "إغلاق",
        wm_edit: "تعديل",
        wm_delete: "حذف",
        wm_delete_confirm: "حذف هذا التسجيل؟",
        wm_deleted: "تم الحذف",
        wm_saved: "تم الحفظ",
        wm_mode_quick: "تسجيل سريع",
        wm_mode_sheet: "كشف اليوم",
        wm_quick_hint: "صنف واحد في كل مرة",
        wm_day_sheet_hint: "اكتب الكميات المسجّلة اليوم فقط — الأسطر الفارغة لا تُحفظ",
        wm_recorded_today: "المسجل اليوم",
        wm_pick_item: "اختر الصنف",
        wm_search_item: "ابحث عن صنف",
        wm_picker_empty: "لا يوجد صنف مطابق",
        wm_no_item_found: "لم أجد الصنف",
        wm_item_request_title: "طلب إضافة صنف",
        wm_item_request_hint: "اكتب اسم الصنف كما تستخدمه في الفرع، وسيصل الطلب لمدير الأصناف",
        wm_item_request_sent: "تم إرسال الطلب لمدير الأصناف",
        wm_default_reason: "سبب افتراضي",
        wm_no_reason: "بدون سبب",
        wm_saved_prefix: "تم حفظ",
        wm_saved_suffix: "أصناف",
        wm_nothing_typed: "لم تكتب أي كمية",
        wm_no_waste_today: "لا يوجد هدر اليوم",
        wm_no_meals_today: "لا يوجد أكل عمال اليوم",
        wm_no_activity_saved: "تم تسجيل اليوم بلا نشاط",
        wm_no_activity_blocked: "لا يمكن تسجيل «لا يوجد» — هذا اليوم يحمل {n} تسجيل بالأسفل. احذفها أولاً إذا كان اليوم بلا نشاط فعلاً.",
        wm_no_activity_day: "لا يوجد",
        wm_no_activity_undo: "إلغاء التسجيل",
        wm_no_activity_undo_title: "إلغاء تسجيل «لا يوجد»؟",
        wm_no_activity_undo_desc: "سيعود اليوم إلى حالة «لم يُسجّل» ويُحفظ الإلغاء في سجل العمليات باسمك. لا يتم حذف أي بيانات.",
        wm_no_activity_undo_reason: "سبب الإلغاء (اختياري)",
        wm_no_activity_undone: "تم إلغاء تسجيل «لا يوجد»",
        wm_beneficiaries: "عدد المستفيدين",
        wm_beneficiaries_recorded: "المسجل",
        wm_my_entries: "إدخالاتي",
        wm_my_entries_hint: "تسجيلاتك خلال مدة التعديل",
        wm_my_entries_empty: "لا توجد تسجيلات بعد",
        wm_grid_item: "الصنف",
        wm_grid_unit: "الوحدة",
        wm_grid_total: "الإجمالي",
        wm_grid_day_total: "إجمالي اليوم",
        wm_grid_month_total: "إجمالي الشهر",
        wm_grid_empty: "لا توجد تسجيلات في هذا الشهر",
        wm_scope_own: "إدخالاتي فقط",
        wm_scope_branch: "كل إدخالات الفرع",
        wm_badge_inactive_item: "غير فعال",
        wm_badge_inactive_branch: "غير نشط",
        wm_coverage_state_recorded: "سجّل",
        wm_coverage_state_none: "لا يوجد",
        wm_coverage_state_not_recorded: "لم يُسجّل",
        wm_coverage_lines: "الأسطر",
        wm_coverage_last_by: "آخر إدخال",
        wm_coverage_empty: "لا توجد فروع في نطاقك",
        wm_no_home_branch: "لم يتم تحديد فرعك بعد — راجع مدير النظام",
        wm_admin_only_note: "حسابك مخصص لإدارة الأصناف فقط — لا يوجد فرع مرتبط به للتسجيل أو للتقارير",
        wm_offline_error: "لم يتم الحفظ — تحقق من الاتصال",
        wm_retry: "إعادة المحاولة",
        wm_records_count: "تسجيلات",
        wm_hidden_colleague_records: "تسجيلات لزملائك غير معروضة",
        wm_source_quick: "سريع",
        wm_source_day_sheet: "كشف",
        wm_source_import: "استيراد",
        wm_by: "بواسطة",
        wm_favourites: "أصناف الفرع",
        wm_fallback_note: "لا توجد أصناف مخصصة لهذا الفرع — تظهر كل الأصناف",
        wm_warn_big_qty: "كمية كبيرة — تأكد من الرقم",
        wm_select_branch: "اختر الفرع",
        wm_qty_placeholder: "0",
        // ---- 2026-10-16 sheet retirement: raw items, notes, returns, cost, export, recipe links
        wm_raw_badge: "خام",
        wm_note_add: "ملاحظة",
        wm_note_placeholder: "ملاحظة على هذا السطر (اختياري)",
        wm_note_needs_qty: "الملاحظة تُحفظ مع الكمية فقط — اكتب الكمية أولاً",
        wm_reason_not_waste: "لا يُحتسب هدراً",
        wm_returns_title: "مرتجع للمستودع",
        wm_returns_hint: "حركة مخزون — لا تدخل في إجمالي الهدر ولا في تكلفته ولا في نسبته",
        wm_returns_month_total: "إجمالي المرتجع",
        wm_coverage_returns: "مرتجع",
        wm_grid_cost: "التكلفة",
        wm_grid_month_cost: "تكلفة الشهر",
        wm_grid_missing_cost: "{n} بلا تكلفة",
        wm_grid_missing_cost_total: "{n} تسجيل بلا تكلفة — اربط الأصناف بوصفاتها من «ربط الوصفات»",
        wm_grid_waste_pct: "نسبة الهدر من المبيعات",
        wm_grid_waste_pct_none: "لا توجد مبيعات لهذا الفرع",
        wm_grid_through: "حتى",
        wm_export: "تصدير Excel",
        wm_export_title: "تصدير الشهر إلى Excel",
        wm_export_hint: "الملخص والهدر وأكل العمال والمرتجع وكل السجلات",
        wm_export_scope: "الفروع",
        wm_export_scope_branch: "هذا الفرع",
        wm_export_scope_all: "كل فروعي",
        wm_export_type: "المحتوى",
        wm_export_type_waste: "الهدر",
        wm_export_type_meals: "أكل العمال",
        wm_export_type_all: "الهدر وأكل العمال",
        wm_export_cost_note: "التكلفة ونسبة الهدر محفوظة لحظة التسجيل، والمرتجع للمستودع لا يدخل فيهما.",
        wm_export_download: "تنزيل",
        wm_exporting: "جارٍ التصدير...",
        wm_exported: "تم تنزيل الملف",
        wm_export_failed: "تعذّر التصدير — حاول مرة أخرى",
        wm_admin_counts_as_waste: "يُحتسب هدراً",
        wm_admin_counts_locked: "مقفل — السبب مستخدم في تسجيلات",
        wm_admin_counts_off_hint: "سبب لا يُحتسب هدراً (مثل المرتجع للمستودع) يُسجَّل ويظهر، لكنه لا يدخل في إجمالي الهدر ولا تكلفته ولا نسبته. لا يمكن تغييره بعد استخدامه.",
        wm_admin_kind: "النوع",
        wm_admin_kind_product: "منتج",
        wm_admin_kind_stock: "مادة خام (صنف جرد)",
        wm_admin_kind_product_hint: "منتج من الكاشير — تكلفته من وصفته في «ربط الوصفات»",
        wm_admin_kind_stock_hint: "مادة خام من أصناف الجرد الشهري — تكلفتها من الجرد",
        wm_admin_sc_code: "رقم صنف الجرد",
        wm_admin_sc_code_hint: "كما في الجرد الشهري، مثال PT-12200016",
        wm_admin_sc_code_required: "اكتب رقم صنف الجرد للمادة الخام",
        wm_admin_ingredient_key: "مفتاح المكوّن في الوصفات",
        wm_admin_ingredient_key_hint: "كما يظهر في وصفات الكاشير، مثال «لبنه labneh» — يُستخدم لخصم هذا الهدر من الاستهلاك في الجرد اليومي",
        wm_admin_links: "ربط الوصفات",
        wm_admin_missing: "تكلفة ناقصة",
        wm_links_hint: "اربط كل صنف بوصفته في الكاشير لتُحفظ تكلفة الهدر وأكل العمال مع كل تسجيل. لا يُربط أي صنف دون تأكيدك، والتسجيلات قبل الربط تبقى بلا تكلفة.",
        wm_links_filter_all: "الكل",
        wm_links_filter_review: "يحتاج مراجعة",
        wm_links_filter_unlinked: "غير مربوط",
        wm_links_filter_linked: "مربوط",
        wm_links_state_linked: "مربوط",
        wm_links_state_dangling: "وصفة محذوفة",
        wm_links_confidence_confirmed: "مطابقة مؤكدة",
        wm_links_confidence_uncertain: "غير مؤكدة",
        wm_links_confidence_none: "لا توجد مطابقة",
        wm_links_suggestion: "الوصفة المقترحة",
        wm_links_linked_to: "مربوط بالوصفة",
        wm_links_pick: "اختر الوصفة",
        wm_links_check_suggestion: "تأكد من الوصفة قبل الربط — هذه المطابقة ليست مؤكدة",
        wm_links_recipe_missing: "هذه الوصفة لم تعد موجودة في الكاشير — اختر الوصفة الجديدة",
        wm_links_factor: "قطع الكاشير في كل {unit}",
        wm_links_factor_hint: "وصفة الكاشير للقطعة الواحدة، والصنف هنا يُسجَّل بـ{unit}: اكتب كم قطعة في {unit} الواحد.",
        wm_links_factor_required: "اكتب المعامل (أكبر من صفر) قبل الربط",
        wm_links_factor_check: "المعامل غير محدد — تُحفظ تسجيلات هذا الصنف بلا تكلفة حتى تكتب عدد قطع الكاشير في الوحدة",
        wm_links_unit_cost: "تكلفة الوحدة",
        wm_links_zero_lines: "{n} مكوّن بتكلفة صفر",
        wm_links_stock_item: "مادة خام — تكلفتها من الجرد الشهري، لا تُربط بوصفة",
        wm_links_confirm: "تأكيد الربط",
        wm_links_save: "حفظ التغيير",
        wm_links_unlink: "فك الربط",
        wm_links_unlink_confirm: "فك ربط هذا الصنف؟ التسجيلات الجديدة ستُحفظ بلا تكلفة حتى تربطه من جديد.",
        wm_links_saved: "تم حفظ الربط",
        wm_links_unlinked: "تم فك الربط",
        wm_links_confirm_all: "تأكيد كل المطابقات المؤكدة",
        wm_links_confirm_all_desc: "سيُربط {n} صنف بوصفاتها المطابقة تماماً، ويُسجَّل كل ربط باسمك. السبانخ (022 و023) والمطابقات غير المؤكدة لا تُربط هنا — راجعها واحداً واحداً. الأصناف بالكيلو تحتاج معامل الكمية بعد الربط.",
        wm_links_confirm_all_run: "ربط المؤكدة",
        wm_links_confirm_all_done: "تم ربط {n} صنف",
        wm_links_empty: "لا توجد أصناف مطابقة",
        wm_links_none: "لا توجد أصناف للربط",
        wm_links_refresh: "تحديث",
        wm_picker_recipe_title: "اختر وصفة الكاشير",
        wm_picker_recipe_search: "ابحث باسم الوصفة",
        wm_picker_alternatives: "المقترحة لهذا الصنف",
        wm_picker_other: "وصفات أخرى",
        wm_picker_type_more: "اكتب للبحث عن المزيد",
        wm_picker_recipe_empty: "لا توجد وصفة مطابقة",
        wm_missing_hint: "ما يجعل التسجيلات تُحفظ بلا تكلفة. لا شيء هنا يمنع التسجيل.",
        wm_missing_unlinked: "أصناف غير مربوطة بوصفة",
        wm_missing_unlinked_hint: "تُحفظ تسجيلاتها بلا تكلفة حتى تُربط",
        wm_missing_dangling: "ربط بوصفة محذوفة",
        wm_missing_dangling_hint: "الوصفة المربوطة لم تعد في الكاشير — أعد الربط",
        wm_missing_zero_lines: "مكوّنات بتكلفة صفر في الوصفات",
        wm_missing_zero_lines_hint: "تكلفة الوصفة أقل من الحقيقة حتى يُسعَّر المكوّن في الكاشير",
        wm_missing_stock: "مواد خام بلا تكلفة في الجرد",
        wm_missing_stock_hint: "لا توجد تكلفة لصنف الجرد المرتبط",
        wm_missing_empty_group: "لا شيء",
        wm_missing_all_clear: "كل الأصناف لها تكلفة",
        wm_missing_open_links: "افتح ربط الوصفات",
        wm_grid_waste_pct_no_pos: "الفرع غير مربوط بالكاشير",
        wm_grid_waste_pct_no_sales: "لا توجد مبيعات لهذا الشهر",
        wm_grid_waste_pct_no_cost: "لا توجد تكلفة بعد — اربط الأصناف بوصفاتها",
        wm_links_no_recipes: "لا توجد وصفات من الكاشير بعد، فلا توجد مقترحات — ستظهر بعد مزامنة الوصفات",
        wm_missing_needs_factor: "أصناف بالوزن بلا معامل",
        wm_missing_needs_factor_hint: "مربوطة بوصفة للقطعة، وتحتاج عدد قطع الكاشير في الكيلو قبل حساب تكلفتها",
        wm_missing_cause_sc_item_missing: "كود الجرد غير موجود",
        wm_missing_cause_unit_mismatch: "الوحدة لا تتحول إلى وحدة الجرد",
        wm_missing_cause_no_cost: "بلا تكلفة في الجرد",
        wm_missing_linked_items: "أصناف مرتبطة",
        // ---- Branch hub shell + Cancellations «إلغاء الطلبات» (CP3)
        hub_section_wm: "الهدر وأكل العمال",
        hub_section_co: "إلغاء الطلبات",
        co_subtitle: "تسجيل الطلبات الملغاة من الكاشير مع صورة الفاتورة",
        co_tab_entry: "تسجيل إلغاء",
        co_tab_mine: "إدخالاتي",
        co_tab_records: "السجلات",
        co_tab_reports: "التقارير",
        co_tab_review: "يحتاج مراجعة",
        co_tab_settings: "الإعدادات",
        co_coming_soon: "تأتي في مرحلة لاحقة",
        co_not_ready: "الوحدة غير جاهزة بعد — إعداد ناقص على الخادم. راجع مدير النظام.",
        co_no_home_branch: "لم يتم تحديد فرعك بعد — راجع مدير النظام",
        co_assigned_branch_missing: "مدير الفرع بلا فرع معيّن — راجع مدير النظام",
        co_select_branch: "اختر الفرع",
        co_branch_required: "اختر الفرع أولاً",
        co_photo_take: "صوّر الفاتورة",
        co_photo_retake: "إعادة التصوير",
        co_photo_uploading: "جارٍ رفع الصورة…",
        co_photo_stored: "تم حفظ الصورة",
        co_photo_pending: "بانتظار الصورة",
        co_photo_failed: "بدون صورة",
        co_photo_reserve_failed: "تعذر حجز الصورة — انقر لإعادة المحاولة",
        co_photo_required: "صورة الفاتورة مطلوبة",
        // ---- incident 2026-10-21: «تم حفظ الصورة» only once the server has the bytes
        co_photo_lost: "الصورة لم تُرفع",
        co_photo_lost_hint: "لم تصل الصورة إلى الخادم ولم تعد على هذا الجهاز — أعد التصوير",
        co_photo_not_kept: "الصورة غير محفوظة على هذا الجهاز — أبقِ هذه الشاشة مفتوحة حتى يكتمل الرفع",
        co_photo_upload_failed: "تعذّر رفع الصورة",
        co_photo_upload_failed_hint: "لم تصل الصورة إلى الخادم — أعد الرفع أو أعد التصوير",
        co_photo_retry_upload: "إعادة الرفع",
        co_photo_checking: "جارٍ التحقق من الصورة…",
        co_photo_unchecked: "تعذّر التحقق من الصورة — انقر لإعادة المحاولة",
        co_photo_save_blocked: "لا يُحفظ الإلغاء قبل وصول الصورة — أعد الرفع أو أعد التصوير",
        co_photo_saved_without: "حُفظ الإلغاء لكن صورته لم تصل إلى الخادم — أعد تصويرها من «إدخالاتي»",
        co_photo_after_save_failed: "صورة الإلغاء السابق لم تُرفع — أعد تصويرها من «إدخالاتي»",
        co_photo_view: "عرض الصورة",
        co_photo_view_failed: "تعذّر عرض الصورة — حاول مرة أخرى",
        co_invoice: "رقم الفاتورة",
        co_invoice_helper: "آخر 4 أرقام على الأقل",
        co_value: "قيمة الطلب (ر.س)",
        co_value_warn: "القيمة كبيرة — تأكد ثم اضغط «تأكيد القيمة»",
        co_value_confirm: "تأكيد القيمة",
        co_outcome: "ماذا حدث للطلب؟",
        co_phone: "رقم الجوال",
        co_phone_kind_mobile: "عميل برقم",
        co_phone_kind_takeaway: "تيك اوي",
        co_phone_kind_delivery_app: "تطبيق توصيل",
        co_source: "قناة الإلغاء",
        co_source_locked_hint: "مقفلة على الكول سنتر",
        co_category: "السبب",
        co_category_more: "أسباب أخرى",
        co_category_less: "أقل",
        co_reason: "اكتب السبب",
        co_more: "المزيد",
        co_less: "أقل",
        co_outcome_note: "ما الذي حدث بالضبط؟",
        co_reissued_invoice: "رقم الفاتورة الجديدة (اختياري)",
        co_date: "التاريخ",
        co_time: "الوقت",
        co_save: "حفظ الإلغاء",
        co_saving: "جارٍ الحفظ…",
        co_update: "حفظ التعديل",
        co_cancel_edit: "إلغاء التعديل",
        co_saved: "تم تسجيل الإلغاء",
        co_updated: "تم حفظ التعديل",
        co_deleted: "تم حذف السجل",
        co_confirmation: "تم التسجيل: فاتورة {invoice} بقيمة {value} ر.س",
        co_confirmation_duplicate: "سُجّل كتسجيل ثانٍ لنفس الفاتورة",
        co_offline_error: "لم يتم الحفظ — تحقق من الاتصال",
        co_retry: "إعادة المحاولة",
        co_duplicate_title: "هذه الفاتورة مسجّلة اليوم مسبقاً",
        co_duplicate_mine: "سجّلتها أنت",
        co_duplicate_other: "سجّلها زميل",
        co_duplicate_by: "سجّلها {name}",
        co_duplicate_at: "الوقت",
        co_duplicate_value: "القيمة",
        co_duplicate_confirm: "نعم، تسجيل ثانٍ",
        co_duplicate_cancel: "إلغاء",
        co_my_entries: "إدخالاتي",
        co_my_entries_hint: "إدخالاتك لهذا اليوم — التعديل والحذف داخل المدة",
        co_my_entries_window: "إدخالاتك خلال مدة التعديل",
        co_my_entries_empty: "لا إدخالات اليوم بعد",
        co_my_entries_total: "{n} إلغاء · {value} ر.س",
        co_badge_duplicate: "تسجيل ثانٍ",
        co_badge_review: "يحتاج مراجعة",
        co_badge_backdated: "مؤرخ بأثر رجعي",
        // ---- CP4: POS lookup + verdict chips
        co_customer: "العميل",
        co_pos_lookup: "بحث",
        co_pos_checking: "جارٍ التحقق…",
        co_pos_searching_live: "جارٍ البحث في الكاشير…",
        co_pos_not_arrived: "لم تصل إلى الكاشير بعد",
        co_pos_matched: "موجودة في الكاشير",
        co_pos_not_found: "لم تُوجد في الكاشير بعد",
        co_pos_ambiguous: "أدخل رقم الفاتورة كاملاً أو آخر {n} أرقام على الأقل",
        co_pos_unavailable: "لم تتم المزامنة بعد",
        co_pos_wait_live: "سيُتحقق منها تلقائياً خلال دقائق",
        co_pos_wait_nightly: "سيُتحقق منها بعد مزامنة الليل",
        co_pos_already_mine: "سجّلتها أنت من قبل",
        co_pos_already_other: "مسجّلة اليوم مسبقاً",
        co_pos_pay_state_paid: "تم الدفع",
        co_pos_pay_state_delivery_company: "شركة توصيل",
        co_pos_pay_state_mismatch: "غير مطابق",
        co_pos_pay_state_unknown: "حالة غير معروفة",
        co_pos_till: "عولجت على الكاشير",
        co_pos_lookup_limit: "محاولات كثيرة — انتظر دقيقة",
        co_delete_confirm: "حذف هذا السجل؟",
        co_edit: "تعديل",
        co_delete: "حذف",
        co_editing: "تعديل سجل",
        co_business_date: "يوم العمل",
        // ---- message 29: photo notice + CP6-lite (records, review, panel, export)
        co_photo_rejected_notice: "لم تُرفع الصورة — يمكنك إعادة التصوير",
        co_rec_from: "من",
        co_rec_to: "إلى",
        co_rec_all_branches: "كل الفروع",
        co_rec_all: "الكل",
        co_rec_filters: "الفلاتر",
        co_rec_filter_category: "السبب",
        co_rec_filter_outcome: "ماذا حدث للطلب",
        co_rec_filter_source: "القناة",
        co_rec_filter_pos_match: "الكاشير",
        co_rec_filter_review_status: "المراجعة",
        co_rec_filter_photo_status: "الصورة",
        co_rec_show_duplicates: "إظهار المكرر",
        co_rec_reset: "مسح الفلاتر",
        co_rec_review_open: "يحتاج مراجعة أو متابعة",
        co_rec_review_none: "بدون مراجعة",
        co_rec_photo_stored: "بصورة",
        co_rec_photo_none: "بدون صورة",
        co_rec_pos_matched: "موجودة في الكاشير",
        co_rec_pos_not_found: "لم تُوجد في الكاشير",
        co_rec_pos_ambiguous: "غير محددة",
        co_rec_pos_unavailable: "لم تتم المزامنة",
        co_rec_total_count: "عدد الإلغاءات",
        co_rec_total_value: "القيمة",
        co_rec_total_still: "ما زالت في مبيعات الكاشير",
        co_rec_totals_note: "المجاميع للفلتر الحالي — التسجيل الثاني غير محسوب",
        co_rec_export: "تصدير Excel",
        co_rec_exporting: "جارٍ التصدير…",
        co_rec_exported: "تم تنزيل الملف",
        co_rec_export_failed: "تعذّر التصدير — حاول مرة أخرى",
        co_rec_empty: "لا سجلات لهذا الفلتر",
        co_rec_page: "{from}–{to} من {total}",
        co_rec_prev: "السابق",
        co_rec_next: "التالي",
        co_rec_panel_title: "سجل الإلغاء",
        co_rec_field_invoice: "رقم الفاتورة",
        co_rec_field_value: "القيمة",
        co_rec_field_business_date: "يوم العمل",
        co_rec_field_time: "وقت الإلغاء",
        co_rec_field_branch: "الفرع",
        co_rec_field_category: "السبب",
        co_rec_field_reason: "تفاصيل السبب",
        co_rec_field_outcome: "ماذا حدث للطلب",
        co_rec_field_outcome_note: "ملاحظة المآل",
        co_rec_field_reissued: "الفاتورة الجديدة",
        co_rec_field_prepared: "حُضِّر",
        co_rec_field_source: "قناة الإلغاء",
        co_rec_field_customer: "العميل",
        co_rec_field_recorded_by: "سجّلها",
        co_rec_field_created_at: "وقت التسجيل",
        co_rec_field_updated: "آخر تعديل",
        co_rec_field_origin: "المصدر",
        co_rec_field_duplicate: "تسجيل ثانٍ لفاتورة مسجّلة",
        co_rec_field_photo: "الصورة",
        co_rec_yes: "نعم",
        co_rec_no: "لا",
        co_rec_origin_app: "التطبيق",
        co_rec_origin_import: "النموذج",
        co_rec_photo_title: "صورة الفاتورة",
        co_rec_photo_missing: "لا توجد صورة محفوظة لهذا السجل",
        co_rec_photo_diag: "تشخيص الصورة: {status} · محاولات الرفع {attempts} · مرات الرفض {rejected} ({rejection}) · خطأ الجهاز {error}",
        co_rec_pos_title: "الكاشير",
        co_rec_pos_matched_line: "الفاتورة موجودة في الكاشير: {total} ر.س · {state} · الساعة {time}",
        co_rec_pos_basis_exact: "مطابقة تامة لرقم الفاتورة",
        co_rec_pos_basis_suffix: "مطابقة بآخر أرقام الفاتورة",
        co_rec_pos_basis_suffix_previous_date: "مطابقة بآخر الأرقام في اليوم السابق",
        co_rec_pos_channel: "قناة الطلب في الكاشير: {channel}",
        co_rec_pos_till_line: "سُجّل لها على الكاشير {count} مرتجع/تالف بقيمة {amount} ر.س",
        co_rec_pos_value_exceeds: "القيمة المسجّلة أكبر من قيمة الفاتورة في الكاشير",
        co_rec_pos_partial: "إلغاء جزئي: القيمة المسجّلة أقل من قيمة الفاتورة",
        co_rec_pos_source_mismatch: "قناة الإلغاء لا تطابق قناة الطلب في الكاشير",
        co_rec_pos_not_found_final: "لم تُوجد الفاتورة في الكاشير بعد اكتمال مزامنة اليوم",
        co_rec_pos_not_found_wait: "لم تُوجد الفاتورة في الكاشير حتى الآن — قد تظهر بعد المزامنة",
        co_rec_pos_ambiguous_many: "أكثر من فاتورة ({n}) تنتهي بنفس الأرقام — يلزم الرقم كاملاً",
        co_rec_pos_ambiguous_short: "الرقم المسجّل أقصر من أن يُطابَق",
        co_rec_pos_unavailable_line: "لم تتم مزامنة الكاشير لهذا اليوم بعد",
        co_rec_pos_checked: "آخر تحقق: {at}",
        co_rec_manager_note: "ملاحظة مدير الفرع",
        co_rec_manager_note_ph: "اكتب ملاحظتك على هذا السجل",
        co_rec_save_note: "حفظ الملاحظة",
        co_rec_note_saved: "تم حفظ الملاحظة",
        co_rec_review_title: "المراجعة",
        co_rec_review_none_yet: "لم يُراجَع بعد",
        co_rec_review_note_ph: "ملاحظة المراجع (اختياري)",
        co_rec_review_save: "حفظ المراجعة",
        co_rec_review_saved: "تم حفظ المراجعة",
        co_rec_review_by: "راجعه {name} · {at}",
        co_rec_dismiss_duplicate: "ليس تسجيلاً مكرراً",
        co_rec_flags: "سبب المراجعة",
        co_rec_audit_title: "سجل التغييرات",
        co_rec_audit_empty: "لا تغييرات مسجّلة",
        co_rec_audit_system: "النظام",
        co_rec_audit_changed: "تغيّر: {fields}",
        co_audit_co_record_create: "إنشاء السجل",
        co_audit_co_record_update: "تعديل المحتوى",
        co_audit_co_record_delete: "حذف السجل",
        co_audit_co_review_update: "مراجعة / ملاحظة",
        co_audit_co_pos_review_flags: "نتيجة مطابقة الكاشير",
        co_audit_co_duplicate_late: "تسجيل ثانٍ (بعد المطابقة)",
        co_audit_co_duplicate_cleared: "أُزيلت علامة التكرار",
        co_audit_co_photo_rejected: "رُفضت الصورة ({n} مرة)",
        co_flag_duplicate: "تسجيل ثانٍ",
        co_flag_duplicate_late: "تسجيل ثانٍ (بعد المطابقة)",
        co_flag_value_high: "قيمة عالية",
        co_flag_discard_value: "إتلاف بقيمة عالية",
        co_flag_cashier_daily_count: "كثرة إلغاءات الكاشير اليوم",
        co_flag_backdated: "مؤرخ بأثر رجعي",
        co_flag_pos_not_found: "غير موجودة في الكاشير",
        co_flag_pos_ambiguous: "رقم غير كافٍ للمطابقة",
        co_flag_value_exceeds: "القيمة أكبر من الكاشير",
        co_flag_source_mismatch: "القناة لا تطابق الكاشير",
        co_rec_close: "إغلاق",
        co_rec_delete: "حذف السجل",
        co_rec_delete_title: "حذف السجل",
        co_rec_delete_body: "يختفي السجل من القوائم والإجماليات و«يحتاج مراجعة» والتصدير. تبقى الصورة ليمكن استعادته عند الحاجة.",
        co_rec_delete_reason: "سبب الحذف",
        co_rec_delete_reason_hint: "5 أحرف على الأقل",
        co_rec_delete_confirm: "تأكيد الحذف",
        co_rec_delete_cancel: "إلغاء",

        quality_hub_tab_sections: "الأقسام",
        quality_hub_tab_branches: "الفروع",

        // ---- Dashboard (2026-07-22) ----
        qc_dash_tab: "لوحة المتابعة",
        qc_dash_title: "لوحة متابعة التفتيش",
        qc_dash_subtitle: "نظرة شاملة على المخالفات والفروع والمفتشين",
        qc_dash_range_last_7d: "آخر ٧ أيام",
        qc_dash_range_last_30d: "آخر ٣٠ يوم",
        qc_dash_range_last_90d: "آخر ٩٠ يوم",
        qc_dash_range_ytd: "منذ بداية السنة",
        qc_dash_range_last_year: "آخر ١٢ شهر",
        qc_dash_range_custom: "مخصص",
        qc_dash_all_branches: "كل الفروع",
        qc_dash_branches: "الفروع",
        qc_dash_severity: "الخطورة",
        qc_dash_severity_all: "جميع الدرجات",
        qc_dash_no_data: "لا توجد بيانات في هذا النطاق. جرّب توسيع الفترة أو تخفيف الفلاتر.",
        qc_dash_kpi_rounds: "جولات مُرسلة",
        qc_dash_kpi_violations: "مخالفات مسجّلة",
        qc_dash_kpi_closed_pct: "نسبة الإغلاق",
        qc_dash_kpi_overdue: "متأخرة",
        qc_dash_kpi_avg_ttc: "متوسط زمن الإغلاق",
        qc_dash_kpi_avg_ttc_note: "بالأيام لكل درجة",
        qc_dash_trend_title: "تطوّر المخالفات",
        qc_dash_trend_desc: "أعمدة أسبوعية أو شهرية موزّعة على درجة الخطورة",
        qc_dash_top_branches_title: "أعلى الفروع بالمخالفات",
        qc_dash_top_items_title: "أعلى البنود مخالفةً",
        qc_dash_open_vs_closed_title: "مفتوحة مقابل مغلقة",
        qc_dash_open: "مفتوحة",
        qc_dash_closed: "مغلقة",
        qc_dash_sev_critical: "حرجة",
        qc_dash_sev_moderate: "متوسطة",
        qc_dash_sev_minor: "بسيطة",
        qc_dash_inspector_title: "نشاط المفتشين",
        qc_dash_col_inspector: "المفتش",
        qc_dash_col_rounds: "الجولات",
        qc_dash_col_avg_violations: "متوسط المخالفات",
        qc_dash_col_last_submission: "آخر إرسال",
        qc_dash_col_total_violations: "إجمالي المخالفات",
        qc_dash_from: "من",
        qc_dash_to: "إلى",
        qc_dash_apply: "تطبيق",
        qc_dash_clear_filters: "مسح الفلاتر",
        qc_dash_branch_perf_title: "أداء الفروع المتعدد التبويبات",
        qc_dash_branch_perf_desc: "المخالفات · صافي المبيعات · صافي الأرباح والخسائر — لنفس الفترة",
        qc_dash_col_branch: "الفرع",
        qc_dash_col_violations: "المخالفات",
        qc_dash_col_sales_net: "صافي المبيعات",
        qc_dash_col_pnl_net: "صافي الربح",
        qc_dash_col_flags: "خصائص",
        qc_dash_critical: "حرج",
        qc_dash_moderate: "متوسط",
        qc_dash_minor: "بسيط",
        qc_ins_rounds_title: "جولات التفتيش",
        qc_ins_rounds_desc: "ابدأ جولة جديدة، أو استأنف مسودة، أو راجع الجولات المُرسلة.",
        qc_ins_new_round: "جولة جديدة",
        qc_ins_new_round_desc: "اختر الفرع لبدء جولة تفتيش. سيتم تسجيل وقت البدء تلقائياً.",
        qc_ins_start_round: "بدء الجولة",
        qc_ins_branch: "الفرع",
        qc_ins_my_drafts: "مسوّداتي",
        qc_ins_no_drafts: "لا توجد مسوّدات — ابدأ جولة جديدة.",
        qc_ins_submitted_rounds: "جولات مُرسلة",
        qc_ins_no_submitted: "لا توجد جولات مُرسلة بعد",
        qc_ins_no_submitted_hint_inspector: "بمجرد إرسال جولة، ستظهر هنا للأرشيف.",
        qc_ins_no_submitted_hint_viewer: "لم يقم أي مفتش بإرسال جولة على فرع من فروعك بعد.",
        qc_ins_status_draft: "مسوّدة",
        qc_ins_status_submitted: "مُرسلة",
        qc_ins_violations_short: "مخالفة",
        qc_ins_resume: "استئناف",
        qc_ins_view: "عرض",
        qc_admin_edit_meta: "تعديل الجولة",
        qc_admin_edit_meta_title: "تعديل بيانات الجولة",
        qc_admin_edit_meta_desc: "تعديل تاريخ الزيارة كإجراء تصحيحي (يُسجَّل في سجل التدقيق).",
        qc_admin_close_action: "إغلاق (تحويل إلى مُرسلة)",
        qc_admin_close_title: "إغلاق الجولة",
        qc_admin_close_desc: "سيتم تحويل الجولة إلى حالة “مُرسلة” فورًا وإرسال البريد للمشتركين. متابعة؟",
        qc_admin_close_ok: "تم إغلاق الجولة",
        qc_admin_reopen_action: "إعادة فتح",
        qc_admin_reopen_title: "إعادة فتح الجولة",
        qc_admin_reopen_desc: "ستعود الجولة إلى حالة المسوّدة القابلة للتحرير. سيتم مسح تاريخ الإرسال، وتظل المخالفات المرتبطة كما هي. متابعة؟",
        qc_admin_reopen_ok: "تم إعادة فتح الجولة",
        qc_admin_delete_action: "حذف الجولة",
        qc_admin_delete_title: "حذف الجولة نهائيًا",
        qc_admin_delete_desc: "سيتم حذف الجولة وجميع مخالفاتها وصورها بشكل دائم. لا يمكن التراجع. متابعة؟",
        qc_admin_delete_ok: "تم حذف الجولة",
        qc_admin_archive_action: "أرشفة الجولة",
        qc_admin_archive_title: "أرشفة الجولة",
        qc_admin_archive_desc: "سيتم إخفاء الجولة من قائمة الجولات ولوحة المتابعة وسجل المخالفات. البيانات تُحفظ ويمكن استعادتها في أي وقت من قائمة «المؤرشفة». متابعة؟",
        qc_admin_archive_ok: "تم أرشفة الجولة",
        qc_admin_unarchive_action: "استعادة من الأرشيف",
        qc_admin_unarchive_title: "استعادة الجولة من الأرشيف",
        qc_admin_unarchive_desc: "ستعود الجولة إلى قائمة الجولات وسجل المخالفات ولوحة المتابعة كما كانت من قبل. متابعة؟",
        qc_admin_unarchive_ok: "تم استعادة الجولة",
        qc_rounds_show_archived: "عرض المؤرشفة",
        qc_rounds_archived_section: "الجولات المؤرشفة",
        qc_rounds_no_archived: "لا توجد جولات مؤرشفة.",
        qc_rounds_archived_badge: "مؤرشفة",

        qc_email_status_label: "الإشعار",
        qc_email_status_sent: "أُرسل الإشعار",
        qc_email_status_failed: "فشل الإرسال",
        qc_email_status_skipped_no_recipients: "لا يوجد مستلمون",
        qc_email_status_skipped_no_api_key: "الإرسال غير مُهيّأ",
        qc_email_status_pending: "قيد الإرسال",
        qc_email_status_none: "لم يُحاوَل الإرسال",

        qc_ins_check_only_violations: "علّم فقط البنود غير المطابقة. البنود غير المُعلّمة تعتبر مطابقة.",
        qc_ins_section_notes: "ملاحظات القسم",
        qc_ins_section_notes_ph: "اكتب ملاحظات عامة على هذا القسم (اختياري)…",
        qc_ins_severity: "الخطورة",
        qc_ins_sev_critical: "حرجة",
        qc_ins_sev_moderate: "متوسطة",
        qc_ins_sev_minor: "بسيطة",
        qc_ins_responsible: "المسؤول",
        qc_ins_responsible_select_ph: "اختر الموظف المسؤول (اختياري)",
        qc_ins_responsible_none: "بدون",
        qc_ins_responsible_loading: "جارٍ تحميل قائمة الموظفين…",
        qc_ins_responsible_hr_unavailable: "قائمة الموظفين غير متاحة حالياً — يمكنك كتابة الاسم يدوياً.",
        qc_ins_responsible_hr_gate: "بدون اختيار مسؤول من قائمة الموظفين لا تُرسل المخالفة إلى الموارد البشرية — تبقى في نظام العمليات فقط.",
        qc_ins_responsible_manual_ph: "اكتب اسم المسؤول (غير مُوثّق)",
        qc_ins_responsible_unverified: "غير مُوثّق",
        qc_ins_deadline: "الموعد النهائي",
        qc_ins_description: "الوصف",
        qc_ins_photos: "الصور",
        qc_ins_capture_photo: "التقاط صورة",
        qc_ins_delete_photo: "حذف الصورة",
        qc_ins_photo_deleted: "تم حذف الصورة",
        qc_ins_section_photos: "صور القسم (ملاحظات غير مدرجة)",
        qc_ins_section_photo_add: "إضافة صورة للقسم",
        qc_ins_section_photo_needs_note: "اكتب ملاحظة القسم أولاً، ثم يمكنك إرفاق صورة توضّحها.",
        qc_ins_section_note_severity: "خطورة الملاحظة",
        qc_ins_section_note_severity_none: "بدون تحديد",
        qc_ins_section_note_severity_needs_note: "اكتب الملاحظة أولاً لتحديد خطورتها.",
        qc_ins_responsible_add: "إضافة موظف مسؤول",
        qc_ins_responsible_all_added: "تمت إضافة كل الموظفين",
        qc_ins_responsible_remove: "إزالة",
        qc_ins_responsible_none_assigned: "لم يُحدَّد أي مسؤول",
        qc_ins_responsible_manual_add: "إضافة",
        qc_ins_responsible_multi_hint: "يمكن تحديد أكثر من موظف. كل موظف مختار من قائمة الموارد البشرية تُرسل له مخالفة خاصة به؛ الأسماء المكتوبة يدوياً تبقى في نظام العمليات فقط.",
        qc_admin_delete_draft_action: "حذف المسودة",
        qc_admin_delete_draft_title: "حذف مسودة الجولة؟",
        qc_admin_delete_draft_desc: "سيتم حذف المسودة وكل ما فيها من مخالفات وصور نهائياً. لا يمكن التراجع.",
        qc_branches_title: "أسماء الفروع",
        qc_branches_desc: "تعديل اسم الفرع فقط. لا يؤثر على رقم نقاط البيع أو ربط الموارد البشرية أو أي بيانات تاريخية.",
        qc_branches_empty: "لا توجد فروع.",
        qc_branch_rename: "تعديل الاسم",
        qc_branch_rename_title: "تعديل اسم الفرع",
        qc_branch_rename_desc: "الاسم الجديد سيظهر في كل شاشات النظام مباشرة.",
        qc_branch_rename_hint: "يتم تعديل الاسم فقط — رقم نقاط البيع ورقم فرع الموارد البشرية والبيانات المرتبطة تبقى كما هي.",
        qc_branch_name_ar: "الاسم بالعربية",
        qc_branch_name_en: "الاسم بالإنجليزية",
        qc_branch_name_required: "اسم الفرع مطلوب",
        qc_branch_renamed: "تم تعديل اسم الفرع",

        qc_ins_wizard_review: "مراجعة وإرسال",
        qc_ins_review: "مراجعة",
        qc_ins_review_summary: "ملخص الجولة",
        qc_ins_total_sections: "الأقسام",
        qc_ins_total_violations: "المخالفات",
        qc_ins_total_photos: "الصور",
        qc_ins_notes_count: "ملاحظات",
        qc_ins_no_violations_yet: "لم تُسجَّل أي مخالفات — الجولة نظيفة حتى الآن.",
        qc_ins_submit_round: "إرسال الجولة",
        qc_ins_submit_confirm: "إرسال جولة التفتيش؟",
        qc_ins_submit_confirm_desc: (n) => `بعد الإرسال لن يمكن التعديل. عدد المخالفات المسجّلة: ${n}.`,
        qc_ins_round_submitted: "تم إرسال الجولة",
        qc_ins_round_readonly: "هذه الجولة مُرسلة ولا يمكن تعديلها.",
        qc_ins_autosaving: "جارٍ الحفظ…",
        qc_ins_back_to_hub: "الرجوع لجولات التفتيش",
        qc_ins_edit_section: "تعديل هذا القسم",
        qc_ins_review_no_photos: "لا توجد صور",
        qc_ins_review_photo_alt: "صورة المخالفة",
        qc_ins_lightbox_close: "إغلاق",
        qc_ins_review_tap_to_edit: "اضغط على المخالفة للعودة إلى القسم والتعديل",
        qc_ins_watermark_failed: "تعذّر تجهيز الصورة (فشل ختم الشعار). يُرجى إعادة المحاولة أو التقاط الصورة مجدداً.",
        back: "السابق",
        next: "التالي",
        close: "إغلاق",

        qc_ins_violations_tab: "المخالفات",
        qc_v_title: "متابعة المخالفات",
        qc_v_desc_admin: "جميع المخالفات عبر الفروع والمفتشين — مع الفلاتر وتغيير الحالة والمقارنة قبل/بعد.",
        qc_v_desc_scoped: "المخالفات ضمن نطاقك — يمكنك تحديث حالة الإغلاق ورفع صور «بعد» كإثبات.",
        qc_v_filter_branch: "الفرع",
        qc_v_filter_status: "الحالة",
        qc_v_filter_severity: "الخطورة",
        qc_v_filter_section: "القسم",
        qc_v_overdue_only: "المتأخرة فقط",
        qc_v_all: "الكل",
        qc_v_clear_filters: "مسح الفلاتر",
        qc_v_total: "الكل",
        qc_v_status_open: "مفتوحة",
        qc_v_status_in_progress: "قيد المعالجة",
        qc_v_status_closed: "مغلقة",
        qc_v_status_pending_approval: "بانتظار الاعتماد",
        qc_v_status_overdue: "متأخرة",
        qc_v_col_branch: "الفرع",
        qc_v_col_item: "المخالفة",
        qc_v_col_status: "الحالة",
        qc_v_col_photos: "قبل/بعد",
        qc_hr_push_queued: "قيد الإرسال للموارد البشرية",
        qc_hr_push_sent: "أُرسل للموارد البشرية",
        qc_hr_push_failed: "فشل الإرسال للموارد البشرية",
        qc_hr_push_skipped: "لم يُرسل — لا يوجد مسؤول",
        qc_v_empty: "لا توجد مخالفات ضمن هذا الفلتر",
        qc_v_empty_hint: "بمجرد إرسال جولات تحوي مخالفات ستظهر هنا.",
        qc_v_empty_filtered_hint: "جرّب تغيير الفلاتر أو مسحها.",

        qc_v_detail_title: "تفاصيل المخالفة",
        qc_v_detail_desc: "استعرض المخالفة، غيّر حالتها، وارفق صور «بعد» كإثبات إغلاق.",
        qc_v_status_change: "تغيير الحالة",
        qc_v_status_updated: "تم تحديث الحالة",
        qc_v_readonly: "ليس لديك صلاحية تعديل هذه المخالفة — عرض فقط.",
        qc_v_edit_btn: "تعديل",
        qc_v_delete_btn: "حذف المخالفة",
        qc_v_edit_title: "تعديل المخالفة",
        qc_v_f_severity: "الخطورة",
        qc_v_f_description: "الوصف",
        qc_v_f_responsible: "المسؤول",
        qc_v_f_responsible_ph: "اسم المسؤول (اختياري)",
        qc_v_f_deadline: "الموعد النهائي",
        qc_v_saved: "تم حفظ التعديلات",
        qc_v_delete_confirm_title: "حذف المخالفة؟",
        qc_v_delete_confirm_desc: "سيتم حذف المخالفة وجميع صورها نهائياً. لا يمكن التراجع عن هذا الإجراء.",
        qc_v_delete_ok: "حذف نهائي",
        qc_v_deleted: "تم حذف المخالفة",
        qc_v_reopen: "إعادة فتح",
        qc_v_add_after_photo: "التقاط صورة «بعد»",
        qc_v_resolve_title: "معالجة المخالفة",
        qc_v_start_working: "بدء المعالجة",
        qc_v_resolution_note_label: "ملاحظة الحل",
        qc_v_resolution_note_ph: "اشرح ما تم عمله لمعالجة المخالفة…",
        qc_v_submit_resolution: "إرسال الحل للاعتماد",
        qc_v_note_required: "الرجاء إدخال ملاحظة الحل",
        qc_v_pending_banner: "تم إرسال الحل — بانتظار اعتماد الجودة",
        qc_v_pending_wait: "لا يمكنك الإغلاق مباشرة. سيقوم مسؤول الجودة بالاعتماد أو الإرجاع.",
        qc_v_resolution_by: "أرسل الحل",
        qc_v_approve_close: "اعتماد وإغلاق",
        qc_v_send_back: "إرجاع للتعديل",
        qc_v_send_back_reason_label: "سبب الإرجاع",
        qc_v_send_back_reason_ph: "سبب الإرجاع للفرع…",
        qc_v_reason_required: "الرجاء إدخال سبب الإرجاع",
        qc_v_sent_back_label: "أُعيدت للتعديل — سبب الإرجاع:",
        qc_v_after_uploaded: "تم رفع صورة «بعد»",
        qc_v_after_ready: "توجد صورة «بعد» — يمكنك الإغلاق دون تحذير.",
        qc_v_after_hint: "أضف صورة «بعد» كإثبات قبل الإغلاق.",
        qc_v_overdue_now: "متأخرة الآن",
        qc_v_before: "قبل",
        qc_v_after: "بعد",
        qc_v_no_photos_yet: "لا توجد صور بعد",
        qc_v_closed_by: "أُغلقت بواسطة",
        qc_v_closed_without_proof: "أُغلقت بدون صورة إثبات",
        qc_v_close_no_proof_title: "إغلاق بدون صورة إثبات؟",
        qc_v_close_no_proof_desc: "لم يتم رفع صورة «بعد» لهذه المخالفة. الإغلاق ممكن، لكنه سيُسجَّل بعلامة «بدون إثبات». هل تريد المتابعة؟",
        qc_v_close_no_proof_ok: "متابعة الإغلاق",

        financials_title: "المالية",
        financials_subtitle: "الأرباح والخسائر من نظام ERP (مستقلة عن المبيعات)",
        financials_empty: "لا توجد بيانات مالية بعد",
        financials_empty_hint: "ستظهر مؤشرات الربحية وترتيب الفروع هنا بعد استيراد البيانات المالية.",
        import_financials: "استيراد البيانات المالية",
        erp_pl_import: "استيراد أرباح وخسائر ERP",
        erp_pl_title: "استيراد تقرير الأرباح والخسائر (ERP)",
        erp_pl_desc: "ارفع ملف XLS من نظام ERP — تقرير Profit - Loss By Cost Center. يتم التحقق من مطابقة المجاميع قبل الحفظ، وأي ملف غير مطابق يُرفض بالكامل.",
        erp_pl_choose: "اختر ملف XLS",
        erp_pl_month: "الشهر",
        erp_pl_revenue: "إجمالي الإيرادات",
        erp_pl_expense: "إجمالي المصروفات",
        erp_pl_net: "الصافي",
        erp_pl_profit: "ربح",
        erp_pl_loss: "خسارة",
        erp_pl_per_cc: "النتيجة حسب مركز التكلفة",
        erp_pl_cc: "مركز التكلفة",
        erp_pl_branch: "الفرع",
        erp_pl_not_mapped: "غير مرتبط",
        erp_pl_unmapped_title: "مراكز تكلفة غير مرتبطة بفروع",
        erp_pl_unmapped_desc: "تم استيراد بياناتها، لكنها غير مرتبطة بأي فرع — الربط لا يتم تلقائياً أبداً.",
        erp_pl_validation_ok: "تم التحقق: مجموع الصفوف يطابق الإجمالي المطبوع (± ١ ريال)",
        cc_map_btn: "ربط مراكز التكلفة",
        cc_map_title: "ربط مراكز التكلفة بالفروع",
        cc_map_desc: "اربط كل مركز تكلفة من نظام ERP بفرع نقاط البيع المطابق — الربط لا يتم تلقائياً أبداً. اختر «بدون مطابقة» لمراكز التكلفة التي ليست فروعاً.",
        cc_map_status: "الحالة",
        cc_map_not_set: "— غير محدد —",
        cc_map_external: "بدون مطابقة / خارجي",
        cc_map_mapped: "مرتبط",
        cc_map_saved: "تم الحفظ",
        cc_map_empty: "لا توجد مراكز تكلفة بعد — استورد تقرير ERP أولاً",
        import_financials_desc: "ارفع ملف JSON للأرباح والخسائر من نظام ERP. تُحفظ بشكل مستقل تماماً عن بيانات المبيعات.",
        financials_recon: "مطابقة البيانات المالية",
        financials_recon_desc: "مقارنة المخزَّن مقابل الإجماليات المستهدفة في الملف.",
        financials_recon_no_data: "لم يتم استيراد بيانات مالية بعد",
        financials_recon_no_data_hint: "استخدم زر «استيراد البيانات المالية» لرفع ملف الأرباح والخسائر.",
        partial_months_label: "أشهر جزئية",
        partial_flag: "بيانات جزئية",
        partial_note: "تحتوي على أشهر ذات بيانات جزئية — لا تُعتبر نهائية.",
        financial_service_token: "رمز الخدمة المالي",
        financials_token_hint: "رمز منفصل لاستيراد البيانات المالية فقط (مختلف عن رمز المبيعات).",
        branches_summary: "الفروع",
        br_linked: "مرتبط",
        br_created: "مُنشأ",
        financials_access: "صلاحيات المالية",
        financials_access_hint: "صلاحية مستقلة عن المبيعات — حدّد الفروع المالية المسموح بها لهذا المستخدم.",
        qc_access: "نطاق فروع الجودة",
        qc_access_hint: "الفروع التي تشملها صلاحية الجودة لهذا المستخدم (يُتجاهل عند منح صلاحية «الجودة: كل الفروع»).",
        perm_capabilities: "الصلاحيات",
        perm_cap_group_quality: "الجودة",
        perm_cap_group_cctv: "الكاميرات",
        perm_cap_group_waste_meals: "الهدر وأكل العمال",
        perm_cap_group_branch_ops: "عمليات الفرع",
        perm_cap_group_cancellations: "إلغاء الطلبات",
        perm_cap_group_stock_count: "الجرد الشهري",
        perm_hub_branches: "فرع العمل (عمليات الفرع)",
        perm_hub_branches_hint: "يُستخدم للهدر وأكل العمال ولإلغاء الطلبات",
        perm_hub_needs_branch: "اختر فرع عمل واحداً على الأقل لصلاحيات التسجيل أو الإشراف",
        perm_co_branch_no_pos: "لا يمكن ربط إلغاء الطلبات بفرع بلا كاشير",
        perm_co_branch_no_pos_hint: "صلاحيات إلغاء الطلبات تتطلب فرعاً مربوطاً بكاشير — الفروع بلا كاشير معلّمة",
        perm_branch_no_pos_badge: "بلا كاشير",
        perm_wm_branches: "فروع الهدر وأكل العمال",
        perm_wm_branches_hint: "الفروع التي يسجّل فيها هذا الحساب — مطلوب قبل حفظ صلاحية التسجيل أو الإشراف",
        perm_wm_bm_locked: "مدير الفرع مرتبط بفرعه المعيّن فقط. عمليات الفرع (الهدر وأكل العمال وإلغاء الطلبات) تتبع نفس الفرع تلقائياً، ولا يمكن إضافة فروع أخرى.",
        perm_wm_needs_branch: "اختر فرعاً واحداً على الأقل لصلاحيات الهدر وأكل العمال",
        perm_wm_reports_needs_base: "يتطلب صلاحية تسجيل أو إشراف أو إدارة الأصناف في الهدر وأكل العمال",
        perm_wm_reports_included: "مشمولة في التحكم الكامل",
        perm_sc_locations: "مواقع الجرد",
        perm_sc_locations_hint: "الفروع والمستودعات التي يجردها هذا الحساب — مطلوب قبل حفظ صلاحية تسجيل الجرد. المالية ترى كل المواقع دون ربط",
        perm_sc_needs_location: "اختر موقع جرد واحداً على الأقل لصلاحية تسجيل الجرد",
        perm_sc_bm_locked: "مدير الفرع يجرد فرعه المعيّن فقط تلقائياً، ولا تُحدَّد له مواقع جرد أخرى.",
        perm_sc_warehouse_badge: "مستودع",
        perm_cap_group_daily_count: "الجرد اليومي",
        perm_dk_needs_location: "اختر موقع جرد واحداً على الأقل لصلاحية تسجيل الجرد اليومي",
        perm_dk_locations_hint: "الجرد اليومي يستخدم الفروع فقط من هذه المواقع. المتابعة والفروقات لا تحتاج ربطاً",
        perm_cap_group_screens: "الشاشات",
        perm_cap_group_admin: "الإدارة",
        perm_admin_cap_super_only: "يمنحها مدير النظام الأعلى فقط.",
        perm_grant_own_only: "لا يمكنك منح صلاحية لا تملكها بنفسك.",
        expense_col: "المصروفات",
        net_col: "صافي الربح",
        margin_col: "الهامش",
        partial_short: "جزئي",
        key_cost: "أكبر تكلفة",
        loss_label: "خسارة",
        of_total_expense: "من إجمالي المصروفات",
        all_branches_fin: "كل الفروع المالية",

        monthly_detail: "التفاصيل الشهرية",
        monthly_detail_hint: "اختر الشهر والفرع لعرض بنود الإيرادات والمصروفات بالتفصيل.",
        select_month: "اختر الشهر",
        account_col: "الحساب",
        group_col: "المجموعة",
        amount_col: "المبلغ",
        income_total_label: "إجمالي الإيرادات",
        expense_total_label: "إجمالي المصروفات",
        net_result_label: "صافي / ما احتفظت به",
        no_lines_month: "لا توجد بنود لهذا الفرع في الشهر المحدد",

        fin_hero_title: "أين ذهبت أموالك؟",
        fin_hero_sub: "رحلة الريال من المبيعات إلى ما احتفظت به",
        fin_sales_label: "المبيعات",
        fin_kept_label: "ما احتفظت به",
        fin_of_sales: "من المبيعات",
        fin_card_kept_month: "ما احتفظت به هذا الشهر",
        fin_card_kept_period: "ما احتفظت به في هذه الفترة",
        fin_card_per100: "لكل 100 ريال مبيعات، احتفظت بـ",
        fin_card_revenue: "إجمالي المبيعات",
        fin_card_cost: "إجمالي المصروفات",
        fin_vs_last_month: "عن الشهر الماضي",
        fin_pts: "نقطة",
        fin_profit_word: "ربح",
        fin_loss_word: "خسارة",
        fin_leaderboard_title: "ترتيب الفروع",
        fin_leaderboard_sub: "من الأعلى ربحاً إلى الأكثر خسارة",
        fin_losing_tag: "تخسر — تصرف أكثر مما تكسب",
        fin_selected: "محدد",
        fin_tap_branch: "اضغط على فرع لعرض تفاصيله",
        fin_expenses_title: "وجهة المصروفات",
        fin_expenses_sub: "إلى أين يذهب كل ريال من المصروفات",
        fin_key_drain: "أكبر استنزاف",
        fin_trend_title: "اتجاه الربح",
        fin_trend_sub: "صافي الربح عبر الأشهر",
        fin_partial_not_final: "الأشهر الجزئية ليست نهائية",
        fin_badge_ramadan: "رمضان",
        fin_insights_title: "ملخص سريع",
        fin_see_details: "عرض التفاصيل الكاملة",
        fin_hide_details: "إخفاء التفاصيل",
        fin_best_month: "أفضل شهر",
        fin_top_branch: "أعلى فرع ربحاً",
        fin_this_month: "هذا الشهر",
        fin_this_period: "في هذه الفترة",
        fin_insight_commission: "عمولة التطبيقات أخذت",
        fin_insight_branch_lost_one: "فرع واحد خسر",
        fin_insight_branches_lost: "فروع خسرت",
        fin_riyal: "ريال",

        fa_tab_pnl: "قائمة الدخل",
        fa_tab_analytics: "التحليلات المالية",
        fa_title: "التحليلات المالية",
        fa_subtitle: "نظرة عامة على المالية من نظام ERP في لمحة",
        fa_kpi_revenue: "الإيرادات",
        fa_kpi_expenses: "المصروفات",
        fa_kpi_net_profit: "صافي الربح",
        fa_kpi_margin: "هامش الربح",
        fa_metrics_title: "مؤشرات محسوبة",
        fa_metric_margin: "هامش الربح",
        fa_metric_margin_hint: "صافي الربح ÷ الإيرادات",
        fa_metric_expense_ratio: "نسبة المصروفات إلى الإيرادات",
        fa_metric_expense_ratio_hint: "إجمالي المصروفات ÷ الإيرادات",
        fa_expense_title: "توزيع المصروفات",
        fa_expense_sub: "حسب الفئة، الأكبر أولاً",
        fa_expense_of_total: "من الإجمالي",
        fa_lines: "بند",
        fa_empty_title: "لا توجد بيانات تحليلية بعد",
        fa_empty_hint: "ستظهر التحليلات المالية هنا بعد استيراد الملف المالي من نظام ERP.",
        fa_load_error: "تعذّر تحميل التحليلات المالية",
        fa_retry: "إعادة المحاولة",

        fa_cash_title: "النقد المتوفر",
        fa_cash_sub: "حسابات النقد والبنوك، الأعلى رصيداً أولاً",
        fa_cash_total: "إجمالي النقد المتوفر",
        fa_cash_empty: "لا توجد حسابات نقدية بعد",
        fa_cash_empty_hint: "ستظهر أرصدة النقد والبنوك هنا بعد استيراد بيانات النقد.",
        fa_receivables_title: "أعمار الذمم المدينة",
        fa_receivables_sub: "المستحقات حسب فئة العمر (بالأيام)",
        fa_receivables_total: "إجمالي الذمم المدينة المستحقة",
        fa_receivables_empty: "لا توجد ذمم مدينة بعد",
        fa_receivables_empty_hint: "ستظهر أعمار الذمم وأكبر المدينين هنا بعد استيراد البيانات.",
        fa_top_debtors: "أكبر المدينين",
        fa_aging_older: "أقدم",

        fa_fcv_title: "تباين تكلفة الطعام",
        fa_fcv_intro: "نسبة تكلفة الطعام الفعلية لكل فرع مقابل التكلفة النظرية للوصفات. الفروع التي تتجاوز النسبة النظرية تتسرّب أموالها.",
        fa_fcv_company: "تكلفة الطعام للشركة",
        fa_fcv_baseline: "النسبة النظرية المرجعية",
        fa_fcv_col_branch: "الفرع",
        fa_fcv_col_revenue: "الإيرادات (ريال)",
        fa_fcv_col_food: "تكلفة الطعام (ريال)",
        fa_fcv_col_food_pct: "نسبة تكلفة الطعام",
        fa_fcv_col_excess: "الفائض (ريال)",
        fa_fcv_empty: "لا توجد بيانات تباين تكلفة الطعام بعد",
        fa_fcv_empty_hint: "سيظهر تباين تكلفة الطعام لكل فرع هنا بعد استيراد البيانات.",

        qc_title: "الجودة - الهدر",
        qc_subtitle: "سجّل زيارة وزن واطّلع على هدر المكوّنات.",
        qc_record_title: "تسجيل زيارة",
        qc_branch: "الفرع",
        qc_branch_ph: "اختر الفرع",
        qc_visit_date: "تاريخ الزيارة",
        qc_pick_date: "اختر التاريخ",
        qc_received: "المُستلم منذ آخر زيارة",
        qc_weighed: "الوزن الآن (المتبقي)",
        qc_ingredient: "المكوّن",
        qc_unit: "الوحدة",
        qc_save: "حفظ الزيارة",
        qc_saving: "جارٍ الحفظ…",
        qc_save_success: "تم حفظ الزيارة",
        qc_save_error: "تعذّر حفظ الزيارة",
        qc_select_branch_first: "اختر فرعاً وتاريخاً للبدء.",
        qc_past_visits: "عرض زيارة سابقة",
        qc_past_visits_ph: "اختر زيارة",
        qc_no_visits: "لا توجد زيارات سابقة",
        qc_result_title: "نتيجة الهدر",
        qc_no_result: "احفظ زيارة أو اختر واحدة سابقة لعرض الهدر.",
        qc_load_error: "تعذّر تحميل النتيجة",
        qc_baseline: "تم تسجيل الزيارة الأولى — تحدد المخزون الافتتاحي. سيظهر الهدر من الزيارة التالية.",
        qc_period: "الفترة",
        qc_days: "يوم",
        qc_gaps_warn: "بيانات المبيعات ناقصة لهذه الأيام — الهدر غير مكتمل:",
        qc_col_opening: "افتتاحي",
        qc_col_received: "مُستلم",
        qc_col_should: "المفترض استهلاكه",
        qc_col_closing: "الختامي (موزون)",
        qc_col_waste: "الهدر",
        qc_col_waste_pct: "نسبة الهدر",
        qc_check_entry: "تحقق من الإدخال",
        qc_summary_cheese: "إجمالي هدر الأجبان",
        qc_summary_falafel: "هدر الفلافل",
        qc_summary_drinks: "هدر المشروبات",
        qc_kg: "كجم",
        qc_bottles: "حبة",

        nav_sales_sync: "مزامنة المبيعات",
        nav_backups: "النسخ الاحتياطية",
        ss_col_recon: "مطابقة الفروع",
        ss_recon_ok: "مطابق",
        ss_recon_off: "غير مطابق",
        ss_recon_zero: "بدون بيع:",
        ss_recon_branches: "مجموع الفروع (فواتير)",
        ss_recon_network: "إجمالي الشبكة (فواتير)",
        budget_actual_mtd: "حتى تاريخه",
        sc_mtd_through: "البيانات حتى",
        sc_mtd_note: "الشهر غير مكتمل — المقارنات مع الشهر السابق والعام السابق تظهر «—» حتى يكتمل",
        bkpi_note_partial_month: "حتى تاريخه — الشهر لم يكتمل بعد",
        bkpi_note_disc_not_in_daily: "الخصومات غير متوفرة في التقرير اليومي",
        bkpi_note_order_days_incomplete: "عدد الطلبات اليومي لم يُسحب لكل أيام هذا الشهر بعد",
        bkpi_mtd_through: "البيانات حتى",
        period_month_no_data: "هذا الشهر لم تُرفع بياناته بعد — يمكنك اختياره وستوضح البطاقات السبب",
        period_month_pending: "لم يُرفع",
        tile_targets_partial: "بعض الفروع بلا مستهدف — لا تُحتسب نسبة للشركة",
        tile_partial_mark: "جزئي",
        tile_partial_short: "لم تكتمل أيام الشهر بعد",
        tile_partial_reason: "بعض أيام هذا الشهر لم تُسحب بعد، لذلك لا تُقارن بالمستهدف",
        nav_hr_integration: "ربط الموارد البشرية",
        hr_ev_title: "ربط منصّة الموارد البشرية",
        hr_ev_subtitle: "إرسال صور وفيديوهات الأدلّة إلى منصّة الموارد البشرية بدلاً من رابط لا يستطيع مدير الموارد البشرية فتحه.",
        hr_ev_not_configured: "الربط غير مُهيّأ في هذه البيئة (HR_API_BASE_URL / HR_INTEGRATION_TOKEN). الملفات تنتظر في الطابور وستُرسل تلقائياً بعد التهيئة.",
        hr_ev_truth_title: "ما تملكه منصّة الموارد البشرية فعلياً",
        hr_ev_truth_desc: "هذه الأرقام مقروءة من منصّة الموارد البشرية نفسها، لا من سجلاتنا — حتى لا يختلف الطرفان عند فقدان أي عملية إرسال.",
        hr_ev_held: "مخالفات لديها الأدلّة",
        hr_ev_waiting: "بانتظار الأدلّة",
        hr_ev_unknown: "لم تصل إليهم",
        hr_ev_unknown_hint: "المخالفة نفسها لم تُستلم — يُعاد إرسالها تلقائياً.",
        hr_ev_never_checked: "لم يتم التحقق بعد",
        hr_ev_never_checked_hint: "اضغط «تحقّق من منصّة الموارد البشرية».",
        hr_ev_last_checked: "آخر تحقّق",
        hr_ev_violations_sent: "مخالفات مُرسلة",
        hr_ev_queue_title: "طابور إرسال الملفات",
        hr_ev_delivered: "ملفات تم تسليمها",
        hr_ev_in_queue: "في الطابور",
        hr_ev_retrying: "يُعاد المحاولة",
        hr_ev_blocked: "مرفوضة",
        hr_ev_blocked_hint: "نوع غير مدعوم، أو أكبر من حد الموارد البشرية (صور ٢٥ م.ب / فيديو ١٥٠ م.ب)، أو أكثر من ١٠ ملفات.",
        hr_ev_errors_title: "آخر الأخطاء",
        hr_ev_clips_title: "أحجام مقاطع المراقبة",
        hr_ev_clips_desc: "أرقامنا الحقيقية — طلبتها منصّة الموارد البشرية لتحديد حد الرفع لديها بدقّة.",
        hr_ev_clips_video: "مقاطع فيديو",
        hr_ev_clips_photo: "صور",
        hr_ev_median: "الوسيط",
        hr_ev_max: "الأكبر",
        hr_ev_over_cap: "أكبر من الحد",
        hr_ev_cap: "حد الموارد البشرية",
        hr_ev_no_files: "لا توجد ملفات",
        hr_ev_limits: "حدود منصّة الموارد البشرية: {files} ملفات لكل مخالفة · الصور {mb} م.ب · الفيديو {vmb} م.ب. المقطع الأكبر من الحد يُرسل كمقتطف أقصر.",
        hr_ev_send_now: "إرسال الآن",
        hr_ev_check_with_hr: "تحقّق من منصّة الموارد البشرية",
        hr_ev_sent_toast: "{n} ملف في قائمة الإرسال — سيرسلها العامل في الخلفية قريبًا.",
        hr_ev_send_confirm_title: "إرسال الأدلة إلى الموارد البشرية الآن؟",
        hr_ev_send_confirm_body: "تُجهَّز ملفات كل مخالفة سبق إرسالها، وتُعاد الملفات التي استنفدت محاولاتها إلى قائمة الانتظار. يرسلها العامل في الخلفية ملفًا ملفًا خلال دقائق — يمكنك مغادرة الصفحة.",
        hr_ev_check_confirm_title: "التحقّق من منصّة الموارد البشرية؟",
        hr_ev_check_confirm_body: "نسأل منصّة الموارد البشرية عمّا تحتفظ به فعلاً. أي مخالفة لا تجدها المنصّة تُرسَل مرة أخرى، وأي مرفقات ناقصة لديها تعود إلى قائمة الإرسال.",
        hr_ev_checked_toast: "تم التحقق من {n} مخالفة، {w} بحاجة إلى إعادة إرسال.",
        hr_ev_connection: "حالة الاتصال",
        hr_ev_online: "متصل",
        hr_ev_offline: "غير متصل",
        nav_data_audit: "تدقيق البيانات",
        tile_no_data_reason: "لم تصل بيانات هذا اليوم من نقاط البيع بعد",
        bkpi_no_data_reason: "لم يصل هذا المؤشر من نقاط البيع لهذه الفترة",
        budget_actual_missing: "لم تصل مبيعات هذا الشهر بعد",

        da_title: "تدقيق تناسق البيانات",
        da_subtitle: "هل كل بطاقة في النظام مغذّاة بالبيانات؟ وهل نفس الرقم متطابق في كل مكان؟ لا أرقام مُختلقة — فقط ما هو موجود فعلًا.",
        da_load_failed: "تعذّر تحميل التدقيق",
        da_coverage_loading: "يُحسب جدول التغطية — قد يستغرق بضع ثوانٍ",
        da_cleaned: "تم التنظيف — عدد الصفوف المحذوفة",
        da_fix_failed: "تعذّر التنظيف",
        da_fix_confirm_title: "تنظيف هذه الصفوف؟",
        da_fix_confirm_body: "سيُحذف {n} صف من {coll}.",
        da_fix_quarantine_note: "تُنسخ كل الصفوف أولًا إلى سجل الحجر (data_audit_quarantine) مع رقم العملية، ثم تُحذف هذه الصفوف بعينها فقط.",
        da_fix_sample: "عيّنة (حتى ٥ صفوف)",
        da_fix_confirm_action: "احذف {n} صف",
        da_fix_quarantined: "نُسخت إلى الحجر — رقم العملية",
        da_cards_with_data: "بطاقات مكتملة",
        da_cards_partial: "بطاقات ناقصة",
        da_cards_empty: "بطاقات فارغة",
        da_checks_passed: "تحققات ناجحة",
        da_checks_failed: "تحققات فاشلة",
        da_backfill_running: "السحب التاريخي جارٍ الآن عند تاريخ",
        da_tab_cards: "البطاقات",
        da_tab_checks: "تطابق الأرقام",
        da_tab_coverage: "التغطية",
        da_tab_anomalies: "شوائب البيانات",
        da_page_ops_dashboard: "لوحة العمليات",
        da_page_sales: "المبيعات",
        da_page_pos_insights: "تحليلات نقاط البيع",
        da_page_financials: "المالية",
        da_page_qc: "الجودة",
        da_st_complete: "مكتملة",
        da_st_partial: "ناقصة",
        da_st_missing: "فارغة",
        da_st_pass: "متطابق",
        da_st_fail: "غير متطابق",
        da_st_skipped: "غير قابل للمقارنة",
        da_open: "افتح",
        da_checks_hint: "يُحتسب نفس الرقم من كل مصدر مستقل ثم يُقارن. لا يُنفَّذ التحقق إلا إذا كان الشهر مكتمل التغطية من الطرفين — الشهر الناقص لا يُنتج علامة خضراء أبدًا.",
        da_dataset: "مجموعة البيانات",
        da_no_anomalies: "لا توجد شوائب — البيانات نظيفة",
        da_clean_up: "تنظيف",
        da_review: "يحتاج مراجعة",

        dg_btn_not_pulled_yet: "متابعة السحب",
        dg_btn_month_in_progress: "متابعة السحب",
        dg_btn_pulled_but_empty: "افتح مزامنة المبيعات",
        dg_btn_needs_erp_upload: "رفع ملف ERP",
        dg_btn_needs_monthly_import: "افتح حالة الاستيراد",
        dg_btn_needs_user_input: "إدخال المستهدفات",
        dg_btn_no_activity: "ابدأ الآن",
        dg_btn_no_activity_ever: "ابدأ الآن",
        dg_btn_undefined: "افتح",
        dg_btn_null: "افتح",
        backups_title: "النسخ الاحتياطية للبيانات",
        backups_subtitle: "تُصدَّر جميع مجموعات قاعدة البيانات إلى تخزين Cloudflare R2 تلقائيًا كل يوم عند الساعة ٣ صباحًا (توقيت الرياض). الكتابة تراكمية فقط — لا حذف ولا استبدال.",
        backups_run_now: "تشغيل النسخ الاحتياطي الآن",
        backups_running: "جارٍ التنفيذ…",
        backups_last_runs: "آخر ٧ عمليات",
        backups_col_folder: "المجلد",
        backups_col_date: "التاريخ",
        backups_col_status: "الحالة",
        backups_col_trigger: "المُشغِّل",
        backups_col_started: "بدأت في",
        backups_col_ok: "ناجحة",
        backups_col_failed: "فاشلة",
        backups_col_docs: "المستندات",
        backups_col_size: "الحجم",
        backups_status_ok: "مكتملة",
        backups_status_partial: "جزئية",
        backups_status_failed: "فشلت",
        backups_status_running: "قيد التنفيذ",
        backups_trigger_manual: "يدوي",
        backups_trigger_scheduler: "مجدول",
        backups_empty: "لم تُنفَّذ أي عملية نسخ احتياطي بعد.",
        backups_run_success: "اكتمل النسخ الاحتياطي — تم حفظ {n} مجموعة.",
        backups_run_failed: "فشل النسخ الاحتياطي",
        backups_root_note: "المسار في R2:",
        backups_run_started: "بدأ النسخ الاحتياطي — يستغرق نحو ٧٠ دقيقة، وستتحدّث الصفحة تلقائيًا حتى ينتهي.",
        backups_active_note: "نسخ احتياطي قيد التنفيذ — تتحدّث الصفحة تلقائيًا. بدأ في",
        backups_confirm_title: "تشغيل النسخ الاحتياطي الآن؟",
        backups_confirm_body: "يُصدِّر جميع مجموعات قاعدة البيانات إلى R2 ويستغرق نحو ٧٠ دقيقة. يبقى التطبيق قابلًا للاستخدام خلال ذلك وقد يكون أبطأ قليلًا. النسخة المجدولة تعمل تلقائيًا كل يوم الساعة ٣ صباحًا.",
        backups_confirm_start: "ابدأ النسخ",
        ss_title: "مزامنة المبيعات",
        ss_subtitle: "اسحب بيانات المبيعات (الشبكة والفروع والأصناف ومركز الاتصال) من نظام نقاط البيع مباشرةً داخل المنصة — بدون أي إشارة مرجعية خارجية.",
        ss_how_title: "كيف تعمل",
        ss_how_1: "يسجّل الخادم الدخول إلى نظام نقاط البيع تلقائياً بمفتاح مؤمّن مخزّن — لا حاجة للإشارة المرجعية أو تسجيل دخولك.",
        ss_how_2: "يسحب مبيعات الشبكة والفروع والأصناف وطلبات مركز الاتصال لكل يوم في النطاق المحدد.",
        ss_how_3: "يعمل السحب في الخلفية مع تحديث التقدّم مباشرةً، ويعمل تلقائياً كل ليلة لسحب بيانات الأمس.",
        ss_mode_yesterday: "سحب الأمس",
        ss_mode_range: "سحب نطاق",
        ss_date_label: "التاريخ",
        ss_from: "من",
        ss_to: "إلى",
        ss_pick_date: "اختر التاريخ",
        ss_start: "ابدأ المزامنة",
        ss_running: "جارٍ المزامنة…",
        ss_stop: "إيقاف",
        ss_retry_skipped: "إعادة محاولة المتعثّرة",
        ss_branches_count: "16 فرعاً",
        ss_progress: "التقدّم",
        ss_current: "الحالي",
        ss_total: "الإجمالي",
        ss_synced: "تمت المزامنة",
        ss_skipped: "متعثّرة (سيُعاد)",
        ss_errors: "أخطاء",
        ss_col_date: "التاريخ",
        ss_col_branch: "الفرع",
        ss_col_status: "الحالة",
        ss_col_items: "الأصناف",
        ss_col_message: "ملاحظة",
        ss_status_pending: "بالانتظار",
        ss_status_pulling: "جارٍ السحب…",
        ss_status_pushing: "جارٍ الإرسال…",
        ss_status_done: "تم",
        ss_status_skipped: "متعثّر",
        ss_status_error: "خطأ",
        ss_skipped_throttle: "استجابة فارغة (تقييد المعدّل) — سيُعاد",
        ss_done_toast: "اكتملت المزامنة",
        ss_stopped_toast: "تم إيقاف المزامنة",
        ss_idle_hint: "اختر الوضع واضغط «ابدأ المزامنة» لبدء سحب البيانات.",
        ss_invalid_range: "نطاق تاريخ غير صالح",
        ss_cors_blocked: "نظام نقاط البيع رفض هذا الطلب من صفحة العمليات. لا يسمح نظام نقاط البيع بالسحب بين التبويبات. أبلغ المطوّر للتحويل إلى الطريقة البديلة.",
        ss_no_skipped: "لا توجد عناصر متعثّرة لإعادتها",
        ss_pull_title: "سحب البيانات",
        ss_incremental_title: "الأيام الناقصة فقط",
        ss_incremental_desc: "تخطَّ الأيام التي تم سحبها بالكامل مسبقاً واسحب الجديد فقط.",
        ss_days: "يوم",
        ss_state_running: "قيد التشغيل",
        ss_state_done: "اكتمل",
        ss_state_cancelled: "أُلغي",
        ss_state_failed: "فشل",
        ss_state_interrupted: "انقطع (أُعيد تشغيل الخادم)",
        ss_status_partial: "جزئي",
        ss_status_provisional: "مؤقت",
        ss_sum_branch_rows: "صفوف الفروع",
        ss_sum_item_days: "أيام الأصناف",
        ss_sum_cc_orders: "طلبات مركز الاتصال",
        ss_sum_partial: "أيام جزئية",
        ss_failures_title: "حالات فاشلة",
        ss_started_toast: "بدأ السحب في الخلفية",
        ss_start_failed: "تعذّر بدء السحب",
        ss_cancelling: "جارٍ الإلغاء…",
        ss_not_configured: "بيانات اعتماد نظام نقاط البيع غير مهيّأة على الخادم.",
        ss_connected: "متصل بنظام نقاط البيع",
        ss_nightly_note: "يعمل السحب التلقائي كل ليلة الساعة",
        ss_coverage_title: "التغطية",
        ss_last_sync: "آخر مزامنة",
        ss_cov_done: "أيام مكتملة",
        ss_cov_partial: "أيام جزئية",
        ss_cov_first: "أول يوم",
        ss_cov_last: "آخر يوم",
        ss_cov_empty: "لم تتم مزامنة أي يوم بعد.",
        ss_hist_title: "سحب السجل التاريخي",
        ss_hist_desc: "المصدر الوحيد لبيانات الفروع اليومية للأشهر السابقة. النطاق:",
        ss_hist_running: "قيد التشغيل",
        ss_hist_stalled: "متوقف — يحتاج إعادة تشغيل",
        ss_hist_paused: "متوقف مؤقتاً",
        ss_hist_complete: "مكتمل",
        ss_hist_stalled_hint: "توقف السحب بعد {n} محاولات متتالية دون تقدم، ولن يُستأنف تلقائياً. اضغط \"استئناف\" لمتابعته من حيث توقف.",
        ss_hist_other_run: "سحب آخر يعمل الآن — يُستأنف هذا السحب بعد انتهائه",
        ss_hist_progress: "التقدم",
        ss_hist_days_done: "أيام مكتملة",
        ss_hist_days_left: "أيام متبقية",
        ss_hist_eta: "الوقت المتوقع",
        ss_hist_last_try: "آخر محاولة",
        ss_hist_resume: "استئناف السحب",
        ss_hist_resumed: "تم الاستئناف — {n} يوم متبقٍ.",
        ss_col_pulled_at: "وقت السحب",
        ss_datasets_label: "نطاق البيانات",
        ss_ds_core: "الأساسي",
        ss_ds_deep: "التفصيلي",
        ss_ds_both: "الكل",
        ss_ds_hint: "الأساسي = إجماليات الفروع والأصناف ومركز الاتصال. التفصيلي = تفاصيل الفواتير والساعات والأصناف والفئات وأرشفة النسخة الخام في Cloudflare.",
        ss_sum_deep_orders: "فواتير مقروءة",
        ss_sum_deep_items: "صفوف أصناف",
        ss_sum_archived: "ملفات مؤرشفة",
        ss_cov_deep_done: "أيام تفصيلية مكتملة",
        ss_cov_deep_partial: "أيام تفصيلية جزئية",
        ss_cov_provisional: "أيام مؤقتة (يُعاد سحبها)",
        ss_pulled_early: "سُحب قبل اكتمال اليوم — قد تكون البيانات ناقصة",
        ss_read_only: "عرض فقط — بدء المزامنة وإيقافها واستئنافها متاح لمدير النظام الأعلى فقط.",
        ss_col_deep: "التفصيلي",
        ss_masters_title: "بيانات أساسية من نقاط البيع",
        ss_stage: "المرحلة",
        ss_stage_core: "الأساسي",
        ss_stage_deep: "التفصيلي",
        ss_stage_masters: "البيانات الأساسية",

        pi_tab: "تحليلات نقاط البيع",
        pi_title: "تحليلات نقاط البيع",
        pi_subtitle: "كل ما يمكن سحبه من نظام نقاط البيع: الفواتير والساعات والأصناف والكميات والفئات وتطبيقات التوصيل وطرق الدفع والكاشيرات والأجهزة.",
        pi_preset_7: "آخر 7 أيام",
        pi_preset_30: "آخر 30 يوم",
        pi_preset_month: "هذا الشهر",
        pi_from: "من",
        pi_to: "إلى",
        pi_branch_all: "كل الفروع",
        pi_kpi_transactions: "عدد الفواتير",
        pi_kpi_avg_ticket: "متوسط الفاتورة",
        pi_kpi_gross: "إجمالي المبيعات",
        pi_kpi_in_store: "مبيعات الفرع",
        pi_kpi_apps: "تطبيقات التوصيل",
        pi_kpi_discounts: "الخصومات",
        pi_kpi_waste: "الهالك (تالف)",
        pi_kpi_vat: "ضريبة القيمة المضافة",
        pi_kpi_items_qty: "الكمية المبيعة",
        pi_vs_prev: "مقارنة بالفترة السابقة",
        pi_tab_hourly: "الساعات",
        pi_tab_items: "الأصناف والكميات",
        pi_tab_categories: "الفئات",
        pi_tab_channels: "القنوات والدفع",
        pi_tab_staff: "الكاشير والأجهزة",
        pi_tab_data: "البيانات والتغطية",
        pi_tab_cashier_check: "متوسط فاتورة الكاشير",
        pi_cc_title: "متوسط فاتورة الكاشير (طلبات الكاونتر)",
        pi_cc_desc: "الطلبات المدفوعة سفري أو محلي التي أدخلها الكاشير، بلا طلبات التطبيقات والتوصيل ومركز الاتصال والتالف، وبلا البيع الذي أُرجع أو أُتلف لاحقًا",
        pi_cc_period: "الشهر",
        pi_cc_base: "مقارنةً بـ",
        pi_cc_export: "تصدير Excel",
        pi_cc_exported: "تم تنزيل الملف",
        pi_cc_export_failed: "تعذّر التصدير",
        pi_cc_load_failed: "تعذّر تحميل متوسط فاتورة الكاشير",
        pi_cc_cashier: "الكاشير",
        pi_cc_counter_orders: "طلبات الكاونتر",
        pi_cc_counter_avg: "متوسط الكاونتر",
        pi_cc_change: "التغيّر (ر.س)",
        pi_cc_share: "نسبة الكاونتر من طلباته",
        pi_cc_all_avg: "متوسط كل طلباته",
        pi_cc_small: "عينة صغيرة",
        pi_cc_small_hint: "عينة صغيرة = أقل من {n} طلب كاونتر في أحد الشهرين، فلا يُعتمد التغيّر وحده",
        pi_cc_branch_avg: "متوسط الكاونتر للفرع",
        pi_cc_missing_days: "أيام بلا تفصيل الطلبات",
        pi_cc_backfill: "آخر تحديث لتفصيل الطلبات",
        pi_cc_page_title: "متوسط فاتورة الكاشير",
        pi_cc_daily_title: "الملفات اليومية",
        pi_cc_daily_hint: "يُحفظ ملف كل صباح بعد اكتمال سحب نقاط البيع: من أول الشهر حتى أمس مقابل الشهر السابق، لكل الفروع",
        pi_cc_daily_none: "لم يُحفظ أي ملف بعد",
        pi_cc_daily_partial: "غير مكتمل",
        pi_cc_daily_more: "عرض الكل",
        pi_cc_daily_less: "عرض أقل",
        pi_cc_daily_failed: "تعذّر تنزيل الملف",
        perm_cap_group_cashier_check: "متوسط فاتورة الكاشير",
        pi_cc_backfill_none: "لم يكتمل بعد، يتحدّث تلقائيًا",
        pi_cc_partial_days: "أيام تفصيلها أقل من إجمالي نقاط البيع",
        pi_cc_open_reversals: "مرتجعات لم تُنسب إلى بيعها بعد",
        pi_cc_voided: "أُرجعت لاحقًا",
        pi_cc_voided_hint: "مبيعات هذا الكاشير التي أرجعتها نقاط البيع أو أتلفتها لاحقًا (قيد ارتجاع)، ولا تدخل في متوسطه",
        pi_cc_no_data: "لا توجد طلبات لهذا الفرع في الشهرين",
        pi_hourly_title: "المبيعات بحسب الساعة",
        pi_hourly_desc: "إجمالي الفواتير والمبيعات لكل ساعة خلال الفترة",
        pi_heatmap_title: "خريطة الفروع × الساعات",
        pi_heatmap_desc: "كثافة المبيعات لكل فرع خلال ساعات اليوم",
        pi_peak_hour: "ساعة الذروة",
        pi_items_title: "الأصناف المبيعة",
        pi_items_desc: "الكمية والإيراد لكل صنف (من تقرير الأصناف في نقاط البيع)",
        pi_items_search: "ابحث عن صنف…",
        pi_sort_revenue: "ترتيب بالإيراد",
        pi_sort_qty: "ترتيب بالكمية",
        pi_sort_name: "ترتيب بالاسم",
        pi_col_item: "الصنف",
        pi_col_category: "الفئة",
        pi_col_qty: "الكمية",
        pi_col_revenue: "الإيراد",
        pi_col_avg_price: "متوسط السعر",
        pi_col_days: "أيام",
        pi_col_orders: "الفواتير",
        pi_col_total: "الإجمالي",
        pi_col_branch: "الفرع",
        pi_col_hour: "الساعة",
        pi_col_share: "النسبة",
        pi_menu_cats: "فئات المنيو",
        pi_recipe_cats: "فئات الأصناف",
        pi_apps_title: "تطبيقات التوصيل",
        pi_apps_desc: "الطلبات والإيراد ورسوم التوصيل لكل تطبيق",
        pi_col_delivery_fee: "رسوم التوصيل",
        pi_col_paid: "مدفوع",
        pi_col_unpaid: "غير مدفوع",
        pi_order_types: "أنواع الطلبات",
        pi_payments: "طرق الدفع",
        pi_pay_states: "حالة الدفع",
        pi_cashiers: "الكاشيرات",
        pi_terminals: "أجهزة نقاط البيع",
        pi_delivery_men: "مندوبو التوصيل",
        pi_shifts: "ورديات نقاط البيع",
        pi_coverage_title: "تغطية البيانات",
        pi_coverage_days: "أيام بها بيانات",
        pi_coverage_missing: "أيام ناقصة",
        pi_recon_title: "مطابقة الأرقام",
        pi_recon_desc: "مقارنة مجموع الفواتير مع تقرير الإجماليات في نقاط البيع",
        pi_recon_checked: "أيام مطابَقة",
        pi_recon_mismatch: "فروقات",
        pi_recon_ok: "كل الأرقام مطابقة تماماً",
        pi_archived: "أيام مؤرشفة في Cloudflare",
        pi_masters_title: "بيانات نقاط البيع الأساسية",
        pi_masters_rows: "صفوف",
        pi_caps_title: "ما يوفّره نظام نقاط البيع",
        pi_caps_available: "متاح ومسحوب",
        pi_caps_missing: "غير متاح في واجهة نقاط البيع",
        pi_empty_title: "لا توجد بيانات تفصيلية لهذه الفترة",
        pi_empty_hint: "شغّل «مزامنة المبيعات» بنطاق «التفصيلي» لسحب تفاصيل الفواتير والأصناف لهذه الأيام.",
        pi_no_branches: "لا توجد فروع متاحة لحسابك.",
        pi_avg_ticket_short: "م.الفاتورة",


        cc_tab_sales: "المبيعات",
        cc_tab_call_center: "مركز الاتصال",
        cc_title: "مركز الاتصال",
        cc_subtitle: "أداء طلبات مركز الاتصال خلال الفترة المحددة",
        cc_preset_7: "آخر 7 أيام",
        cc_preset_30: "آخر 30 يوم",
        cc_kpi_revenue: "إيرادات مركز الاتصال",
        cc_kpi_orders: "عدد الطلبات",
        cc_kpi_aov: "متوسط قيمة الطلب",
        cc_revenue_note: "طلبات مركز الاتصال جزء من إجمالي المبيعات وليست إضافية.",
        cc_delivery_title: "صحة رسوم التوصيل",
        cc_delivery_sub: "هذا هو المجال الذي يحتاج إلى متابعة",
        cc_delivery_total: "إجمالي رسوم التوصيل المُحصّلة",
        cc_delivery_avg: "متوسط رسوم التوصيل",
        cc_delivery_warn_pre: "متوسط رسوم التوصيل",
        cc_delivery_warn_post: "لكل طلب — راجِع الفروع ذات تحصيل التوصيل المنخفض.",
        cc_unpaid_label: "غير مدفوع",
        cc_orders_word: "طلب",
        cc_all_paid: "كل الطلبات مدفوعة",
        cc_by_branch_title: "حسب الفرع",
        cc_top_agents_title: "أفضل الموظفين",
        cc_agents_title: "أداء الموظفين",
        cc_no_agents: "لا توجد طلبات مسجّلة لأي موظف في هذه الفترة.",
        cc_col_avg_invoice: "متوسط الفاتورة",
        cc_col_aov: "متوسط الطلب",
        cc_col_delivery: "التوصيل",
        cc_col_agent: "الموظف",
        cc_low_delivery: "توصيل منخفض",
        cc_empty: "لا توجد بيانات لمركز الاتصال في هذه الفترة",
        cc_error: "تعذّر تحميل ملخص مركز الاتصال",
    },
    en: {
        app_name: "Operations",
        app_short: "Ops",
        company: "Alshallal Restaurants",

        login_title: "Sign in",
        login_subtitle: "Enter your account credentials to access the Operations platform",
        login_identifier: "Email or National ID",
        login_identifier_ph: "name@shallal.sa / 10 digits",
        login_password: "Password",
        login_submit: "Sign in",
        login_submitting: "Signing in...",
        login_error: "Invalid credentials",

        nav_administration: "Administration",
        nav_users: "Users",
        nav_branches: "Branches",
        coming_soon: "Coming soon",
        coming_soon_tip: "This tab is under development and will be available later",

        logout: "Sign out",
        role_super_admin: "Super Admin",
        role_user: "User",
        role_inspector: "Inspector",
        role_branch_manager: "Branch Manager",
        role_quality_manager: "Quality Manager",
        role_qc_supervisor: "QC Supervisor",
        role_ops_manager: "Operations Manager",
        role_warehouse_manager: "Warehouse Manager",
        role_kitchen_manager: "Kitchen Manager",
        role_maintenance_manager: "Maintenance Manager",
        role_call_center_manager: "Call Center Manager",
        role_complaints_manager: "Complaints Manager",
        role_it_admin: "IT Admin",
        perm_ops_manager_note: "Operations Manager has read-write access to ALL modules (Sales, Financials, Quality, and every future module). They do NOT manage users or infrastructure (branches/backups/ingest).",
        perm_warehouse_manager_note: "Warehouse Manager is limited to the Warehouse module only. No Sales, Financials, or Quality access.",
        perm_kitchen_manager_note: "Kitchen Manager is limited to the Kitchen / Production module only. No Sales, Financials, or Quality access.",
        perm_maintenance_manager_note: "Maintenance Manager is limited to the Maintenance module only. No Sales, Financials, or Quality access.",
        perm_call_center_manager_note: "Call Center Manager is limited to the Call Center module only. No Sales, Financials, or Quality access.",
        perm_complaints_manager_note: "Complaints Manager is limited to the Complaints module only — which is entirely separate from QC Quality. No Quality, Sales, or Financials data.",
        perm_it_admin_note: "IT Admin is an infrastructure role: sees Ingest Status, Backups, and Sync logs only. Never any sales figures or financial data, and no user administration.",
        role_cctv_monitor: "CCTV Monitor",
        role_cctv_manager: "CCTV Manager",
        perm_cctv_monitor_note: "CCTV Monitor creates and edits only their own findings and can resubmit a returned one. Sees only their own findings; cannot dispatch to the Operations Manager.",
        perm_cctv_manager_note: "CCTV Manager sees all monitors' findings, is the ONLY role that can dispatch a finding to the Operations Manager, and can reject it back to the monitor with a reason. Does not approve findings.",
        cctv_title: "CCTV Monitoring",
        cctv_subtitle: "Findings management with an internal approval chain",
        cctv_new_finding: "New finding",
        cctv_no_findings: "No findings",
        cctv_no_findings_hint: "No findings match the current filters yet.",
        cctv_filter_branch: "Branch",
        cctv_filter_category: "Category",
        cctv_filter_status: "Status",
        cctv_filter_date: "Date",
        cctv_all: "All",
        cctv_col_branch: "Branch",
        cctv_col_incident: "Incident",
        cctv_col_category: "Category",
        cctv_col_employee: "Employee",
        cctv_col_status: "Status",
        cctv_col_evidence: "Evidence",
        cctv_col_updated: "Updated",
        cctv_status_draft: "Draft",
        cctv_status_submitted: "Submitted",
        cctv_status_with_ops: "With Ops",
        cctv_status_ops_approved: "Approved",
        cctv_status_returned_to_monitor: "Returned",
        cctv_cat_behavior: "Behavior",
        cctv_cat_quality: "Quality",
        cctv_cat_safety: "Safety",
        cctv_cat_cleanliness: "Cleanliness",
        cctv_cat_theft: "Theft",
        cctv_cat_other: "Other",
        cctv_f_branch: "Branch",
        cctv_f_date: "Incident date",
        cctv_f_day: "Day",
        cctv_f_time: "Time",
        cctv_f_category: "Category",
        cctv_f_category_other: "Category label",
        cctv_f_description: "Description",
        cctv_f_employee: "Employee (optional)",
        cctv_f_category_other_ph: "Type the category",
        cctv_f_description_ph: "Describe what was observed on camera",
        cctv_emp_loading: "Loading employees…",
        cctv_emp_none: "No employee",
        cctv_emp_unmapped: "Branch not mapped to HR",
        cctv_emp_unconfigured: "HR integration not configured",
        cctv_emp_unreachable: "HR unreachable",
        cctv_emp_pick: "Select an employee",
        cctv_employee_id_note: "Employee must be picked from the list",
        cctv_evidence: "Evidence",
        cctv_evidence_hint: "Photo and/or video",
        cctv_add_evidence: "Add evidence",
        cctv_uploading: "Uploading…",
        cctv_upload_failed: "Upload failed",
        cctv_no_evidence: "No evidence",
        cctv_photo: "Photo",
        cctv_video: "Video",
        cctv_delete_evidence: "Delete",
        cctv_evidence_required_dispatch: "Cannot dispatch to Ops without at least one evidence file",
        cctv_max_note: "Video up to 200MB, photo up to 15MB",
        cctv_hr_clip_too_big: "This clip is over {mb} MB and the HR platform cannot play it — the violation would reach them visible but unwatchable. Upload a shorter excerpt around the incident instead (the full recording stays here).",
        cctv_hr_not_playable: "Not playable in HR",
        cctv_upload_note_timeout: "Files upload in 8MB chunks so the browser never times out",
        cctv_save_first: "Save the finding first to attach evidence",
        cctv_save_draft: "Save draft",
        cctv_saved: "Saved",
        cctv_submit: "Submit",
        cctv_action_done: "Done",
        cctv_edit_btn: "Edit",
        cctv_delete_btn: "Delete finding",
        cctv_delete_confirm_title: "Delete this finding?",
        cctv_delete_confirm_desc: "This permanently deletes the finding and all its evidence. This action cannot be undone.",
        cctv_delete_ok: "Delete permanently",
        cctv_deleted: "Finding deleted",
        cctv_dispatch: "Dispatch to Ops",
        cctv_approve: "Approve",
        cctv_reject: "Return to monitor",
        cctv_reject_reason: "Return reason",
        cctv_reject_reason_ph: "State the reason for returning (required)",
        cctv_history: "Action history",
        cctv_by: "by",
        cctv_reason: "Reason",
        cctv_ev_create: "Created",
        cctv_ev_submit: "Submitted",
        cctv_ev_dispatch_to_ops: "Dispatched to Ops",
        cctv_ev_approve: "Approved",
        cctv_ev_reject: "Returned",
        cctv_ev_escalate_to_hr: "Escalated to HR",
        cctv_ev_severity_change: "Severity changed",
        cctv_ev_branch_change: "Moved to another branch",
        cctv_f_severity: "Severity",
        cctv_filter_severity: "Severity",
        cctv_approve_severity: "Approval severity",
        cctv_severity_hint: "The monitor proposes severity at creation; the Ops Manager can adjust it at approval",
        cctv_sev_low: "Low",
        cctv_sev_medium: "Medium",
        cctv_sev_high: "High",
        cctv_sev_critical: "Critical",
        cctv_hr_push_title: "HR",
        cctv_hr_push_queued: "HR: queued",
        cctv_hr_push_sent: "HR: sent",
        cctv_hr_push_failed: "HR: failed",
        cctv_hr_push_none: "No employee — not escalated to HR",
        cctv_view: "View",
        cctv_edit: "Edit",
        cctv_last_reason: "Return reason",
        cctv_detail: "Finding detail",
        cctv_description_required: "Description is required",
        cctv_reason_required: "A return reason is required",
        ops_tile_cctv: "CCTV",
        nav_infrastructure: "Infrastructure",
        nav_ingest_status: "Ingest Status",
        sys_ingest_title: "Ingest Status & System Health",
        sys_ingest_subtitle: "External ingest sources, the internal event log, and the metric catalog",
        sys_sources_title: "Ingest Sources",
        sys_sources_desc: "Latest ingest health per external source (POS / ERP P&L / Bitfil)",
        sys_col_source: "Source",
        sys_col_configured: "Config",
        sys_col_status: "Status",
        sys_col_last_run: "Last run",
        sys_col_runs: "OK / Failed",
        sys_col_error: "Last error",
        sys_configured: "Configured",
        sys_not_configured: "Not configured",
        sys_status_ok: "OK",
        sys_status_failed: "Failed",
        sys_status_never: "Never run",
        sys_events_title: "Event Log (Alert Bus)",
        sys_events_desc: "Events emitted by modules through the internal alert bus",
        sys_events_empty: "No events yet",
        sys_event_voided: "Voided",
        sys_rc_title: "Recompute late closes (midnight fix)",
        sys_rc_desc: "Recomputes stored close times with the corrected rule. Preview writes nothing.",
        sys_rc_preview: "Preview",
        sys_rc_apply: "Apply",
        sys_rc_scanned: "Close records",
        sys_rc_changed: "Will change",
        sys_rc_late_on_time: "Late → on time",
        sys_rc_late_early: "Late → early close",
        sys_rc_events: "Alerts to flag void",
        sys_rc_over_6h: "Over 6 h from schedule (re-check with the branch)",
        sys_rc_report: "Report",
        sys_rc_last: "Last applied",
        sys_rc_last_counts: "{n} records recomputed, {m} alerts flagged void",
        sys_rc_last_none: "No recompute has been applied yet.",
        sys_rc_nothing: "Nothing to apply — the records are up to date.",
        sys_rc_confirm_title: "Apply the recompute?",
        sys_rc_confirm_desc: "{n} close records will be recomputed and {m} alerts flagged void. The old values are kept on each record, and no alert is deleted.",
        sys_rc_applied: "Applied: {n} records recomputed, {m} alerts flagged void.",
        sys_col_event: "Event",
        sys_col_payload: "Payload",
        sys_col_time: "Time",
        sys_test_emit: "Emit test event",
        sys_emit_success: "Test event emitted",
        sys_test_emit_confirm: "A system.test_emit test event will be added to the event log and recorded in the audit log. No alert or notification is sent.",
        sys_metrics_title: "Metric Catalog",
        sys_metrics_desc: "Operational metrics computed by the unified metric service",
        budget_tab: "Budget vs Actual",
        budget_title: "Budget vs Actual",
        budget_subtitle: "Monthly sales targets per branch compared to actual revenue",
        budget_import_targets: "Import targets",
        budget_import_title: "Import Sales Targets",
        budget_import_desc: "Upload a CSV with columns: branch, month, target",
        budget_csv_format: "File format (CSV):",
        budget_csv_hint: "branch = Arabic branch name · month = YYYY-MM · target = number in SAR (> 0). Each branch is resolved to its ID via its name — never stored by name.",
        budget_choose_csv: "Choose CSV file",
        budget_compared_against: "Comparison is against:",
        budget_revenue_gross: "Revenue (gross, incl. VAT)",
        budget_month_open: "month not yet closed",
        budget_col_branch: "Branch",
        budget_col_target: "Target",
        budget_col_actual: "Actual (Revenue)",
        budget_col_variance: "Variance (SAR)",
        budget_col_variance_pct: "Variance %",
        budget_col_status: "Status",
        budget_col_month: "Month",
        budget_no_target: "no target set",
        budget_no_data: "no data",
        budget_rag_green: "On target",
        budget_rag_amber: "Close",
        budget_rag_red: "Below target",
        budget_company_total: "Company total",
        budget_coverage_fmt: "Comparable: {comparable} · With target: {with_target} · Total branches: {total}",
        budget_set_target: "Set target",
        budget_edit_target: "Edit target",
        budget_target_amount: "Target amount",
        budget_clear_target: "Clear target",
        budget_target_invalid: "Target must be a number greater than 0",
        budget_target_saved: "Target saved",
        budget_target_cleared: "Target cleared",
        budget_imported: "Imported",
        budget_updated: "Updated",
        budget_failed: "Failed",
        budget_failed_rows_title: "Rejected rows",
        budget_all_rows_ok: "All rows processed successfully",
        budget_reason: "Reason",
        nav_dashboard: "Dashboard",
        ops_dashboard_title: "Operations Dashboard",
        ops_dashboard_subtitle: "Live single-screen view of all branches",
        ops_as_of: "As of",
        ops_last_updated: "Updated",
        ops_hr_offline: "Workforce offline (HR not configured)",
        ops_tile_sales_today: "Sales today",
        ops_tile_sales_mtd: "Sales MTD",
        ops_tile_qc_open: "Open QC violations",
        ops_tile_workforce: "Workforce",
        ops_drill_subtitle: "Branch summary",
        nav_checkin: "Branch Check-in",
        ops_tile_checkin: "Open/Close",
        // ops dashboard module columns (2026-10-31)
        ops_tile_error: "This column could not be loaded right now",
        ops_tile_hidden: "This branch has its own ops manager — its QC and CCTV figures are with them",
        ops_cctv_with_ops: "with ops",
        ops_cctv_high: "high/critical",
        ops_cctv_at_manager: "awaiting the CCTV manager",
        ops_cctv_returned: "returned to the monitor",
        ops_cc_orders: "orders",
        ops_cc_mtd: "Month",
        ops_cc_paid_note: "Paid call-centre orders: revenue and order count",
        ops_cc_no_pos: "The branch is not linked to the POS",
        ops_cc_no_data: "The call-centre pull has not covered this day yet",
        ops_cc_mtd_partial: "The call-centre pull does not cover the whole month yet",
        ops_stock_month: "Monthly count",
        ops_stock_not_started: "Not started",
        ops_stock_draft: "Counting",
        ops_stock_submitted: "Submitted",
        ops_stock_approved: "Approved",
        ops_stock_late: "Late",
        ops_stock_value_title: "Value of the submitted or approved count",
        ops_stock_missing_cost: "Items without cost",
        ops_stock_missing_cost_title: "Counted items with no cost yet, so the value is understated",
        ops_stock_daily_title: "Daily key-item count: items counted yesterday",
        ops_stock_daily_yesterday: "Daily, yesterday",
        ops_stock_flags_mtd: "Items over the variance threshold, month to date through yesterday",
        ops_stock_flags_unevaluated: "Variances not evaluated (no pulled sales or no recipes)",
        ops_stock_daily_value: "Month variance",
        ops_stock_daily_value_title: "Net daily-count variance value, month to date through yesterday (positive = shortage)",
        ops_stock_not_counted: "Not counted",
        ops_stock_not_counted_reason: "This branch has no stock-count location",
        ops_maint_open_wo: "Open work orders now",
        ops_maint_overdue: "overdue",
        ops_maint_awaiting_branch: "Awaiting branch confirmation",
        ops_maint_suggested: "suggested",
        ops_maint_suggested_reason: "This branch's maintenance location mapping is suggested and not yet confirmed",
        ops_maint_unmapped: "No maintenance location is linked to this branch",
        ops_maint_unlinked: "not linked to a branch",
        ops_maint_stale: "The last good maintenance sync is more than an hour old, or the sync is not configured",
        ops_maint_stale_short: "out of date",
        ops_maint_not_configured: "The maintenance sync is not configured",
        ops_maint_never: "No good maintenance sync has run yet",
        ops_wf_unmapped: "Not linked",
        ops_wf_unmapped_reason: "No HR branch id (hr_branch_id) is set for this branch",
        ops_wf_unreachable: "The HR system could not be reached for this branch",
        ops_wf_no_data: "No staff data",
        ops_wf_partial_reason: "Some branches are not linked to HR or HR did not answer, so the total is incomplete",
        checkin_title: "Branch Check-in",
        checkin_subtitle: "Record branch open/close times and track operating-hours compliance",
        checkin_schedule_settings: "Operating hours",
        checkin_schedule_desc: "Set open and close times for each day of the week. A day can be marked as a day off (closed).",
        checkin_today: "Today",
        checkin_open: "Open",
        checkin_close: "Close",
        checkin_scheduled: "Scheduled",
        checkin_schedule_today: "Today's hours",
        checkin_default_hours: "default",
        checkin_closed_today: "Closed today",
        checkin_closed_short: "Closed",
        checkin_closed_col: "Closed",
        checkin_late: "Late",
        checkin_min: "min",
        checkin_on_time: "On time",
        checkin_early_close: "Early close",
        checkin_early_close_note: "Early close when closed earlier than scheduled by more than",
        checkin_not_applicable: "N/A",
        checkin_partial: "Partial",
        checkin_manually_adjusted: "Manually adjusted",
        checkin_live_stamp: "Live",
        checkin_adjusted_by: "adjusted by",
        checkin_recorded_by: "recorded by",
        checkin_edit: "Edit",
        checkin_enter_time: "Enter time",
        checkin_not_recorded: "Not recorded",
        checkin_yesterday: "yesterday",
        checkin_prev_close_label: "Yesterday's close",
        checkin_mtd_label: "Month to date",
        checkin_open_now: "Open now",
        checkin_close_now: "Close now",
        checkin_time_invalid: "Time must be in HH:MM format",
        checkin_grace_note: "Grace:",
        checkin_saved: "Recorded",
        checkin_already_recorded: "Already recorded — use edit to change the time",
        checkin_summary_title: "This month's compliance",
        checkin_summary_desc: "On-time rate for opening and closing",
        checkin_open_compliance: "Open compliance",
        checkin_close_compliance: "Close compliance",
        checkin_scheduled_days: "Operating days",
        checkin_closed_days: "days off",
        checkin_not_recorded_count: "Not recorded",
        checkin_open_word: "open",
        checkin_summary_note: "Not-recorded days and days off are excluded from the compliance %.",
        checkin_summary_early_note: "An early close is not counted as late, but it is not on time either.",
        checkin_no_branch: "No branch",
        checkin_no_branch_hint: "There is no branch available for you to check in.",
        checkin_schedule_saved: "Hours saved",
        checkin_day_mon: "Monday",
        checkin_day_tue: "Tuesday",
        checkin_day_wed: "Wednesday",
        checkin_day_thu: "Thursday",
        checkin_day_fri: "Friday",
        checkin_day_sat: "Saturday",
        checkin_day_sun: "Sunday",
        nav_branch_kpi: "Branch KPIs",
        bkpi_title: "Branch KPIs",
        bkpi_subtitle: "One consolidated operational view per branch — every number comes from the metric service, nothing recomputed",
        bkpi_view_single: "Single branch",
        bkpi_view_compare: "Compare branches",
        bkpi_branch: "Branch",
        bkpi_month: "Month",
        bkpi_day: "Daily-revenue day",
        bkpi_no_data: "no data",
        bkpi_source: "Source",
        bkpi_kpi_monthly_revenue: "Monthly revenue (incl. VAT)",
        bkpi_kpi_daily_revenue: "Daily revenue",
        bkpi_kpi_net_sales: "Net sales (ex-VAT)",
        bkpi_kpi_vat: "VAT",
        bkpi_kpi_invoices: "Invoices",
        bkpi_kpi_orders: "Orders",
        bkpi_kpi_aov: "Avg order value",
        bkpi_kpi_discounts: "Discounts",
        bkpi_kpi_cancelled: "Cancelled invoices",
        bkpi_kpi_modified: "Modified invoices",
        bkpi_kpi_returns: "Returns / refunds",
        bkpi_note_no_month_data: "This month's totals have not been pulled from the POS yet",
        bkpi_note_no_daily_data: "This day has not been pulled for this branch yet",
        bkpi_note_not_in_payload: "Not in the POS payload",
        bkpi_note_pos_not_carrying_discounts: "Reads 0 because the POS payload isn't carrying discounts — not a sign that no discounts were given",
        bkpi_legend_title: "About these numbers",
        bkpi_legend_body: "Every figure comes from the metric service and matches the Sales report (same source). Nothing is fabricated; a period whose data has not arrived shows \u201c\u2014\u201d, never zero. Cancelled invoices, modified invoices and a separate returns figure are not carried in the POS payload yet.",
        bkpi_no_branch: "No branch",
        bkpi_no_branch_hint: "There is no branch available for you to view KPIs.",
        bkpi_branch_col: "Branch",
        branch_manager_branch_label: "Assigned branch",
        branch_manager_branch_placeholder: "Pick a branch…",
        branch_manager_branch_hint: "Branch managers see and manage only this branch's data in the QC tab. Admins can change this assignment at any time — it takes effect on the next request.",
        branch_manager_needs_branch: "A branch is required for the Branch Manager role",
        perm_branch_manager_note: "Branch Manager only accesses the Quality Inspection tab, scoped to the single branch selected above. They cannot start new rounds or delete photos, but they CAN close violations by uploading an after-photo.",
        language: "العربية",

        notifications: "Notifications",
        notif_qc_submissions_label: "Email notifications",
        notif_qc_submissions_desc: "Get an email when a QC round is submitted or when something needs your action (resolution approvals, item requests…). Turning this off stops every email and never affects the in-app bell.",
        notif_dialog_title: "Notification settings",
        notif_dialog_desc: "Choose what you'd like to receive by email.",
        notif_saved: "Preferences saved",
        notif_settings: "Notification settings",
        notif_inbox_title: "Notifications",
        notif_mark_all_read: "Mark all read",
        notif_empty: "No notifications yet",
        qc_v_timeline_title: "Resolution history",
        qc_tl_created: "Violation created",
        qc_tl_started: "Work started",
        qc_tl_submitted: "Resolution submitted for approval",
        qc_tl_sent_back: "Sent back for rework",
        qc_tl_approved: "Approved & closed",
        qc_tl_closed: "Closed",
        qc_tl_reopened: "Reopened",

        sales_title: "Sales & Performance",
        sales_subtitle: "Sales performance dashboard",
        branch_filter: "Branch",
        all_branches: "All permitted branches",
        no_data: "No data imported yet",
        no_data_hint: "Figures will appear here once POS data is connected",
        metric: "Metric",
        value: "Value",
        date: "Date",
        month: "Month",
        branch: "Branch",
        item: "Item",
        channel: "Channel",
        share: "Share",

        users_title: "User Management",
        users_subtitle: "Add and edit accounts and permissions",
        add_user: "Add user",
        edit_user: "Edit user",
        new_user: "New user",
        name: "Name",
        email: "Email",
        national_id: "National ID",
        password: "Password",
        role: "Role",
        status: "Status",
        last_login: "Last login",
        actions: "Actions",
        active: "Active",
        inactive: "Inactive",
        never: "Never",
        save: "Save",
        saving: "Saving...",
        cancel: "Cancel",
        edit: "Edit",
        reset_password: "Reset password",
        deactivate: "Deactivate",
        activate: "Activate",
        delete: "Delete",
        new_password: "New password",
        confirm: "Confirm",
        confirm_delete_user: "Permanently delete this user? This cannot be undone.",
        password_hint: "At least 6 characters",
        identifier_hint: "Provide an email or a national ID (at least one)",

        permissions: "Permissions",
        perm_tabs: "Tabs",
        perm_branches: "Branches",
        perm_sections: "Sales sections",
        perm_metrics: "Metrics",
        select_all: "Select all",
        clear_all: "Clear all",
        all_branches_grant: "All branches (incl. new ones)",
        perm_super_note: "Super Admin sees and manages everything automatically.",
        perm_inspector_note: "Inspector only accesses the Quality Inspection tab — no Sales, Financials, or other tabs. No permissions to configure here.",
        perm_quality_manager_note: "Quality Manager sees every branch's QC data (Inspection + Waste), edits QC Sections, and administers users of role inspector / branch_manager / qc_supervisor only. No Sales, no Financials, no branch admin.",
        perm_qc_supervisor_note: "QC Supervisor sees every branch's QC data, runs rounds, and closes violations at any branch. Cannot manage users, cannot edit QC Sections, no Sales or Financials access.",
        sales_access: "Sales access",

        branches_title: "Branch Management",
        branches_subtitle: "Add and edit branches",
        add_branch: "Add branch",
        branch_name_ar: "Branch name (Arabic)",
        branch_name_en: "Branch name (English)",
        branch_code: "Code",
        branch_pos_id: "POS ID",
        branch_pos_id_hint: "(optional)",
        branch_pos_id_invalid: "POS ID must be a positive integer",
        branch_hr_id: "HR branch ID",
        branch_hr_id_hint: "(links the employee list)",
        branch_hr_unmapped: "Unmapped",
        branch_hr_test: "Test HR",
        branch_hr_test_employees: "employees",
        branch_hr_test_zero: "0 employees — check HR branch ID",
        branch_hr_test_unmapped: "no HR branch ID set",
        branch_hr_test_unconfigured: "HR not configured",
        branch_hr_test_unreachable: "HR unreachable",
        branch_hr_test_using: "using",
        branch_flags: "Flags",
        branch_finance_only: "Finance-only",
        branch_finance_only_desc: "Finance-only branches do not appear in Sales or QC — only in the P&L.",
        branch_finance_only_no_pos: "Finance-only branches must not have a POS id",
        branch_hr_id_invalid: "HR branch id must be a UUID (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)",
        branch_finance_only_unlinks: "Saving will unlink the branch from POS #{n}: its nightly pull stops and its sales drop out of branch views. Turn finance-only off to restore the id.",
        // the branch's own operations manager (2026-11-01)
        branch_ops_manager: "Branch ops manager",
        branch_ops_manager_hint: "(optional)",
        branch_ops_manager_none: "— the network ops manager —",
        branch_ops_manager_desc: "Handles this branch's QC violations and CCTV approvals on their own; the network ops manager no longer sees this branch's QC and CCTV records.",
        branch_ops_manager_saved_failed: "The branch was saved, but its ops manager could not be saved",
        branch_clear_title: "Remove a link from this branch?",
        branch_clear_save: "Save and remove the link",
        branch_clear_pos_effect: "the nightly POS pull stops for this branch and its sales drop out of branch views until the id is entered again.",
        branch_clear_hr_effect: "the employee list in Quality and CCTV goes empty for this branch until the id is entered again.",
        branch_deactivate_effect: "Deactivating hides the branch from Sales, the Ops dashboard, Quality, Waste & Meals and check-in, and stops its nightly POS pull. Its past figures drop out of per-branch views while network totals still include them. No data is deleted, and you can reactivate it at any time.",
        branch_deactivate_type: "Type the branch name “{name}” to confirm",
        rename: "Edit",

        no_access_title: "No access granted",
        no_access_desc: "You have not been granted any tab. Please contact your administrator.",
        forbidden_title: "Access denied",
        loading: "Loading...",
        search_users: "Search by name or email...",
        no_users: "No users found",
        of: "of",
        save_success: "Saved successfully",
        action_success: "Action completed",
        error_generic: "Something went wrong, please try again",
        app_error_title: "This page could not be shown",
        app_error_body: "Something went wrong while displaying it. No saved data was lost — reload the page or go back to the home page.",
        app_error_reload: "Reload",
        app_error_home: "Home",

        import_sales: "Import sales data",
        import_desc: "Upload the verified POS JSON file. Data is upserted cumulatively with no duplication.",
        choose_file: "Choose JSON file",
        selected_file: "Selected file",
        upload: "Upload & import",
        uploading: "Uploading & processing...",
        import_done: "Import complete",
        rows_inserted: "Rows inserted",
        rows_updated: "Rows updated",
        rejected_rows: "Rejected rows",
        no_rejected: "No rejected rows",
        service_token: "Service token (for future automated pushes)",
        token_hint: "Save this token to send in the X-Ingest-Token header for automated pushes. The manual upload uses it automatically.",
        copy: "Copy",
        copied: "Copied",
        invalid_json: "Invalid JSON file",

        reconciliation: "Reconciliation",
        recon_desc: "Stored totals compared against the file's target values",
        recon_no_data: "No data imported yet",
        recon_no_data_hint: "Upload the sales file to see the reconciliation panel",
        recon_metric: "Line",
        recon_stored: "Stored",
        recon_target: "Target",
        recon_diff: "Diff",
        recon_status: "Status",
        all_matched: "All lines matched",
        mismatch_found: "Mismatch found",
        last_import: "Last import",
        coverage: "Coverage",
        source: "Source",

        period: "Period",
        period_all_time: "All time",
        period_custom: "Custom range",
        period_reset: "Reset",
        period_apply: "Apply",
        updated_through: "Updated through",
        item_name: "Item",
        item_category: "Category",
        qty: "Qty",
        revenue_col: "Revenue",
        share_col: "Share",
        orders_col: "Orders",
        rank_col: "#",
        top_n_items: "Top selling items",
        reference_total: "Reference total",
        channel_breakdown: "Sales channel breakdown",
        net_only_note: "Note",
        no_rows_range: "No data within the selected period",

        exp_title: "Sales Explorer",
        exp_subtitle: "Unified view — group by day, month, item, branch or channel",
        exp_group_by: "Group by",
        exp_gb_day: "Day",
        exp_gb_month: "Month",
        exp_gb_item: "Item",
        exp_gb_branch: "Branch",
        exp_gb_channel: "Channel",
        exp_channel_breakdown: "Channel breakdown",
        exp_chart: "Chart",
        exp_chart_show: "Show chart",
        exp_chart_hide: "Hide chart",
        exp_sum_net: "Revenue",
        exp_sum_cash: "Cash",
        exp_sum_card: "Card",
        exp_sum_delivery: "Delivery apps",
        exp_sum_invoices: "Invoices",
        exp_sum_aov: "Avg Order Value",
        exp_period_30: "Last 30 days",
        exp_compare_yoy: "Compare years",
        exp_compare_metric: "Compare metric",
        exp_compare_change: "Change",
        exp_compare_total: "Total",
        exp_vs: "vs",

        dsr_tab: "Branch DSR",
        dsr_title: "Branch Daily Sales Report",
        dsr_subtitle: "Per-branch daily sales split across Walk-in / Call Center / Delivery apps — replaces the manual daily spreadsheet.",
        dsr_all_branches: "All branches",
        dsr_all_subtitle: "Compare every branch's performance in one table for the selected month — total, channel split and percentages.",
        dsr_col_branch: "Branch",
        dsr_network_total: "Network total",
        sc_title: "Branch Performance",
        sc_subtitle: "Compare branch revenue to spot underperformers fast — monthly and year-over-year.",
        sc_month: "Month",
        sc_tab_compare: "Branch comparison",
        sc_tab_trend: "Monthly trend",
        sc_tab_yoy: "Year over year",
        sc_col_revenue: "Revenue",
        sc_col_target: "Target",
        sc_attainment: "Attainment",
        sc_mom: "vs previous month",
        sc_yoy: "vs last year",
        sc_vs_prev: "vs prev month",
        sc_vs_last_year: "vs last year",
        sc_network_total: "Network total",
        sc_no_target: "No target",
        sc_no_data: "No data for this month",
        sc_yoy_unavailable_title: "Last year's data isn't imported yet",
        sc_yoy_unavailable_desc: "Import the prior year to see each branch's year-over-year comparison.",
        sc_current_year: "Current year",
        sc_prior_year: "Prior year",
        exp_item_gap_title: "Item breakdown isn't synced for this period",
        exp_channel_gap_title: "Channel split isn't synced for this period",
        exp_breakdown_gap_hint: "This breakdown is available from {from} to {to}. The totals for the selected period are synced, but the POS detail pull hasn't reached this period yet — extend the sales history backfill to cover it.",
        ops_charts_attainment_title: "Target attainment by branch",
        ops_charts_attainment_desc: "Lowest performers first (month-to-date)",
        ops_charts_movers_title: "Biggest movers (vs last month)",
        ops_charts_movers_desc: "Largest revenue gains and drops",
        ops_charts_no_data: "Not enough data for charts yet",
        dsr_branch: "Branch",
        dsr_month: "Month",
        dsr_pick_branch: "Pick a branch to load its report",
        dsr_no_data: "No sales data for this branch in this month",
        dsr_no_data_hint: "Figures appear here once daily rows for this branch are synced.",
        dsr_col_date: "Date",
        dsr_col_total: "Total",
        dsr_col_walk_in: "Walk-in",
        dsr_col_cc: "Call Center",
        dsr_col_apps: "Delivery Apps",
        dsr_col_total_tc: "Orders",
        dsr_col_cc_tc: "CC Orders",
        dsr_col_apps_tc: "Apps Orders",
        dsr_col_avg_ticket: "Avg Ticket",
        dsr_row_totals: "Month Total",
        dsr_row_prev: "Previous Month",
        dsr_row_delta: "Change (%)",
        dsr_apps_tc_note: "Not available yet — POS hasn't pushed per-app data for this day.",
        dsr_cc_window_from: "Call-Center data available from",
        dsr_cc_window_to: "to",
        dsr_cc_no_coverage: "No Call-Center data yet for this branch.",
        dsr_apps_breakdown: "Delivery apps breakdown for this day",
        dsr_apps_col_name: "App",
        dsr_apps_col_net: "Net",
        dsr_apps_col_orders: "Orders",
        dsr_wk: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

        qc_ins_title: "Quality Inspection",
        qc_ins_subtitle: "Restaurant inspection checklist — manage inspection sections and items.",
        qc_ins_admin_title: "Inspection Sections & Items",
        qc_ins_admin_desc: "Add / edit / reorder inspection sections and edit their checklist items (potential violation items).",
        qc_ins_inspector_placeholder_title: "Inspection form coming soon",
        qc_ins_inspector_placeholder_hint: "The inspection round form will appear here in the next release. This account only has access to this tab.",
        qc_ins_add_section: "Add Section",
        qc_ins_new_section: "New Inspection Section",
        qc_ins_edit_section: "Edit Inspection Section",
        qc_ins_section_key: "Internal Key",
        qc_ins_section_key_hint: "Short English key (a-z0-9_-) — used internally, not shown to the inspector.",
        qc_ins_title_ar: "Title (Arabic)",
        qc_ins_title_en: "Title (English)",
        qc_ins_subtitle_ar: "Subtitle (Arabic)",
        qc_ins_subtitle_en: "Subtitle (English)",
        qc_ins_items: "Inspection Items",
        qc_ins_items_desc: "Each item is a point an inspector can flag as a violation. One item per line.",
        qc_ins_items_count: (n) => `${n} item${n === 1 ? "" : "s"}`,
        qc_ins_items_placeholder: "One item per line…",
        qc_ins_active: "Active",
        qc_ins_inactive: "Inactive",
        qc_ins_no_sections: "No inspection sections yet",
        qc_ins_no_sections_hint: "Click \"Add Section\" to create your first inspection section.",
        qc_ins_move_up: "Move up",
        qc_ins_move_down: "Move down",
        qc_ins_toggle: "Toggle active",
        qc_ins_edit: "Edit",
        qc_ins_delete: "Delete",
        qc_ins_delete_confirm: "Delete inspection section?",
        qc_ins_delete_confirm_desc: "This cannot be undone. The section and all its items will be permanently deleted.",
        qc_ins_saved: "Saved",
        qc_ins_deleted: "Deleted",

        qc_ins_sections_tab: "Sections",
        qc_ins_rounds_tab: "Inspection Rounds",

        // ---- Unified Quality Management hub (2026-07-23) ----
        quality_hub_title: "Quality Management",
        quality_hub_subtitle: "One unified place for quality operations — inspections, violations, and waste.",
        quality_hub_nav: "Quality Management",
        quality_hub_tab_dashboard: "Dashboard",
        quality_hub_tab_rounds: "Rounds",
        quality_hub_tab_violations: "Violations",
        quality_hub_tab_waste: "Waste",

        // ---------------- Waste & Staff Meals ----------------
        wm_title: "Waste & Staff Meals",
        wm_subtitle: "Daily waste and staff-meal recording, per branch",
        wm_tab_waste: "Record waste",
        wm_tab_waste_report: "Waste report",
        wm_tab_meals: "Staff meals",
        wm_tab_meals_report: "Staff meals report",
        wm_tab_coverage: "Today's coverage",
        wm_tab_admin: "Item management",
        wm_admin_items: "Items",
        wm_admin_units: "Units",
        wm_admin_reasons: "Waste reasons",
        wm_admin_requests: "Item requests",
        wm_admin_policy: "Policy",
        wm_admin_search: "Search by name or code",
        wm_admin_usage_all: "All",
        wm_admin_usage_waste: "Waste",
        wm_admin_usage_meals: "Staff meals",
        wm_admin_usage_both: "Both",
        wm_admin_only_active: "Active only",
        wm_admin_count: "Active",
        wm_admin_item_add: "Add item",
        wm_admin_item_edit: "Edit item",
        wm_admin_items_empty: "No matching items",
        wm_admin_code: "Code",
        wm_admin_name_ar: "Arabic name",
        wm_admin_name_en: "English name",
        wm_admin_usage: "Usage",
        wm_admin_unit: "Unit",
        wm_admin_state: "State",
        wm_admin_active: "Active",
        wm_admin_inactive: "Inactive",
        wm_admin_category: "Category",
        wm_admin_name_required: "The Arabic name is required",
        wm_admin_unit_locked: "The unit is frozen once records exist for this item. Deactivate it and create a replacement with the correct unit.",
        wm_admin_inactive_hint: "Deactivating hides the item from new entry screens only — it stays visible in past months' reports.",
        wm_admin_unit_key: "Key",
        wm_admin_allows_decimal: "Allows decimals",
        wm_admin_unit_add: "Add unit",
        wm_admin_unit_required: "Key and Arabic name are required",
        wm_admin_reason_key: "Key",
        wm_admin_reason_add: "Add reason",
        wm_admin_reason_required: "Waste reason is mandatory",
        wm_admin_reason_required_hint: "When on, a waste entry without a reason is refused",
        wm_admin_backdate_days: "Back-date days",
        wm_admin_edit_days: "Edit window (days)",
        wm_admin_cutoff_hour: "Day cutoff hour",
        wm_admin_warn_quantity: "Quantity warning",
        wm_admin_max_quantity: "Quantity maximum",
        wm_admin_request_open: "Pending",
        wm_admin_request_resolved: "Approved",
        wm_admin_request_rejected: "Declined",
        wm_admin_request_all: "All",
        wm_admin_requests_empty: "No requests",
        wm_admin_link_to_item: "Link to an existing item",
        wm_admin_request_link: "Approve",
        wm_admin_request_decline: "Decline",
        wm_admin_pick_item_first: "Pick the item first",
        wm_admin_request_done: "Request approved — the employee was notified",
        wm_admin_request_declined: "Request declined — the employee was notified",
        wm_admin_yes: "Yes",
        wm_admin_no: "No",
        wm_branch: "Branch",
        wm_date: "Date",
        wm_month: "Month",
        wm_more: "More",
        wm_less: "Hide",
        wm_item: "Item",
        wm_quantity: "Quantity",
        wm_reason: "Reason",
        wm_notes: "Notes",
        wm_save: "Save",
        wm_saving: "Saving...",
        wm_cancel: "Cancel",
        wm_close: "Close",
        wm_edit: "Edit",
        wm_delete: "Delete",
        wm_delete_confirm: "Delete this record?",
        wm_deleted: "Deleted",
        wm_saved: "Saved",
        wm_mode_quick: "Quick add",
        wm_mode_sheet: "Day sheet",
        wm_quick_hint: "One item at a time",
        wm_day_sheet_hint: "Type only what was recorded today — empty lines save nothing",
        wm_recorded_today: "Recorded today",
        wm_pick_item: "Pick an item",
        wm_search_item: "Search items",
        wm_picker_empty: "No matching item",
        wm_no_item_found: "I can't find the item",
        wm_item_request_title: "Request a new item",
        wm_item_request_hint: "Type the item name as the branch uses it; the catalogue admin will get the request",
        wm_item_request_sent: "Request sent to the catalogue admin",
        wm_default_reason: "Default reason",
        wm_no_reason: "No reason",
        wm_saved_prefix: "Saved",
        wm_saved_suffix: "items",
        wm_nothing_typed: "No quantity typed",
        wm_no_waste_today: "No waste today",
        wm_no_meals_today: "No staff meals today",
        wm_no_activity_saved: "Day recorded as having no activity",
        wm_no_activity_blocked: "Can't mark this day as \"none\" — it already carries {n} entr(ies) listed below. Delete them first if the day really had no activity.",
        wm_no_activity_day: "None",
        wm_no_activity_undo: "Undo",
        wm_no_activity_undo_title: "Undo the \"no activity\" flag?",
        wm_no_activity_undo_desc: "The day goes back to \"not recorded\" and the undo is written to the audit log under your name. No data is deleted.",
        wm_no_activity_undo_reason: "Reason (optional)",
        wm_no_activity_undone: "\"No activity\" flag reversed",
        wm_beneficiaries: "Beneficiaries",
        wm_beneficiaries_recorded: "Recorded",
        wm_my_entries: "My entries",
        wm_my_entries_hint: "Your records inside the edit window",
        wm_my_entries_empty: "No records yet",
        wm_grid_item: "Item",
        wm_grid_unit: "Unit",
        wm_grid_total: "Total",
        wm_grid_day_total: "Day total",
        wm_grid_month_total: "Month total",
        wm_grid_empty: "No records this month",
        wm_scope_own: "My entries only",
        wm_scope_branch: "All branch entries",
        wm_badge_inactive_item: "Inactive",
        wm_badge_inactive_branch: "Inactive",
        wm_coverage_state_recorded: "Recorded",
        wm_coverage_state_none: "None",
        wm_coverage_state_not_recorded: "Not recorded",
        wm_coverage_lines: "Lines",
        wm_coverage_last_by: "Last entry",
        wm_coverage_empty: "No branches in your scope",
        wm_no_home_branch: "No branch assigned yet — contact your administrator",
        wm_admin_only_note: "This account manages the catalogue only — it has no branch for recording or reports",
        wm_offline_error: "Not saved — check your connection",
        wm_retry: "Retry",
        wm_records_count: "records",
        wm_hidden_colleague_records: "colleague records not shown",
        wm_source_quick: "Quick",
        wm_source_day_sheet: "Sheet",
        wm_source_import: "Import",
        wm_by: "by",
        wm_favourites: "Branch items",
        wm_fallback_note: "This branch has no item list yet — showing every item",
        wm_warn_big_qty: "Large quantity — double-check the number",
        wm_select_branch: "Select a branch",
        wm_qty_placeholder: "0",
        // ---- 2026-10-16 sheet retirement: raw items, notes, returns, cost, export, recipe links
        wm_raw_badge: "Raw",
        wm_note_add: "Note",
        wm_note_placeholder: "Note for this line (optional)",
        wm_note_needs_qty: "A note is saved only with a quantity — type the quantity first",
        wm_reason_not_waste: "Not counted as waste",
        wm_returns_title: "Returned to warehouse",
        wm_returns_hint: "A stock movement — not in the waste totals, cost or %",
        wm_returns_month_total: "Returns total",
        wm_coverage_returns: "Returned",
        wm_grid_cost: "Cost",
        wm_grid_month_cost: "Month cost",
        wm_grid_missing_cost: "{n} without cost",
        wm_grid_missing_cost_total: "{n} record(s) without cost — link the items to their recipes in “Recipe links”",
        wm_grid_waste_pct: "Waste % of sales",
        wm_grid_waste_pct_none: "No sales for this branch",
        wm_grid_through: "through",
        wm_export: "Export Excel",
        wm_export_title: "Export the month to Excel",
        wm_export_hint: "Summary, waste, staff meals, returns and every record",
        wm_export_scope: "Branches",
        wm_export_scope_branch: "This branch",
        wm_export_scope_all: "All my branches",
        wm_export_type: "Contents",
        wm_export_type_waste: "Waste",
        wm_export_type_meals: "Staff meals",
        wm_export_type_all: "Waste & staff meals",
        wm_export_cost_note: "Cost and waste % are the snapshots taken at save time; returns to the warehouse are left out of both.",
        wm_export_download: "Download",
        wm_exporting: "Exporting...",
        wm_exported: "File downloaded",
        wm_export_failed: "Export failed — try again",
        wm_admin_counts_as_waste: "Counts as waste",
        wm_admin_counts_locked: "Locked — records use this reason",
        wm_admin_counts_off_hint: "A reason that does not count as waste (such as returned to warehouse) is recorded and shown, but left out of waste totals, cost and %. It cannot be changed once used.",
        wm_admin_kind: "Kind",
        wm_admin_kind_product: "Product",
        wm_admin_kind_stock: "Raw ingredient (stock item)",
        wm_admin_kind_product_hint: "A POS product — costed from its recipe in “Recipe links”",
        wm_admin_kind_stock_hint: "A raw ingredient from the monthly stock count — costed from the count",
        wm_admin_sc_code: "Stock-count code",
        wm_admin_sc_code_hint: "As in the monthly stock count, e.g. PT-12200016",
        wm_admin_sc_code_required: "Enter the stock-count code of the raw ingredient",
        wm_admin_ingredient_key: "Recipe ingredient key",
        wm_admin_ingredient_key_hint: "As it appears in the POS recipes, e.g. «لبنه labneh» — lets the daily count take this waste off the theoretical use",
        wm_admin_links: "Recipe links",
        wm_admin_missing: "Missing cost",
        wm_links_hint: "Link each item to its POS recipe so every waste and staff-meal record saves its cost. Nothing is linked without your confirmation; records saved before the link stay without cost.",
        wm_links_filter_all: "All",
        wm_links_filter_review: "Needs review",
        wm_links_filter_unlinked: "Not linked",
        wm_links_filter_linked: "Linked",
        wm_links_state_linked: "Linked",
        wm_links_state_dangling: "Recipe removed",
        wm_links_confidence_confirmed: "Confirmed match",
        wm_links_confidence_uncertain: "Uncertain",
        wm_links_confidence_none: "No match",
        wm_links_suggestion: "Suggested recipe",
        wm_links_linked_to: "Linked recipe",
        wm_links_pick: "Pick the recipe",
        wm_links_check_suggestion: "Check the recipe before linking — this match is not confirmed",
        wm_links_recipe_missing: "This recipe is no longer in the POS — pick the new one",
        wm_links_factor: "POS pieces per {unit}",
        wm_links_factor_hint: "The POS recipe is per piece while this item is recorded in {unit}: enter how many pieces make one {unit}.",
        wm_links_factor_required: "Enter the factor (greater than zero) before linking",
        wm_links_factor_check: "No factor yet — this item's records save without cost until you enter the POS pieces per unit",
        wm_links_unit_cost: "Unit cost",
        wm_links_zero_lines: "{n} ingredient(s) costed at zero",
        wm_links_stock_item: "Raw ingredient — costed from the monthly stock count, never linked to a recipe",
        wm_links_confirm: "Confirm link",
        wm_links_save: "Save change",
        wm_links_unlink: "Unlink",
        wm_links_unlink_confirm: "Unlink this item? New records will be saved without cost until it is linked again.",
        wm_links_saved: "Link saved",
        wm_links_unlinked: "Link removed",
        wm_links_confirm_all: "Confirm all confirmed matches",
        wm_links_confirm_all_desc: "{n} item(s) will be linked to their exact-match recipes, each link recorded under your name. Spinach (022 and 023) and uncertain matches are not linked here — review them one by one. Items counted in kilos need their quantity factor after linking.",
        wm_links_confirm_all_run: "Link confirmed",
        wm_links_confirm_all_done: "{n} item(s) linked",
        wm_links_empty: "No matching items",
        wm_links_none: "No items to link",
        wm_links_refresh: "Refresh",
        wm_picker_recipe_title: "Pick the POS recipe",
        wm_picker_recipe_search: "Search by recipe name",
        wm_picker_alternatives: "Suggested for this item",
        wm_picker_other: "Other recipes",
        wm_picker_type_more: "type to search for more",
        wm_picker_recipe_empty: "No matching recipe",
        wm_missing_hint: "What makes records save without cost. Nothing here blocks recording.",
        wm_missing_unlinked: "Items not linked to a recipe",
        wm_missing_unlinked_hint: "Their records save without cost until linked",
        wm_missing_dangling: "Links to a removed recipe",
        wm_missing_dangling_hint: "The linked recipe is no longer in the POS — link again",
        wm_missing_zero_lines: "Recipe ingredients costed at zero",
        wm_missing_zero_lines_hint: "The recipe cost is understated until the ingredient is priced in the POS",
        wm_missing_stock: "Raw ingredients without a stock-count cost",
        wm_missing_stock_hint: "The linked stock item has no cost",
        wm_missing_empty_group: "Nothing",
        wm_missing_all_clear: "Every item has a cost",
        wm_missing_open_links: "Open recipe links",
        wm_grid_waste_pct_no_pos: "The branch has no POS link",
        wm_grid_waste_pct_no_sales: "No sales this month",
        wm_grid_waste_pct_no_cost: "No cost yet — link the items to their recipes",
        wm_links_no_recipes: "No POS recipes yet, so there are no suggestions — they appear once the recipes sync",
        wm_missing_needs_factor: "Weighed items without a factor",
        wm_missing_needs_factor_hint: "Linked to a per-piece recipe; they need the POS pieces per kilo before they are costed",
        wm_missing_cause_sc_item_missing: "stock-count code not found",
        wm_missing_cause_unit_mismatch: "unit does not convert to the count unit",
        wm_missing_cause_no_cost: "no stock-count cost",
        wm_missing_linked_items: "Linked items",
        // ---- Branch hub shell + Cancellations (CP3)
        hub_section_wm: "Waste & Staff Meals",
        hub_section_co: "Cancellations",
        co_subtitle: "Record cancelled orders at the till with the receipt photo",
        co_tab_entry: "Record cancellation",
        co_tab_mine: "My entries",
        co_tab_records: "Records",
        co_tab_reports: "Reports",
        co_tab_review: "Needs review",
        co_tab_settings: "Settings",
        co_coming_soon: "Coming in a later checkpoint",
        co_not_ready: "Module not ready — a server setting is missing. Contact your administrator.",
        co_no_home_branch: "No branch assigned yet — contact your administrator",
        co_assigned_branch_missing: "Branch manager has no assigned branch — contact your administrator",
        co_select_branch: "Select branch",
        co_branch_required: "Pick the branch first",
        co_photo_take: "Photograph the receipt",
        co_photo_retake: "Retake",
        co_photo_uploading: "Uploading photo…",
        co_photo_stored: "Photo saved",
        co_photo_pending: "Waiting for photo",
        co_photo_failed: "No photo",
        co_photo_reserve_failed: "Could not reserve the photo — tap to retry",
        co_photo_required: "A receipt photo is required",
        // ---- incident 2026-10-21: "Photo saved" only once the server has the bytes
        co_photo_lost: "Photo not uploaded",
        co_photo_lost_hint: "The photo never reached the server and is no longer on this device — retake it",
        co_photo_not_kept: "This photo is not kept on this device — keep this screen open until the upload finishes",
        co_photo_upload_failed: "Photo upload failed",
        co_photo_upload_failed_hint: "The photo did not reach the server — retry the upload or retake it",
        co_photo_retry_upload: "Retry upload",
        co_photo_checking: "Checking the photo…",
        co_photo_unchecked: "Could not check the photo — tap to try again",
        co_photo_save_blocked: "The cancellation cannot be saved before its photo arrives — retry the upload or retake it",
        co_photo_saved_without: "Saved, but its photo did not reach the server — retake it from My entries",
        co_photo_after_save_failed: "The previous cancellation's photo did not upload — retake it from My entries",
        co_photo_view: "View photo",
        co_photo_view_failed: "Could not show the photo — try again",
        co_invoice: "Invoice number",
        co_invoice_helper: "At least the last 4 digits",
        co_value: "Order value (SAR)",
        co_value_warn: "Large value — check it, then press “Confirm value”",
        co_value_confirm: "Confirm value",
        co_outcome: "What happened to the order?",
        co_phone: "Mobile number",
        co_phone_kind_mobile: "Customer with number",
        co_phone_kind_takeaway: "Takeaway",
        co_phone_kind_delivery_app: "Delivery app",
        co_source: "Cancellation channel",
        co_source_locked_hint: "Locked to call centre",
        co_category: "Reason",
        co_category_more: "Other reasons",
        co_category_less: "Less",
        co_reason: "Write the reason",
        co_more: "More",
        co_less: "Less",
        co_outcome_note: "What exactly happened?",
        co_reissued_invoice: "New invoice number (optional)",
        co_date: "Date",
        co_time: "Time",
        co_save: "Save cancellation",
        co_saving: "Saving…",
        co_update: "Save changes",
        co_cancel_edit: "Cancel editing",
        co_saved: "Cancellation recorded",
        co_updated: "Changes saved",
        co_deleted: "Record deleted",
        co_confirmation: "Recorded: invoice {invoice}, {value} SAR",
        co_confirmation_duplicate: "Saved as a second entry for the same invoice",
        co_offline_error: "Not saved — check the connection",
        co_retry: "Retry",
        co_duplicate_title: "This invoice is already recorded for today",
        co_duplicate_mine: "recorded by you",
        co_duplicate_other: "recorded by a colleague",
        co_duplicate_by: "recorded by {name}",
        co_duplicate_at: "Time",
        co_duplicate_value: "Value",
        co_duplicate_confirm: "Yes, record a second entry",
        co_duplicate_cancel: "Cancel",
        co_my_entries: "My entries",
        co_my_entries_hint: "Your entries for this day — edit and delete inside the window",
        co_my_entries_window: "Your entries inside the edit window",
        co_my_entries_empty: "No entries today yet",
        co_my_entries_total: "{n} cancellations · {value} SAR",
        co_badge_duplicate: "second entry",
        co_badge_review: "needs review",
        co_badge_backdated: "backdated",
        // ---- CP4: POS lookup + verdict chips
        co_customer: "Customer",
        co_pos_lookup: "Check",
        co_pos_checking: "Checking…",
        co_pos_searching_live: "Searching the till…",
        co_pos_not_arrived: "Not at the till yet",
        co_pos_matched: "Found at the till",
        co_pos_not_found: "Not found at the till yet",
        co_pos_ambiguous: "Enter the full invoice number or at least its last {n} digits",
        co_pos_unavailable: "Not synced yet",
        co_pos_wait_live: "Will be checked automatically within minutes",
        co_pos_wait_nightly: "Will be checked after the night sync",
        co_pos_already_mine: "You already recorded it",
        co_pos_already_other: "Already recorded today",
        co_pos_pay_state_paid: "Paid",
        co_pos_pay_state_delivery_company: "Delivery company",
        co_pos_pay_state_mismatch: "Not matching",
        co_pos_pay_state_unknown: "Unknown state",
        co_pos_till: "Handled at the till",
        co_pos_lookup_limit: "Too many checks — wait a minute",
        co_delete_confirm: "Delete this record?",
        co_edit: "Edit",
        co_delete: "Delete",
        co_editing: "Editing a record",
        co_business_date: "Business day",
        // ---- message 29: photo notice + CP6-lite (records, review, panel, export)
        co_photo_rejected_notice: "The photo was not uploaded — you can retake it",
        co_rec_from: "From",
        co_rec_to: "To",
        co_rec_all_branches: "All branches",
        co_rec_all: "All",
        co_rec_filters: "Filters",
        co_rec_filter_category: "Category",
        co_rec_filter_outcome: "Outcome",
        co_rec_filter_source: "Channel",
        co_rec_filter_pos_match: "POS",
        co_rec_filter_review_status: "Review",
        co_rec_filter_photo_status: "Photo",
        co_rec_show_duplicates: "Show second entries",
        co_rec_reset: "Clear filters",
        co_rec_review_open: "Needs review or follow-up",
        co_rec_review_none: "Not reviewed",
        co_rec_photo_stored: "With photo",
        co_rec_photo_none: "No photo",
        co_rec_pos_matched: "Found at the till",
        co_rec_pos_not_found: "Not found at the till",
        co_rec_pos_ambiguous: "Ambiguous",
        co_rec_pos_unavailable: "Not synced yet",
        co_rec_total_count: "Cancellations",
        co_rec_total_value: "Value",
        co_rec_total_still: "Still in POS sales",
        co_rec_totals_note: "Totals for the current filter — second entries are not counted",
        co_rec_export: "Export Excel",
        co_rec_exporting: "Exporting…",
        co_rec_exported: "File downloaded",
        co_rec_export_failed: "Export failed — try again",
        co_rec_empty: "No records for this filter",
        co_rec_page: "{from}–{to} of {total}",
        co_rec_prev: "Previous",
        co_rec_next: "Next",
        co_rec_panel_title: "Cancellation record",
        co_rec_field_invoice: "Invoice",
        co_rec_field_value: "Value",
        co_rec_field_business_date: "Business day",
        co_rec_field_time: "Cancelled at",
        co_rec_field_branch: "Branch",
        co_rec_field_category: "Category",
        co_rec_field_reason: "Reason details",
        co_rec_field_outcome: "Outcome",
        co_rec_field_outcome_note: "Outcome note",
        co_rec_field_reissued: "New invoice",
        co_rec_field_prepared: "Prepared",
        co_rec_field_source: "Channel",
        co_rec_field_customer: "Customer",
        co_rec_field_recorded_by: "Recorded by",
        co_rec_field_created_at: "Recorded at",
        co_rec_field_updated: "Last edit",
        co_rec_field_origin: "Origin",
        co_rec_field_duplicate: "Second entry of a recorded invoice",
        co_rec_field_photo: "Photo",
        co_rec_yes: "Yes",
        co_rec_no: "No",
        co_rec_origin_app: "App",
        co_rec_origin_import: "Form",
        co_rec_photo_title: "Receipt photo",
        co_rec_photo_missing: "No stored photo for this record",
        co_rec_photo_diag: "Photo diagnostics: {status} · upload attempts {attempts} · rejected {rejected} ({rejection}) · device error {error}",
        co_rec_pos_title: "POS",
        co_rec_pos_matched_line: "The invoice is at the till: {total} SAR · {state} · at {time}",
        co_rec_pos_basis_exact: "Exact invoice-number match",
        co_rec_pos_basis_suffix: "Matched on the last digits",
        co_rec_pos_basis_suffix_previous_date: "Matched on the last digits, previous day",
        co_rec_pos_channel: "Order channel at the till: {channel}",
        co_rec_pos_till_line: "{count} return/damage posted at the till for {amount} SAR",
        co_rec_pos_value_exceeds: "The recorded value is above the till total",
        co_rec_pos_partial: "Partial cancellation: the recorded value is below the till total",
        co_rec_pos_source_mismatch: "The cancellation channel differs from the till's order channel",
        co_rec_pos_not_found_final: "Not found at the till after the day was fully synced",
        co_rec_pos_not_found_wait: "Not found at the till yet — it may appear after the sync",
        co_rec_pos_ambiguous_many: "More than one invoice ({n}) ends with these digits — the full number is needed",
        co_rec_pos_ambiguous_short: "The recorded number is too short to match",
        co_rec_pos_unavailable_line: "The till has not been synced for this day yet",
        co_rec_pos_checked: "Last checked: {at}",
        co_rec_manager_note: "Branch manager note",
        co_rec_manager_note_ph: "Write your note on this record",
        co_rec_save_note: "Save note",
        co_rec_note_saved: "Note saved",
        co_rec_review_title: "Review",
        co_rec_review_none_yet: "Not reviewed yet",
        co_rec_review_note_ph: "Reviewer note (optional)",
        co_rec_review_save: "Save review",
        co_rec_review_saved: "Review saved",
        co_rec_review_by: "Reviewed by {name} · {at}",
        co_rec_dismiss_duplicate: "Not a second entry",
        co_rec_flags: "Why it needs review",
        co_rec_audit_title: "Change history",
        co_rec_audit_empty: "No changes recorded",
        co_rec_audit_system: "System",
        co_rec_audit_changed: "Changed: {fields}",
        co_audit_co_record_create: "Record created",
        co_audit_co_record_update: "Content edited",
        co_audit_co_record_delete: "Record deleted",
        co_audit_co_review_update: "Review / note",
        co_audit_co_pos_review_flags: "POS match result",
        co_audit_co_duplicate_late: "Second entry (after matching)",
        co_audit_co_duplicate_cleared: "Second-entry mark removed",
        co_audit_co_photo_rejected: "Photo rejected ({n}×)",
        co_flag_duplicate: "Second entry",
        co_flag_duplicate_late: "Second entry (after matching)",
        co_flag_value_high: "High value",
        co_flag_discard_value: "High-value discard",
        co_flag_cashier_daily_count: "Many cancellations by one cashier today",
        co_flag_backdated: "Backdated",
        co_flag_pos_not_found: "Not found at the till",
        co_flag_pos_ambiguous: "Number too short to match",
        co_flag_value_exceeds: "Value above the till total",
        co_flag_source_mismatch: "Channel differs from the till",
        co_rec_close: "Close",
        co_rec_delete: "Delete record",
        co_rec_delete_title: "Delete record",
        co_rec_delete_body: "The record leaves the lists, the totals, the review queue and the export. The photo is kept so it can be restored if needed.",
        co_rec_delete_reason: "Reason for deletion",
        co_rec_delete_reason_hint: "At least 5 characters",
        co_rec_delete_confirm: "Confirm deletion",
        co_rec_delete_cancel: "Cancel",

        quality_hub_tab_sections: "Sections",
        quality_hub_tab_branches: "Branches",

        // ---- Dashboard (2026-07-22) ----
        qc_dash_tab: "Dashboard",
        qc_dash_title: "Inspection Dashboard",
        qc_dash_subtitle: "A cross-branch view of violations, top offenders, and inspector activity",
        qc_dash_range_last_7d: "Last 7 days",
        qc_dash_range_last_30d: "Last 30 days",
        qc_dash_range_last_90d: "Last 90 days",
        qc_dash_range_ytd: "Year to date",
        qc_dash_range_last_year: "Last 12 months",
        qc_dash_range_custom: "Custom",
        qc_dash_all_branches: "All branches",
        qc_dash_branches: "Branches",
        qc_dash_severity: "Severity",
        qc_dash_severity_all: "All severities",
        qc_dash_no_data: "No data in this range. Try widening the dates or clearing filters.",
        qc_dash_kpi_rounds: "Rounds submitted",
        qc_dash_kpi_violations: "Violations opened",
        qc_dash_kpi_closed_pct: "Closed %",
        qc_dash_kpi_overdue: "Overdue",
        qc_dash_kpi_avg_ttc: "Avg. time to close",
        qc_dash_kpi_avg_ttc_note: "Days, by severity",
        qc_dash_trend_title: "Violations over time",
        qc_dash_trend_desc: "Weekly or monthly stacks, split by severity",
        qc_dash_top_branches_title: "Top offending branches",
        qc_dash_top_items_title: "Top offending items",
        qc_dash_open_vs_closed_title: "Open vs Closed",
        qc_dash_open: "Open",
        qc_dash_closed: "Closed",
        qc_dash_sev_critical: "Critical",
        qc_dash_sev_moderate: "Moderate",
        qc_dash_sev_minor: "Minor",
        qc_dash_inspector_title: "Inspector activity",
        qc_dash_col_inspector: "Inspector",
        qc_dash_col_rounds: "Rounds",
        qc_dash_col_avg_violations: "Avg. violations",
        qc_dash_col_last_submission: "Last submission",
        qc_dash_col_total_violations: "Total violations",
        qc_dash_from: "From",
        qc_dash_to: "To",
        qc_dash_apply: "Apply",
        qc_dash_clear_filters: "Clear filters",
        qc_dash_branch_perf_title: "Cross-module branch performance",
        qc_dash_branch_perf_desc: "Violations · Sales net · P&L net — for the same period",
        qc_dash_col_branch: "Branch",
        qc_dash_col_violations: "Violations",
        qc_dash_col_sales_net: "Sales net",
        qc_dash_col_pnl_net: "P&L net",
        qc_dash_col_flags: "Flags",
        qc_dash_critical: "Critical",
        qc_dash_moderate: "Moderate",
        qc_dash_minor: "Minor",
        qc_ins_rounds_title: "Inspection Rounds",
        qc_ins_rounds_desc: "Start a new round, resume a draft, or review submitted rounds.",
        qc_ins_new_round: "New Round",
        qc_ins_new_round_desc: "Pick a branch to start an inspection round. Start time will be recorded automatically.",
        qc_ins_start_round: "Start Round",
        qc_ins_branch: "Branch",
        qc_ins_my_drafts: "My Drafts",
        qc_ins_no_drafts: "No drafts yet — start a new round.",
        qc_ins_submitted_rounds: "Submitted Rounds",
        qc_ins_no_submitted: "No submitted rounds yet",
        qc_ins_no_submitted_hint_inspector: "Once you submit a round it will appear here in the archive.",
        qc_ins_no_submitted_hint_viewer: "No inspector has submitted a round on any of your branches yet.",
        qc_ins_status_draft: "Draft",
        qc_ins_status_submitted: "Submitted",
        qc_ins_violations_short: "violations",
        qc_ins_resume: "Resume",
        qc_ins_view: "View",
        qc_admin_edit_meta: "Edit round",
        qc_admin_edit_meta_title: "Edit round meta",
        qc_admin_edit_meta_desc: "Correct the visit date as an admin fix — the change is written to the audit log.",
        qc_admin_close_action: "Close (mark submitted)",
        qc_admin_close_title: "Close round",
        qc_admin_close_desc: "The round will be marked submitted immediately and the notification email will fire to subscribed users. Continue?",
        qc_admin_close_ok: "Round closed",
        qc_admin_reopen_action: "Reopen",
        qc_admin_reopen_title: "Reopen round",
        qc_admin_reopen_desc: "The round will go back to draft and become editable via the wizard. The submitted timestamp is cleared but all attached violations are kept. Continue?",
        qc_admin_reopen_ok: "Round reopened",
        qc_admin_delete_action: "Delete round",
        qc_admin_delete_title: "Delete round permanently",
        qc_admin_delete_desc: "This will permanently delete the round, every attached violation, and every photo. Cannot be undone. Continue?",
        qc_admin_delete_ok: "Round deleted",
        qc_admin_archive_action: "Archive round",
        qc_admin_archive_title: "Archive round",
        qc_admin_archive_desc: "The round will be hidden from the rounds list, violations tracker and dashboard. Data is preserved and can be restored at any time from the Archived section. Continue?",
        qc_admin_archive_ok: "Round archived",
        qc_admin_unarchive_action: "Restore from archive",
        qc_admin_unarchive_title: "Restore round from archive",
        qc_admin_unarchive_desc: "The round will return to the rounds list, violations tracker and dashboard just as it was before archiving. Continue?",
        qc_admin_unarchive_ok: "Round restored",
        qc_rounds_show_archived: "Show archived",
        qc_rounds_archived_section: "Archived Rounds",
        qc_rounds_no_archived: "No archived rounds.",
        qc_rounds_archived_badge: "Archived",

        qc_email_status_label: "Email",
        qc_email_status_sent: "Email sent",
        qc_email_status_failed: "Email failed",
        qc_email_status_skipped_no_recipients: "No recipients",
        qc_email_status_skipped_no_api_key: "Email not configured",
        qc_email_status_pending: "Email sending…",
        qc_email_status_none: "Email not attempted",

        qc_ins_check_only_violations: "Check ONLY items that are non-compliant. Unchecked items are considered compliant.",
        qc_ins_section_notes: "Section notes",
        qc_ins_section_notes_ph: "General notes for this section (optional)…",
        qc_ins_severity: "Severity",
        qc_ins_sev_critical: "Critical",
        qc_ins_sev_moderate: "Moderate",
        qc_ins_sev_minor: "Minor",
        qc_ins_responsible: "Responsible",
        qc_ins_responsible_select_ph: "Select responsible employee (optional)",
        qc_ins_responsible_none: "None",
        qc_ins_responsible_loading: "Loading employees…",
        qc_ins_responsible_hr_unavailable: "Employee list is unavailable right now — you can type a name manually.",
        qc_ins_responsible_hr_gate: "Without an employee picked from the list this violation is not sent to HR — it stays in the Ops platform only.",
        qc_ins_responsible_manual_ph: "Type responsible name (unverified)",
        qc_ins_responsible_unverified: "Unverified",
        qc_ins_deadline: "Deadline",
        qc_ins_description: "Description",
        qc_ins_photos: "Photos",
        qc_ins_capture_photo: "Capture photo",
        qc_ins_delete_photo: "Delete photo",
        qc_ins_photo_deleted: "Photo deleted",
        qc_ins_section_photos: "Section photos (off-checklist)",
        qc_ins_section_photo_add: "Add section photo",
        qc_ins_section_photo_needs_note: "Write the section note first, then you can attach a photo of it.",
        qc_ins_section_note_severity: "Note severity",
        qc_ins_section_note_severity_none: "Not set",
        qc_ins_section_note_severity_needs_note: "Write the note first to set its severity.",
        qc_ins_responsible_add: "Add responsible employee",
        qc_ins_responsible_all_added: "All employees added",
        qc_ins_responsible_remove: "Remove",
        qc_ins_responsible_none_assigned: "No one assigned",
        qc_ins_responsible_manual_add: "Add",
        qc_ins_responsible_multi_hint: "You can name more than one person. Each employee picked from the HR list gets their own violation record in HR; typed names stay in the Ops platform only.",
        qc_admin_delete_draft_action: "Delete draft",
        qc_admin_delete_draft_title: "Delete this draft round?",
        qc_admin_delete_draft_desc: "The draft and every violation and photo in it are deleted permanently. This cannot be undone.",
        qc_branches_title: "Branch names",
        qc_branches_desc: "Rename a branch. Nothing else changes — no POS id, no HR mapping, no historical data.",
        qc_branches_empty: "No branches.",
        qc_branch_rename: "Rename",
        qc_branch_rename_title: "Rename branch",
        qc_branch_rename_desc: "The new name shows up across every screen immediately.",
        qc_branch_rename_hint: "Name only — the POS id, the HR branch id and every linked record stay exactly as they are.",
        qc_branch_name_ar: "Arabic name",
        qc_branch_name_en: "English name",
        qc_branch_name_required: "Branch name is required",
        qc_branch_renamed: "Branch renamed",

        qc_ins_wizard_review: "Review & Submit",
        qc_ins_review: "Review",
        qc_ins_review_summary: "Round summary",
        qc_ins_total_sections: "Sections",
        qc_ins_total_violations: "Violations",
        qc_ins_total_photos: "Photos",
        qc_ins_notes_count: "Notes",
        qc_ins_no_violations_yet: "No violations recorded — the round is clean so far.",
        qc_ins_submit_round: "Submit round",
        qc_ins_submit_confirm: "Submit inspection round?",
        qc_ins_submit_confirm_desc: (n) => `Once submitted the round becomes read-only. Total violations recorded: ${n}.`,
        qc_ins_round_submitted: "Round submitted",
        qc_ins_round_readonly: "This round is submitted and read-only.",
        qc_ins_autosaving: "Saving…",
        qc_ins_back_to_hub: "Back to inspections",
        qc_ins_edit_section: "Edit this section",
        qc_ins_review_no_photos: "No photos",
        qc_ins_review_photo_alt: "Violation photo",
        qc_ins_lightbox_close: "Close",
        qc_ins_review_tap_to_edit: "Tap a violation to jump back to its section and edit",
        qc_ins_watermark_failed: "Couldn't prepare the photo (watermarking failed). Please try again or retake the shot.",
        back: "Back",
        next: "Next",
        close: "Close",

        qc_ins_violations_tab: "Violations",
        qc_v_title: "Violations Tracker",
        qc_v_desc_admin: "All violations across branches and inspectors — filter, transition status, compare before/after.",
        qc_v_desc_scoped: "Violations within your scope — update status and upload 'after' proof photos.",
        qc_v_filter_branch: "Branch",
        qc_v_filter_status: "Status",
        qc_v_filter_severity: "Severity",
        qc_v_filter_section: "Section",
        qc_v_overdue_only: "Overdue only",
        qc_v_all: "All",
        qc_v_clear_filters: "Clear filters",
        qc_v_total: "Total",
        qc_v_status_open: "Open",
        qc_v_status_in_progress: "In progress",
        qc_v_status_closed: "Closed",
        qc_v_status_pending_approval: "Pending approval",
        qc_v_status_overdue: "Overdue",
        qc_v_col_branch: "Branch",
        qc_v_col_item: "Violation",
        qc_v_col_status: "Status",
        qc_v_col_photos: "Before/After",
        qc_hr_push_queued: "HR: queued",
        qc_hr_push_sent: "HR: sent",
        qc_hr_push_failed: "HR: failed",
        qc_hr_push_skipped: "Not sent — no responsible",
        qc_v_empty: "No violations match this filter",
        qc_v_empty_hint: "Once rounds with violations are submitted they'll show up here.",
        qc_v_empty_filtered_hint: "Try changing or clearing the filters.",

        qc_v_detail_title: "Violation details",
        qc_v_detail_desc: "Review the violation, change its status, and attach an 'after' photo as proof of closure.",
        qc_v_status_change: "Change status",
        qc_v_status_updated: "Status updated",
        qc_v_readonly: "You cannot edit this violation — view only.",
        qc_v_edit_btn: "Edit",
        qc_v_delete_btn: "Delete violation",
        qc_v_edit_title: "Edit violation",
        qc_v_f_severity: "Severity",
        qc_v_f_description: "Description",
        qc_v_f_responsible: "Responsible",
        qc_v_f_responsible_ph: "Responsible name (optional)",
        qc_v_f_deadline: "Deadline",
        qc_v_saved: "Changes saved",
        qc_v_delete_confirm_title: "Delete this violation?",
        qc_v_delete_confirm_desc: "This permanently deletes the violation and all its photos. This action cannot be undone.",
        qc_v_delete_ok: "Delete permanently",
        qc_v_deleted: "Violation deleted",
        qc_v_reopen: "Reopen",
        qc_v_add_after_photo: "Capture 'after' photo",
        qc_v_resolve_title: "Resolve violation",
        qc_v_start_working: "Start working",
        qc_v_resolution_note_label: "Resolution note",
        qc_v_resolution_note_ph: "Describe what was done to resolve the issue…",
        qc_v_submit_resolution: "Submit resolution for approval",
        qc_v_note_required: "Please add a resolution note",
        qc_v_pending_banner: "Resolution submitted — awaiting QC approval",
        qc_v_pending_wait: "You cannot close directly. A QC manager will approve or send it back.",
        qc_v_resolution_by: "Resolution by",
        qc_v_approve_close: "Approve & close",
        qc_v_send_back: "Send back",
        qc_v_send_back_reason_label: "Send-back reason",
        qc_v_send_back_reason_ph: "Reason for sending back to the branch…",
        qc_v_reason_required: "Please enter a send-back reason",
        qc_v_sent_back_label: "Sent back for rework — reason:",
        qc_v_after_uploaded: "'After' photo uploaded",
        qc_v_after_ready: "'After' photo is attached — closing will proceed without warning.",
        qc_v_after_hint: "Add an 'after' photo as proof before closing.",
        qc_v_overdue_now: "Overdue now",
        qc_v_before: "Before",
        qc_v_after: "After",
        qc_v_no_photos_yet: "No photos yet",
        qc_v_closed_by: "Closed by",
        qc_v_closed_without_proof: "Closed without proof photo",
        qc_v_close_no_proof_title: "Close without a proof photo?",
        qc_v_close_no_proof_desc: "No 'after' photo has been uploaded for this violation. Closing is allowed, but the violation will be flagged as 'closed without proof'. Continue?",
        qc_v_close_no_proof_ok: "Close anyway",

        financials_title: "Financials",
        financials_subtitle: "Profit & loss from the ERP (independent of Sales)",
        financials_empty: "No financial data yet",
        financials_empty_hint: "Profitability metrics and branch ranking will appear here after financial data is imported.",
        import_financials: "Import financial data",
        erp_pl_import: "Import ERP P&L",
        erp_pl_title: "Import ERP Profit & Loss report",
        erp_pl_desc: "Upload the ERP's XLS export — the Profit - Loss By Cost Center report. Totals are validated against the printed Grand Total before saving; any mismatching file is rejected entirely.",
        erp_pl_choose: "Choose XLS file",
        erp_pl_month: "Month",
        erp_pl_revenue: "Total revenue",
        erp_pl_expense: "Total expenses",
        erp_pl_net: "Net",
        erp_pl_profit: "profit",
        erp_pl_loss: "loss",
        erp_pl_per_cc: "Result by cost center",
        erp_pl_cc: "Cost center",
        erp_pl_branch: "Branch",
        erp_pl_not_mapped: "Not mapped",
        erp_pl_unmapped_title: "Cost centers not mapped to branches",
        erp_pl_unmapped_desc: "Their data was ingested, but they are not linked to any branch — mappings are never guessed.",
        erp_pl_validation_ok: "Validated: row sums match the printed Grand Total (±1 SAR)",
        cc_map_btn: "Cost-center mapping",
        cc_map_title: "Map cost centers to branches",
        cc_map_desc: "Link each ERP cost center to its matching POS branch — mappings are never guessed. Choose \u201cNo match\u201d for cost centers that are not POS branches.",
        cc_map_status: "Status",
        cc_map_not_set: "— Not set —",
        cc_map_external: "No match / external",
        cc_map_mapped: "Mapped",
        cc_map_saved: "Saved",
        cc_map_empty: "No cost centers yet — import an ERP report first",
        import_financials_desc: "Upload the P&L JSON from the ERP. It is stored completely separately from sales data.",
        financials_recon: "Financials reconciliation",
        financials_recon_desc: "Stored values vs the file's target totals.",
        financials_recon_no_data: "No financial data imported yet",
        financials_recon_no_data_hint: "Use the \"Import financial data\" button to upload the P&L file.",
        partial_months_label: "Partial months",
        partial_flag: "Partial data",
        partial_note: "Contains months with partial data — not treated as final.",
        financial_service_token: "Financial service token",
        financials_token_hint: "A separate token for financial imports only (different from the sales token).",
        branches_summary: "Branches",
        br_linked: "linked",
        br_created: "created",
        financials_access: "Financials access",
        financials_access_hint: "Independent from Sales — choose the financial branches this user may see.",
        qc_access: "Quality branch scope",
        qc_access_hint: "Branches this user's QC access covers (ignored when the “QC: all branches” capability is granted).",
        perm_capabilities: "Capabilities",
        perm_cap_group_quality: "Quality",
        perm_cap_group_cctv: "CCTV",
        perm_cap_group_waste_meals: "Waste & Staff Meals",
        perm_cap_group_branch_ops: "Branch Operations",
        perm_cap_group_cancellations: "Cancellations",
        perm_cap_group_stock_count: "Monthly Stock Count",
        perm_hub_branches: "Work branch (Branch Operations)",
        perm_hub_branches_hint: "Used for Waste & Staff Meals and for Cancellations",
        perm_hub_needs_branch: "Pick at least one work branch for the record or supervise capabilities",
        perm_co_branch_no_pos: "Cancellations cannot be bound to a branch without a POS",
        perm_co_branch_no_pos_hint: "Cancellations capabilities need a branch with a POS — branches without one are marked",
        perm_branch_no_pos_badge: "no POS",
        perm_wm_branches: "Waste & Meals branches",
        perm_wm_branches_hint: "The branches this account records for — required before saving the record or supervise capability",
        perm_wm_bm_locked: "A branch manager is locked to its assigned branch. Branch Operations (Waste & Meals and Cancellations) follow that same branch automatically — extra branches cannot be assigned.",
        perm_wm_needs_branch: "Pick at least one branch for the Waste & Meals capabilities",
        perm_wm_reports_needs_base: "Needs the Waste & Meals record, supervision or catalogue admin capability",
        perm_wm_reports_included: "Included in full control",
        perm_sc_locations: "Count locations",
        perm_sc_locations_hint: "The branches and warehouses this account counts — required before saving the count capability. Finance sees every location without a binding",
        perm_sc_needs_location: "Pick at least one count location for the stock-count capability",
        perm_sc_bm_locked: "A branch manager counts their assigned branch only, automatically — other count locations cannot be set.",
        perm_sc_warehouse_badge: "warehouse",
        perm_cap_group_daily_count: "Daily Key-Item Count",
        perm_dk_needs_location: "Pick at least one count location for the daily-count record capability",
        perm_dk_locations_hint: "The daily count uses only the branches among these locations. Review & variance needs no binding",
        perm_cap_group_screens: "Screens",
        perm_cap_group_admin: "Administration",
        perm_admin_cap_super_only: "Only a Super Admin can grant this.",
        perm_grant_own_only: "You cannot grant access you don't hold yourself.",
        expense_col: "Expenses",
        net_col: "Net Profit",
        margin_col: "Margin",
        partial_short: "Partial",
        key_cost: "Key cost",
        loss_label: "Loss",
        of_total_expense: "of total expenses",
        all_branches_fin: "All financial branches",

        monthly_detail: "Monthly detail",
        monthly_detail_hint: "Pick a month and a branch to view the full revenue and expense lines.",
        select_month: "Select month",
        account_col: "Account",
        group_col: "Group",
        amount_col: "Amount",
        income_total_label: "Total revenue",
        expense_total_label: "Total costs",
        net_result_label: "Net / What you kept",
        no_lines_month: "No lines for this branch in the selected month",

        fin_hero_title: "Where did your money go?",
        fin_hero_sub: "Follow the riyal from sales to what you kept",
        fin_sales_label: "Sales",
        fin_kept_label: "What you kept",
        fin_of_sales: "of sales",
        fin_card_kept_month: "You kept this month",
        fin_card_kept_period: "You kept in this period",
        fin_card_per100: "For every 100 SAR of sales, you kept",
        fin_card_revenue: "Total sales",
        fin_card_cost: "Total costs",
        fin_vs_last_month: "vs last month",
        fin_pts: "pts",
        fin_profit_word: "Profit",
        fin_loss_word: "Loss",
        fin_leaderboard_title: "Branch leaderboard",
        fin_leaderboard_sub: "From most profitable to biggest loss",
        fin_losing_tag: "Losing — spends more than it earns",
        fin_selected: "Selected",
        fin_tap_branch: "Tap a branch to view its details",
        fin_expenses_title: "Where the money goes",
        fin_expenses_sub: "Where each riyal of cost goes",
        fin_key_drain: "Key drain",
        fin_trend_title: "Profit trend",
        fin_trend_sub: "Net profit across months",
        fin_partial_not_final: "Partial months aren't final",
        fin_badge_ramadan: "Ramadan",
        fin_insights_title: "Quick summary",
        fin_see_details: "See full details",
        fin_hide_details: "Hide details",
        fin_best_month: "Best month",
        fin_top_branch: "Top branch",
        fin_this_month: "this month",
        fin_this_period: "in this period",
        fin_insight_commission: "Delivery-app commission took",
        fin_insight_branch_lost_one: "1 branch lost",
        fin_insight_branches_lost: "branches lost",
        fin_riyal: "SAR",

        fa_tab_pnl: "P&L",
        fa_tab_analytics: "Financial Analytics",
        fa_title: "Financial Analytics",
        fa_subtitle: "Your ERP financial overview at a glance",
        fa_kpi_revenue: "Revenue",
        fa_kpi_expenses: "Expenses",
        fa_kpi_net_profit: "Net Profit",
        fa_kpi_margin: "Profit Margin",
        fa_metrics_title: "Calculated metrics",
        fa_metric_margin: "Profit Margin",
        fa_metric_margin_hint: "Net profit ÷ Revenue",
        fa_metric_expense_ratio: "Expense-to-Revenue",
        fa_metric_expense_ratio_hint: "Total expenses ÷ Revenue",
        fa_expense_title: "Expense Breakdown",
        fa_expense_sub: "By category, largest first",
        fa_expense_of_total: "of total",
        fa_lines: "lines",
        fa_empty_title: "No analytics data yet",
        fa_empty_hint: "Financial analytics will appear here once the ERP financial file is ingested.",
        fa_load_error: "Couldn't load financial analytics",
        fa_retry: "Retry",

        fa_cash_title: "Cash on Hand",
        fa_cash_sub: "Bank & cash accounts, highest balance first",
        fa_cash_total: "Total cash on hand",
        fa_cash_empty: "No cash accounts yet",
        fa_cash_empty_hint: "Bank and cash balances will appear here once cash data is ingested.",
        fa_receivables_title: "Receivables Aging",
        fa_receivables_sub: "Outstanding by age bucket (in days)",
        fa_receivables_total: "Total outstanding receivables",
        fa_receivables_empty: "No receivables yet",
        fa_receivables_empty_hint: "Aging buckets and top debtors will appear here once data is ingested.",
        fa_top_debtors: "Top debtors",
        fa_aging_older: "Older",

        fa_fcv_title: "Food Cost Variance",
        fa_fcv_intro: "Actual food cost % per branch vs theoretical recipe cost. Branches above the theoretical baseline are leaking.",
        fa_fcv_company: "Company food cost",
        fa_fcv_baseline: "Theoretical baseline",
        fa_fcv_col_branch: "Branch",
        fa_fcv_col_revenue: "Revenue (SAR)",
        fa_fcv_col_food: "Food cost (SAR)",
        fa_fcv_col_food_pct: "Food cost %",
        fa_fcv_col_excess: "Excess SAR",
        fa_fcv_empty: "No food cost variance data yet",
        fa_fcv_empty_hint: "Per-branch food cost variance will appear here once the data is ingested.",

        qc_title: "QC Waste",
        qc_subtitle: "Record a weigh-in visit and review ingredient waste.",
        qc_record_title: "Record a visit",
        qc_branch: "Branch",
        qc_branch_ph: "Select a branch",
        qc_visit_date: "Visit date",
        qc_pick_date: "Pick a date",
        qc_received: "Received since last visit",
        qc_weighed: "Weighed now (remaining)",
        qc_ingredient: "Ingredient",
        qc_unit: "Unit",
        qc_save: "Save Visit",
        qc_saving: "Saving…",
        qc_save_success: "Visit saved",
        qc_save_error: "Couldn't save the visit",
        qc_select_branch_first: "Select a branch and date to begin.",
        qc_past_visits: "View a past visit",
        qc_past_visits_ph: "Select a visit",
        qc_no_visits: "No past visits",
        qc_result_title: "Waste result",
        qc_no_result: "Save a visit or pick a past one to see waste.",
        qc_load_error: "Couldn't load the result",
        qc_baseline: "First visit recorded — this sets the opening stock. Waste will appear from the next visit.",
        qc_period: "Period",
        qc_days: "days",
        qc_gaps_warn: "Sales data missing for these days — waste is incomplete:",
        qc_col_opening: "Opening",
        qc_col_received: "Received",
        qc_col_should: "Should-have-used",
        qc_col_closing: "Closing (weighed)",
        qc_col_waste: "Waste",
        qc_col_waste_pct: "Waste %",
        qc_check_entry: "check entry",
        qc_summary_cheese: "Total cheese waste",
        qc_summary_falafel: "Falafel waste",
        qc_summary_drinks: "Drinks waste",
        qc_kg: "kg",
        qc_bottles: "bottles",

        nav_sales_sync: "Sales Sync",
        nav_backups: "Backups",
        ss_col_recon: "Branches = network",
        ss_recon_ok: "Matches",
        ss_recon_off: "Off",
        ss_recon_zero: "no sales:",
        ss_recon_branches: "Sum of branches (invoices)",
        ss_recon_network: "Network total (invoices)",
        budget_actual_mtd: "Month to date",
        sc_mtd_through: "Data through",
        sc_mtd_note: "The month is not complete — month-on-month and year-on-year read \u201c\u2014\u201d until it is",
        bkpi_note_partial_month: "Month to date — the month is not over",
        bkpi_note_disc_not_in_daily: "Discounts are not carried in the daily report",
        bkpi_note_order_days_incomplete: "The daily order counts have not been pulled for every day of this month yet",
        bkpi_mtd_through: "Data through",
        period_month_no_data: "This month has not been uploaded yet — you can still pick it, the cards will say why",
        period_month_pending: "pending",
        tile_targets_partial: "some branches have no target — no company %",
        tile_partial_mark: "partial",
        tile_partial_short: "some days of this month are still missing",
        tile_partial_reason: "Some days of this month have not been pulled yet, so it is not scored against the target",
        nav_hr_integration: "HR integration",
        hr_ev_title: "HR platform integration",
        hr_ev_subtitle: "Send the evidence photos and clips to the HR platform instead of a link their managers cannot open.",
        hr_ev_not_configured: "The integration is not configured in this environment (HR_API_BASE_URL / HR_INTEGRATION_TOKEN). Files wait in the queue and go out automatically once it is.",
        hr_ev_truth_title: "What HR actually holds",
        hr_ev_truth_desc: "These numbers are read from the HR platform itself, not from our own records — so the two can never drift after a lost upload.",
        hr_ev_held: "Violations with evidence",
        hr_ev_waiting: "Waiting for evidence",
        hr_ev_unknown: "Never reached HR",
        hr_ev_unknown_hint: "The violation itself never arrived — it is re-sent automatically.",
        hr_ev_never_checked: "Not verified yet",
        hr_ev_never_checked_hint: "Press \"Check with HR\".",
        hr_ev_last_checked: "Last checked",
        hr_ev_violations_sent: "Violations sent",
        hr_ev_queue_title: "File delivery queue",
        hr_ev_delivered: "Files delivered",
        hr_ev_in_queue: "In the queue",
        hr_ev_retrying: "Retrying",
        hr_ev_blocked: "Refused",
        hr_ev_blocked_hint: "Unsupported type, over HR's cap (25 MB photo / 150 MB video), or past the 10-file limit.",
        hr_ev_errors_title: "Recent errors",
        hr_ev_clips_title: "CCTV clip sizes",
        hr_ev_clips_desc: "Our real numbers — the HR platform asked for them so it can set its upload cap deliberately.",
        hr_ev_clips_video: "Video clips",
        hr_ev_clips_photo: "Photos",
        hr_ev_median: "median",
        hr_ev_max: "largest",
        hr_ev_over_cap: "over the cap",
        hr_ev_cap: "HR cap",
        hr_ev_no_files: "No files",
        hr_ev_limits: "HR limits: {files} files per violation · photos {mb} MB · video {vmb} MB. A clip over the cap needs a shorter excerpt.",
        hr_ev_send_now: "Send now",
        hr_ev_check_with_hr: "Check with HR",
        hr_ev_sent_toast: "{n} file(s) queued — the background worker will send them shortly.",
        hr_ev_send_confirm_title: "Send evidence to HR now?",
        hr_ev_send_confirm_body: "Files are queued for every violation already sent, and files that ran out of retries go back in the queue. The background worker sends them one at a time over the next minutes — you can leave this page.",
        hr_ev_check_confirm_title: "Check with the HR platform?",
        hr_ev_check_confirm_body: "We ask the HR platform what it actually holds. Any violation it does not have is sent again, and any files it is missing go back in the send queue.",
        hr_ev_checked_toast: "{n} violation(s) checked, {w} need re-sending.",
        hr_ev_connection: "Connection",
        hr_ev_online: "online",
        hr_ev_offline: "offline",
        nav_data_audit: "Data Audit",
        tile_no_data_reason: "The POS has not delivered this day yet",
        bkpi_no_data_reason: "The POS has not delivered this metric for this period",
        budget_actual_missing: "sales not received yet",

        da_title: "Data Consistency Audit",
        da_subtitle: "Is every card in the app actually fed, and does the same number agree everywhere? Nothing is invented — only what really exists.",
        da_load_failed: "Couldn't load the audit",
        da_coverage_loading: "Working out the coverage grid — this can take a few seconds",
        da_cleaned: "Cleaned up — rows deleted",
        da_fix_failed: "Clean-up failed",
        da_fix_confirm_title: "Clean up these rows?",
        da_fix_confirm_body: "{n} row(s) will be deleted from {coll}.",
        da_fix_quarantine_note: "Every row is first copied to the quarantine store (data_audit_quarantine) with a run id; then exactly those rows are deleted.",
        da_fix_sample: "Sample (up to 5 rows)",
        da_fix_confirm_action: "Delete {n} row(s)",
        da_fix_quarantined: "Copied to quarantine — run id",
        da_cards_with_data: "Cards complete",
        da_cards_partial: "Cards partial",
        da_cards_empty: "Cards empty",
        da_checks_passed: "Checks passed",
        da_checks_failed: "Checks failed",
        da_backfill_running: "History backfill is running right now at",
        da_tab_cards: "Cards",
        da_tab_checks: "Number agreement",
        da_tab_coverage: "Coverage",
        da_tab_anomalies: "Data anomalies",
        da_page_ops_dashboard: "Ops dashboard",
        da_page_sales: "Sales",
        da_page_pos_insights: "POS Insights",
        da_page_financials: "Financials",
        da_page_qc: "Quality",
        da_st_complete: "Complete",
        da_st_partial: "Partial",
        da_st_missing: "Empty",
        da_st_pass: "Agrees",
        da_st_fail: "Disagrees",
        da_st_skipped: "Not comparable",
        da_open: "Open",
        da_checks_hint: "The same figure is computed from every independent source, then compared. A check only runs when BOTH sides fully cover the month — a partial month can never produce a green tick.",
        da_dataset: "Dataset",
        da_no_anomalies: "No anomalies — the data is clean",
        da_clean_up: "Clean up",
        da_review: "Needs review",

        dg_btn_not_pulled_yet: "Track the sync",
        dg_btn_month_in_progress: "Track the sync",
        dg_btn_pulled_but_empty: "Open Sales Sync",
        dg_btn_needs_erp_upload: "Upload the ERP file",
        dg_btn_needs_monthly_import: "Open Ingest Status",
        dg_btn_needs_user_input: "Enter targets",
        dg_btn_no_activity: "Start now",
        dg_btn_no_activity_ever: "Start now",
        dg_btn_undefined: "Open",
        dg_btn_null: "Open",
        backups_title: "Database Backups",
        backups_subtitle: "Every MongoDB collection is exported to Cloudflare R2 automatically at 03:00 Asia/Riyadh, every day. Writes are append-only — the job never deletes or overwrites a previous run.",
        backups_run_now: "Run backup now",
        backups_running: "Running…",
        backups_last_runs: "Last 7 runs",
        backups_col_folder: "Folder",
        backups_col_date: "Date",
        backups_col_status: "Status",
        backups_col_trigger: "Trigger",
        backups_col_started: "Started",
        backups_col_ok: "OK",
        backups_col_failed: "Failed",
        backups_col_docs: "Docs",
        backups_col_size: "Size",
        backups_status_ok: "OK",
        backups_status_partial: "Partial",
        backups_status_failed: "Failed",
        backups_status_running: "Running",
        backups_trigger_manual: "Manual",
        backups_trigger_scheduler: "Scheduled",
        backups_empty: "No backup runs recorded yet.",
        backups_run_success: "Backup complete — {n} collection(s) archived.",
        backups_run_failed: "Backup failed",
        backups_root_note: "R2 prefix:",
        backups_run_started: "Backup started — it takes about 70 minutes; this page refreshes until it finishes.",
        backups_active_note: "A backup is running — this page refreshes automatically. Started",
        backups_confirm_title: "Run a backup now?",
        backups_confirm_body: "Exports every database collection to R2 and takes about 70 minutes. The app stays usable meanwhile and may be a little slower. The scheduled backup runs automatically every day at 03:00.",
        backups_confirm_start: "Start backup",
        ss_title: "Sales Sync",
        ss_subtitle: "Pull sales (network, branches, items and call-center) straight from the POS inside the platform — no external bookmark needed.",
        ss_how_title: "How it works",
        ss_how_1: "The server signs in to the POS automatically with a stored secure key — no bookmark, and you don't need to be logged in.",
        ss_how_2: "It pulls network, per-branch, item and call-center data for each day in the selected range.",
        ss_how_3: "The pull runs in the background with live progress, and also runs automatically every night to fetch yesterday.",
        ss_mode_yesterday: "Pull Yesterday",
        ss_mode_range: "Pull Range",
        ss_date_label: "Date",
        ss_from: "From",
        ss_to: "To",
        ss_pick_date: "Pick a date",
        ss_start: "Start sync",
        ss_running: "Syncing…",
        ss_stop: "Stop",
        ss_retry_skipped: "Retry skipped",
        ss_branches_count: "16 branches",
        ss_progress: "Progress",
        ss_current: "Current",
        ss_total: "Total",
        ss_synced: "Synced",
        ss_skipped: "Skipped (retry)",
        ss_errors: "Errors",
        ss_col_date: "Date",
        ss_col_branch: "Branch",
        ss_col_status: "Status",
        ss_col_items: "Items",
        ss_col_message: "Note",
        ss_status_pending: "Pending",
        ss_status_pulling: "Pulling…",
        ss_status_pushing: "Pushing…",
        ss_status_done: "Done",
        ss_status_skipped: "Skipped",
        ss_status_error: "Error",
        ss_skipped_throttle: "Empty response (rate-limited) — will retry",
        ss_done_toast: "Sync complete",
        ss_stopped_toast: "Sync stopped",
        ss_idle_hint: "Choose a mode and press \"Start sync\" to begin pulling data.",
        ss_invalid_range: "Invalid date range",
        ss_cors_blocked: "The POS blocked this request from the ops page. Cross-tab pull isn't permitted by the POS system. Tell your developer to switch to the fallback method.",
        ss_no_skipped: "No skipped items to retry",
        ss_pull_title: "Pull data",
        ss_incremental_title: "Only missing days",
        ss_incremental_desc: "Skip days already fully pulled and fetch only what's new.",
        ss_days: "days",
        ss_state_running: "Running",
        ss_state_done: "Completed",
        ss_state_cancelled: "Cancelled",
        ss_state_failed: "Failed",
        ss_state_interrupted: "Interrupted (server restarted)",
        ss_status_partial: "Partial",
        ss_status_provisional: "Provisional",
        ss_sum_branch_rows: "Branch rows",
        ss_sum_item_days: "Item days",
        ss_sum_cc_orders: "Call-center orders",
        ss_sum_partial: "Partial days",
        ss_failures_title: "Failures",
        ss_started_toast: "Pull started in the background",
        ss_start_failed: "Couldn't start the pull",
        ss_cancelling: "Cancelling…",
        ss_not_configured: "POS credentials are not configured on the server.",
        ss_connected: "Connected to the POS",
        ss_nightly_note: "Automatic nightly pull runs at",
        ss_coverage_title: "Coverage",
        ss_last_sync: "Last sync",
        ss_cov_done: "Days done",
        ss_cov_partial: "Partial days",
        ss_cov_first: "First day",
        ss_cov_last: "Last day",
        ss_cov_empty: "No days synced yet.",
        ss_hist_title: "History backfill",
        ss_hist_desc: "The only source of per-branch daily rows for older months. Range:",
        ss_hist_running: "Running",
        ss_hist_stalled: "Stalled — needs a restart",
        ss_hist_paused: "Paused",
        ss_hist_complete: "Complete",
        ss_hist_stalled_hint: "The pull stopped after {n} consecutive attempts that made no progress, and will not auto-resume. Press Resume to continue from where it stopped.",
        ss_hist_other_run: "Another pull is running now — this one can resume once it finishes",
        ss_hist_progress: "Progress",
        ss_hist_days_done: "Days done",
        ss_hist_days_left: "Days remaining",
        ss_hist_eta: "Estimated time",
        ss_hist_last_try: "Last attempt",
        ss_hist_resume: "Resume backfill",
        ss_hist_resumed: "Resumed — {n} day(s) to go.",
        ss_col_pulled_at: "Pulled at",
        ss_datasets_label: "Data scope",
        ss_ds_core: "Core",
        ss_ds_deep: "Deep",
        ss_ds_both: "Everything",
        ss_ds_hint: "Core = branch totals, items and call-center. Deep = invoice-level detail, hourly, items, categories + raw snapshot archived to Cloudflare.",
        ss_sum_deep_orders: "Invoices read",
        ss_sum_deep_items: "Item rows",
        ss_sum_archived: "Files archived",
        ss_cov_deep_done: "Deep days done",
        ss_cov_deep_partial: "Deep days partial",
        ss_cov_provisional: "Provisional days (re-pulled)",
        ss_pulled_early: "Pulled before the day was complete — data may be missing",
        ss_read_only: "View only — starting, stopping and resuming a sync is limited to the super admin.",
        ss_col_deep: "Deep",
        ss_masters_title: "POS master data",
        ss_stage: "Stage",
        ss_stage_core: "Core",
        ss_stage_deep: "Deep",
        ss_stage_masters: "Master data",

        pi_tab: "POS Insights",
        pi_title: "POS Insights",
        pi_subtitle: "Everything the POS exposes: invoices, hours, items and quantities, categories, delivery apps, payment mix, cashiers and terminals.",
        pi_preset_7: "Last 7 days",
        pi_preset_30: "Last 30 days",
        pi_preset_month: "This month",
        pi_from: "From",
        pi_to: "To",
        pi_branch_all: "All branches",
        pi_kpi_transactions: "Transactions",
        pi_kpi_avg_ticket: "Average ticket",
        pi_kpi_gross: "Gross sales",
        pi_kpi_in_store: "In-store",
        pi_kpi_apps: "Delivery apps",
        pi_kpi_discounts: "Discounts",
        pi_kpi_waste: "Waste (damaged)",
        pi_kpi_vat: "VAT",
        pi_kpi_items_qty: "Quantity sold",
        pi_vs_prev: "vs previous period",
        pi_tab_hourly: "Hourly",
        pi_tab_items: "Items & quantity",
        pi_tab_categories: "Categories",
        pi_tab_channels: "Channels & payments",
        pi_tab_staff: "Cashiers & terminals",
        pi_tab_data: "Data & coverage",
        pi_tab_cashier_check: "Cashier average check",
        pi_cc_title: "Cashier average check (counter orders)",
        pi_cc_desc: "Paid takeaway / dine-in orders keyed by the cashier; app, delivery, call-centre and damaged orders left out, and so is a sale returned or written off later",
        pi_cc_period: "Month",
        pi_cc_base: "Compared with",
        pi_cc_export: "Export Excel",
        pi_cc_exported: "File downloaded",
        pi_cc_export_failed: "Export failed",
        pi_cc_load_failed: "Could not load the cashier average check",
        pi_cc_cashier: "Cashier",
        pi_cc_counter_orders: "Counter orders",
        pi_cc_counter_avg: "Counter avg",
        pi_cc_change: "Change (SAR)",
        pi_cc_share: "Counter share of his orders",
        pi_cc_all_avg: "All-orders avg",
        pi_cc_small: "Small sample",
        pi_cc_small_hint: "Small sample = fewer than {n} counter orders in either month; do not rely on the change alone",
        pi_cc_branch_avg: "Branch counter avg",
        pi_cc_missing_days: "Days without order detail",
        pi_cc_backfill: "Order detail last updated",
        pi_cc_page_title: "Cashier average check",
        pi_cc_daily_title: "Daily files",
        pi_cc_daily_hint: "Saved every morning once the POS pull is complete: 1st of the month to yesterday vs last month, every branch",
        pi_cc_daily_none: "No file saved yet",
        pi_cc_daily_partial: "incomplete",
        pi_cc_daily_more: "Show all",
        pi_cc_daily_less: "Show fewer",
        pi_cc_daily_failed: "Could not download the file",
        perm_cap_group_cashier_check: "Cashier average check",
        pi_cc_backfill_none: "not finished yet, updates by itself",
        pi_cc_partial_days: "Days whose detail misses POS totals",
        pi_cc_open_reversals: "Reversals not matched to their sale yet",
        pi_cc_voided: "Reversed later",
        pi_cc_voided_hint: "This cashier's sales the POS later returned or wrote off (an RTRN row); they stay out of the average",
        pi_cc_no_data: "No orders for this branch in either month",
        pi_hourly_title: "Sales by hour",
        pi_hourly_desc: "Invoices and revenue per hour across the selected period",
        pi_heatmap_title: "Branch × hour heatmap",
        pi_heatmap_desc: "Sales intensity per branch across the trading day",
        pi_peak_hour: "Peak hour",
        pi_items_title: "Items sold",
        pi_items_desc: "Quantity and revenue per item (from the POS item report)",
        pi_items_search: "Search an item…",
        pi_sort_revenue: "Sort by revenue",
        pi_sort_qty: "Sort by quantity",
        pi_sort_name: "Sort by name",
        pi_col_item: "Item",
        pi_col_category: "Category",
        pi_col_qty: "Qty",
        pi_col_revenue: "Revenue",
        pi_col_avg_price: "Avg price",
        pi_col_days: "Days",
        pi_col_orders: "Orders",
        pi_col_total: "Total",
        pi_col_branch: "Branch",
        pi_col_hour: "Hour",
        pi_col_share: "Share",
        pi_menu_cats: "Menu categories",
        pi_recipe_cats: "Recipe categories",
        pi_apps_title: "Delivery apps",
        pi_apps_desc: "Orders, revenue and delivery fees per app",
        pi_col_delivery_fee: "Delivery fees",
        pi_col_paid: "Paid",
        pi_col_unpaid: "Unpaid",
        pi_order_types: "Order types",
        pi_payments: "Payment mix",
        pi_pay_states: "Payment state",
        pi_cashiers: "Cashiers",
        pi_terminals: "POS terminals",
        pi_delivery_men: "Delivery men",
        pi_shifts: "POS shifts",
        pi_coverage_title: "Data coverage",
        pi_coverage_days: "Days with data",
        pi_coverage_missing: "Missing days",
        pi_recon_title: "Number reconciliation",
        pi_recon_desc: "Invoice sums compared against the POS aggregate report",
        pi_recon_checked: "Days checked",
        pi_recon_mismatch: "Mismatches",
        pi_recon_ok: "Every figure matches to the riyal",
        pi_archived: "Days archived to Cloudflare",
        pi_masters_title: "POS master data",
        pi_masters_rows: "rows",
        pi_caps_title: "What the POS exposes",
        pi_caps_available: "Available and pulled",
        pi_caps_missing: "Not exposed by the POS API",
        pi_empty_title: "No deep data for this period",
        pi_empty_hint: "Run Sales Sync with the \"Deep\" scope to pull invoice and item detail for these days.",
        pi_no_branches: "No branches available for your account.",
        pi_avg_ticket_short: "Avg ticket",


        cc_tab_sales: "Sales",
        cc_tab_call_center: "Call Center",
        cc_title: "Call Center",
        cc_subtitle: "Call-center order performance for the selected range",
        cc_preset_7: "Last 7 days",
        cc_preset_30: "Last 30 days",
        cc_kpi_revenue: "Call-Center Revenue",
        cc_kpi_orders: "Orders",
        cc_kpi_aov: "Avg Order Value",
        cc_revenue_note: "Call-center orders are part of total sales, not additional.",
        cc_delivery_title: "Delivery-Fee Health",
        cc_delivery_sub: "This is the area that needs attention",
        cc_delivery_total: "Total delivery fees collected",
        cc_delivery_avg: "Avg delivery fee",
        cc_delivery_warn_pre: "Avg delivery fee is",
        cc_delivery_warn_post: "per order — review branches with low delivery recovery.",
        cc_unpaid_label: "Unpaid",
        cc_orders_word: "orders",
        cc_all_paid: "All orders paid",
        cc_by_branch_title: "By Branch",
        cc_top_agents_title: "Top Agents",
        cc_agents_title: "Agent performance",
        cc_no_agents: "No orders recorded for any agent in this period.",
        cc_col_avg_invoice: "Avg invoice",
        cc_col_aov: "Avg Order",
        cc_col_delivery: "Delivery",
        cc_col_agent: "Agent",
        cc_low_delivery: "Low delivery",
        cc_empty: "No call-center data in this range",
        cc_error: "Couldn't load the call-center summary",
    },
};

// Monthly stock count «الجرد الشهري»: its keys live next to the module, all
// prefixed `stk_` (`sc_` is the Sales Scorecard's), and are merged in here.
// The daily key-item count «الجرد اليومي» does the same with `dk_`.
for (const pack of [STK_COUNT, STK_ADMIN, DK_STRINGS, AI_STRINGS, MAINT_STRINGS]) {
    Object.assign(translations.ar, pack.ar);
    Object.assign(translations.en, pack.en);
}
